/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 44);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(51);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(80)();
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.firstYearOfDevelopment = 2018;
// export const ContentTransparent = require('./content-transparent.png')
exports.zollar = __webpack_require__(63);
exports.zero = __webpack_require__(64);
exports.zeroPng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGP6zwAAAgcBApocMXEAAAAASUVORK5CYII=';
// export const logo = require('./tour-logo-white.png')
// export const bezt = require('./Beztbetlogo.png')
// export const logo2 = require('./tour-logo-transp.png')
exports.cancel = 'fa fa-times';
exports.cancelCircle = 'fa fa-times-circle-o';
exports.productName = 'Accumulator Club';
exports.productOwner = 'Fair Play Gaming Ltd';
exports.productYear = '2018';
exports.productSource = 'Premier League';
exports.supportMail = 'support@accumulatorclub.com';
exports.contactMail = 'support@accumulatorclub.com';
exports.loaderImage = __webpack_require__(65);
exports.logoMain = __webpack_require__(66);
exports.poweredByGamanzaBlack = __webpack_require__(67);
exports.poweredByGamanzaWhite = __webpack_require__(68);
var location;
(function (location) {
    location[location["firstPage"] = 1] = "firstPage";
    location[location["contact"] = 2] = "contact";
    location[location["howtoplay"] = 3] = "howtoplay";
    location[location["terms"] = 4] = "terms";
    location[location["privacy"] = 5] = "privacy";
    location[location["lounge"] = 6] = "lounge";
    location[location["results"] = 7] = "results";
    location[location["betStep1"] = 8] = "betStep1";
    location[location["betStep2"] = 9] = "betStep2";
    location[location["betStep3"] = 10] = "betStep3";
    location[location["confirmation"] = 11] = "confirmation";
    location[location["login"] = 12] = "login";
    location[location["registration"] = 13] = "registration";
    location[location["leaderboards"] = 14] = "leaderboards";
    location[location["leagues"] = 15] = "leagues";
    location[location["myprofile"] = 16] = "myprofile";
})(location = exports.location || (exports.location = {}));
var CompetitionTypes;
(function (CompetitionTypes) {
    CompetitionTypes[CompetitionTypes["League"] = 1] = "League";
    CompetitionTypes[CompetitionTypes["HomeCups"] = 2] = "HomeCups";
    CompetitionTypes[CompetitionTypes["InternationalCups"] = 3] = "InternationalCups";
    CompetitionTypes[CompetitionTypes["International"] = 4] = "International";
})(CompetitionTypes = exports.CompetitionTypes || (exports.CompetitionTypes = {}));
exports.menuLeft = [
    { content: 'LOUNGE', selector: location.login },
    { content: 'HOW TO PLAY' },
    { content: 'LEAGUES', selector: location.login }
];
exports.homeMenuLeft = [
    { content: 'LOUNGE', selector: location.login },
    { content: 'HOW TO PLAY' }
];
exports.mobileMenuLeft = [
    { content: 'LOUNGE', selector: location.login },
    { content: 'HOW TO PLAY' },
    { content: 'LEAGUES', selector: location.login },
    { content: 'MY PROFILE', selector: location.myprofile },
    { content: 'LOGOUT', selector: location.login }
];
exports.mobileMenuLeftLogin = [
    { content: 'LOUNGE', selector: location.login },
    { content: 'HOW TO PLAY' },
    { content: 'LEAGUES', selector: location.login },
    { content: 'LOGIN', selector: 100 },
    { content: 'SIGN UP', selector: 100 }
];
exports.menuRight = [
    { content: 'LOGIN', selector: location.login },
    { content: 'SIGN UP', selector: location.registration },
];
exports.homeMenuRight = [
    { content: 'LEAGUES', selector: location.login },
    { content: 'LOGIN', selector: location.login },
    { content: 'SIGN UP', selector: location.registration },
];
exports.About = [
    { content: 'Contact', selector: location.contact },
    { content: 'How to Play', selector: location.howtoplay }
];
exports.Help = [
    { content: 'Terms and Conditions', selector: location.terms },
    { content: 'Privacy Policy', selector: location.privacy }
];
exports.NewFormat = { content: [
        'The Accumulator Club is an exciting new game format and a fresh take on football predictions. Predict the final score of any five of the weekly fixtures, place a 4-fold accumulator on any four fixtures to feature BTTS, Over/Under 2.5 goals or a draw, then pick out three anytime goalscorers and two card indexes.',
        'Wear out the edge of your seat as your predictions and selections earn points according to the real action!'
    ]
};
exports.PrivateLeagues = { content: [
        'It’s quick and easy to setup a private league and invite friends, colleagues or teammates, just like the Fantasy Premier League.',
        'You will automatically compete for the weekly and overall number 1 ranking, but nothing beats the enjoyment of the classic bants between your nearest and dearest, or punishing the local David Brent at the office.'
    ]
};
exports.OriginalContent = { content: [
        'We love football, we love talking about it, watching it, arguing about it and writing about it. Our news and blog page is frequently updated with team and player information, weekly previews, betting tips, fantasy football insight and other football related stuff.',
        'But it’s not all about our views and observations - We’re no experts and everyone has an opinion, so we encourage you to voice it!'
    ]
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cookies = __webpack_require__(75);

Object.defineProperty(exports, 'Cookies', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Cookies).default;
  }
});

var _CookiesProvider = __webpack_require__(79);

Object.defineProperty(exports, 'CookiesProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CookiesProvider).default;
  }
});

var _withCookies = __webpack_require__(83);

Object.defineProperty(exports, 'withCookies', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withCookies).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(84);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(86);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(37);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(88);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(91);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(94);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(96);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(38);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_11__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(107);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Socket_1 = __webpack_require__(72);
// const url = window.location.href
// const suffix = url.split('.')[url.split('.').length - 1]
// const host = (suffix === 'com') ? (`ws.${process.env.WS_HOST || 'accumulatorclub.com'}`) : (`ws.${process.env.WS_HOST || 'accumulatorclub.co.uk'}`)
var host = "" + (Object({"NODE_ENV":"production","PUBLIC_URL":""}).WS_HOST || 'fantasyprod.gamingenius.net');
var config = { host: host, wss: true };
var socketopts = config; /*{host, wss: true}*/
var Socket = new Socket_1.default(socketopts);
Socket.onOpen = function () { return console.log('open'); };
Socket.onError = function () { return console.log('Error!'); };
Socket.onClose = function () { return Socket.terminate(); };
exports.default = Socket;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Assets = __webpack_require__(3);
var Utils = __webpack_require__(9);
// import { Main } from '../../../Logic/Main'
// import { Logic } from '../../../Logic/Type'
var react_router_dom_1 = __webpack_require__(5);
var react_cookie_1 = __webpack_require__(4);
var socket_init_1 = __webpack_require__(6);
var react_helmet_1 = __webpack_require__(18);
function getMenu(className, menu) {
    var elements = [];
    for (var i = 0; i < menu.length; i++) {
        elements.push(React.createElement("li", { key: i.toString() }, (menu[i].content === 'LOGOUT') ?
            React.createElement(react_router_dom_1.Link, { to: "/login", className: "hide-logout", onClick: function () { return Utils.logout(); } }, menu[i].content)
            :
                (menu[i].content === 'MY PROFILE') ?
                    React.createElement(react_router_dom_1.Link, { to: "/myprofile", className: "hide-profile" }, menu[i].content)
                    :
                        (menu[i].selector === 100) ?
                            React.createElement(react_router_dom_1.Link, { to: menu[i].content.toLowerCase().replace(/\s/g, '') }, menu[i].content)
                            :
                                React.createElement(react_router_dom_1.Link, { to: menu[i].content.toLowerCase().replace(/\s/g, '') }, menu[i].content)));
    }
    return (React.createElement("ul", { className: 'nav navbar-nav ' + className }, elements));
}
exports.getMenu = getMenu;
function getCards(title, content, icon, svg) {
    return (React.createElement("div", { className: "col-xs-4 block-lvl3" },
        React.createElement("div", { className: "block-internal equal-height-col card-firstpage" },
            icon !== undefined ? React.createElement("i", { className: icon }) : void 0,
            svg !== undefined ? React.createElement("svg", { id: "agrmnt", className: "icon-agrmnt", viewBox: "0 0 487.4 487.4" },
                React.createElement("g", null,
                    React.createElement("path", { d: svg, fill: "#33AA00" }))) : void 0,
            React.createElement("div", { className: "h4" }, title),
            React.createElement("p", null, content))));
}
exports.getCards = getCards;
function getThreeColumns(title, content) {
    var columns = [];
    columns.push(React.createElement("label", { key: columns.length }, title));
    for (var _i = 0, content_1 = content; _i < content_1.length; _i++) {
        var item = content_1[_i];
        columns.push(React.createElement("p", { key: columns.length, className: "text-left" }, item));
    }
    return (React.createElement("li", null, columns));
}
exports.getThreeColumns = getThreeColumns;
var Body = /** @class */ (function (_super) {
    __extends(Body, _super);
    function Body(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        _this.cookies = new react_cookie_1.Cookies();
        _this.state = _this.getInitialState();
        socket_init_1.default.Send('rounds', { playerId: 1 });
        return _this;
    }
    Body.prototype.getInitialState = function () {
        return {
            email: '',
            username: '',
            password: '',
            passwordConfirmation: '',
            mobileMenu: false,
            checkbox: false,
            subscription: false,
            listen: true
        };
    };
    Body.prototype.handleInput = function (value, state) {
        socket_init_1.default.Set('registration', {});
        this.state[state] = value;
        this.setState(this.state);
    };
    Body.prototype.sendUser = function () {
        if (this.state.username === '') {
            alert('Write your Username.');
        }
        else if (this.state.password === '') {
            alert('Write your Password.');
        }
        else if (this.state.email === '') {
            alert('Write your Email.');
        }
        else if (!this.state.checkbox) {
            alert('You have to agree to the Accumulator Club Terms of Service.');
        }
        else {
            if (this.state.password === this.state.passwordConfirmation) {
                var user = {
                    firstName: '',
                    lastName: '',
                    email: this.state.email,
                    username: this.state.username,
                    password: this.state.password,
                    nationality: '',
                    subscription: this.state.subscription
                };
                socket_init_1.default.Send('registration', user);
            }
            else {
                alert('Passwords do not match.');
            }
        }
    };
    Body.prototype.componentWillUnmount = function () {
        clearInterval(this.intervalID);
    };
    Body.prototype.componentWillReceiveProps = function () {
        var rounds = socket_init_1.default.Get('rounds');
        var currentDate = new Date().getTime();
        if (this.state.listen && rounds.loading === 'loaded') {
            var allRounds = rounds.rounds;
            var filteredRounds = allRounds.filter(function (elt) { return new Date(elt.deadline).getTime() > currentDate; });
            if (filteredRounds.length > 0) {
                var firstDeadline = new Date(filteredRounds[0].deadline);
                var firstDeadlineMonth = firstDeadline.getMonth() + 1;
                var firstDeadlineDay = firstDeadline.getDate();
                var firstDeadlineYear = firstDeadline.getFullYear();
                var firstDeadlineHours = firstDeadline.getHours();
                var firstDeadlineMinutes = firstDeadline.getMinutes();
                var dateString = firstDeadlineMonth + '/' + firstDeadlineDay + '/' + firstDeadlineYear + ' ' +
                    firstDeadlineHours + ':' + firstDeadlineMinutes + ':00 ' + ' UTC';
                var dateDeadline_1 = new Date(dateString).getTime();
                this.intervalID = setInterval(function () {
                    var dateNow = new Date().getTime();
                    var distance = dateDeadline_1 - dateNow;
                    if (distance > 0) {
                        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
                        document.getElementById('day').innerHTML = (days < 10) ? '<span>' + '0' + days.toString() + '</span>' : '<span>' + days.toString() + '</span>';
                        document.getElementById('hour').innerHTML = (hours < 10) ? '<span>' + '0' + hours.toString() + '</span>' : '<span>' + hours.toString() + '</span>';
                        document.getElementById('month').innerHTML = (minutes < 10) ? '<span>' + '0' + minutes.toString() + '</span>' : '<span>' + minutes.toString() + '</span>';
                        document.getElementById('second').innerHTML = (seconds < 10) ? '<span>' + '0' + seconds.toString() + '</span>' : '<span>' + seconds.toString() + '</span>';
                    }
                    else {
                        document.getElementById('day').innerHTML = '<span>00</span>';
                        document.getElementById('hour').innerHTML = '<span>00</span>';
                        document.getElementById('month').innerHTML = '<span>00</span>';
                        document.getElementById('second').innerHTML = '<span>00</span>';
                    }
                }, 1000);
                this.setState({ listen: false });
            }
            else {
                this.intervalID = setInterval(function () {
                    document.getElementById('day').innerHTML = '<span>00</span>';
                    document.getElementById('hour').innerHTML = '<span>00</span>';
                    document.getElementById('month').innerHTML = '<span>00</span>';
                    document.getElementById('second').innerHTML = '<span>00</span>';
                }, 1000);
                this.setState({ listen: false });
            }
        }
    };
    Body.prototype.render = function () {
        var _this = this;
        var registration = socket_init_1.default.Get('registration');
        if (registration.registration) {
            if (registration.registration.message === 'Username already exists.')
                alert('Username already exists.');
            if (registration.registration.message === 'Email already exists.')
                alert('Email already exists.');
            if (registration.registration.message === 'Both already exist.')
                alert('Username and email already exist.');
        }
        return (React.createElement("div", { className: "new-homepage mean-container" },
            React.createElement(react_helmet_1.Helmet, null,
                React.createElement("meta", { charSet: "utf-8" }),
                React.createElement("title", null, "The Accumulator Club \u2013 Premier League predictions \u2013 Join the club"),
                React.createElement("meta", { name: "description", content: "The Accumulator Club is the ultimate punting championship, where users make a series\n                        of football predictions across a number of different betting markets. Compete in private leagues and\n                        overall rankings in this free to play football game with a cash prize up for grabs every gameweek \u2013\n                        Join the club!" })),
            React.createElement("div", { className: "mean-bar" },
                (!this.state.mobileMenu) ? React.createElement("a", { style: { marginLeft: '15px', color: '#FFF', fontSize: '17px' } }, this.cookies.get('username')) : null,
                React.createElement("a", { className: (this.state.mobileMenu) ? 'meanmenu-reveal meanclose' : 'meanmenu-reveal', style: (this.state.mobileMenu) ? { right: '0', left: 'auto', textAlign: 'center', textIndent: '0', fontSize: '18px' } : { right: '0', left: 'auto' }, onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); } }, (this.state.mobileMenu) ?
                    'X'
                    :
                        React.createElement("div", null,
                            React.createElement("span", null),
                            React.createElement("span", null),
                            React.createElement("span", null))),
                React.createElement("nav", { className: "mean-nav" },
                    React.createElement("ul", { style: (this.state.mobileMenu) ? { display: 'block' } : { display: 'none' } },
                        React.createElement("li", { className: "montserrat-medium" },
                            React.createElement(react_router_dom_1.Link, { to: "/lounge" }, "Lounge")),
                        React.createElement("li", { className: "montserrat-medium" },
                            React.createElement(react_router_dom_1.Link, { to: "/howtoplay" }, "HOW TO PLAY")),
                        React.createElement("li", { className: "montserrat-medium" },
                            React.createElement(react_router_dom_1.Link, { to: "/leagues" }, "LEAGUES")),
                        (!this.cookies.get('username')) ?
                            React.createElement("div", null,
                                React.createElement("li", { className: "montserrat-medium" },
                                    React.createElement(react_router_dom_1.Link, { to: "/login" }, "LOGIN")),
                                React.createElement("li", { className: "mean-last montserrat-medium" },
                                    React.createElement(react_router_dom_1.Link, { to: "/signup" }, "SIGN UP")))
                            : null))),
            React.createElement("div", { className: "header-area sticky-nav" },
                React.createElement("div", { className: "container container-homepage" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-6" },
                            React.createElement("div", { className: "main-menu" },
                                React.createElement("ul", null,
                                    React.createElement("li", { style: { cursor: 'pointer' } },
                                        " ",
                                        React.createElement(react_router_dom_1.Link, { to: "/lounge", className: "montserrat-semi-bold" }, "Lounge"),
                                        " "),
                                    React.createElement("li", { style: { cursor: 'pointer' } },
                                        " ",
                                        React.createElement(react_router_dom_1.Link, { to: "/howtoplay", className: "montserrat-semi-bold" }, "HOW TO PLAY"),
                                        " "),
                                    React.createElement("li", { style: { cursor: 'pointer' } },
                                        " ",
                                        React.createElement(react_router_dom_1.Link, { to: "/leagues", className: "montserrat-semi-bold" }, "LEAGUES"),
                                        " ")))),
                        React.createElement("div", { className: "col-md-3 col-xs-12" },
                            React.createElement("div", { className: "site-logo" },
                                React.createElement("img", { src: "logo-main2.png", alt: "The Accumulator Club presents\u2026" }))),
                        (!this.cookies.get('username')) ?
                            React.createElement("div", { className: "col-md-3" },
                                React.createElement("div", { className: "user-login" },
                                    React.createElement("ul", null,
                                        React.createElement("li", { className: "montserrat-semi-bold" },
                                            " ",
                                            React.createElement(react_router_dom_1.Link, { to: "/login" }, "LOGIN"),
                                            " "),
                                        React.createElement("li", { className: "montserrat-semi-bold" },
                                            " ",
                                            React.createElement(react_router_dom_1.Link, { to: "/signup" }, "SIGN UP"),
                                            " "))))
                            :
                                React.createElement("div", { className: "col-md-3" },
                                    React.createElement("div", { className: "user-login" },
                                        React.createElement("ul", null,
                                            React.createElement("li", { className: "montserrat-semi-bold homepage-username" },
                                                React.createElement("a", null, this.cookies.get('username'))))))))),
            React.createElement("div", { className: "hero-area" },
                React.createElement("div", { className: "container container-homepage" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-8 col-sm-12" },
                            React.createElement("div", { className: "hero-inner" },
                                React.createElement("h2", { className: "montserrat-extra-bold" }, "The Accumulator Club presents\u2026"),
                                React.createElement("div", { className: "row" },
                                    (+screen.width < 500) ? React.createElement("div", { className: "clearfix" }) : null,
                                    React.createElement("div", { className: "col-md-8 col-sm-8 alternative-div" },
                                        React.createElement("div", { className: "hero-big-text" },
                                            React.createElement("h1", null,
                                                React.createElement("span", null, "the ultimate"),
                                                " Free to Play ",
                                                React.createElement("br", null),
                                                " predictor! "),
                                            React.createElement("h3", { className: "montserrat-extra-bold" }, "#WHATSYOURSTRATEGY?")))))),
                        !(this.cookies.get('username')) ?
                            React.createElement("div", { className: "col-md-4 col-sm-8 col-md-4-homepage" },
                                React.createElement("div", { className: "form-box" },
                                    React.createElement("div", { className: "form-box-inner" },
                                        React.createElement("h1", { className: "montserrat-extra-bold" }, "Sign up now!"),
                                        React.createElement("form", { className: "form-main", action: "contact.php", method: "post" },
                                            React.createElement("input", { type: "text", autoCapitalize: "none", name: "name", placeholder: "Username", value: this.state.username, onChange: function (event) { return _this.handleInput(event.target.value, 'username'); }, className: "montserrat-medium" }),
                                            React.createElement("input", { type: "password", autoCapitalize: "none", name: "name", placeholder: "Password", value: this.state.password, onChange: function (event) { return _this.handleInput(event.target.value, 'password'); }, className: "montserrat-medium" }),
                                            React.createElement("input", { type: "password", autoCapitalize: "none", name: "name", placeholder: "Confirm password", value: this.state.passwordConfirmation, onChange: function (event) { return _this.handleInput(event.target.value, 'passwordConfirmation'); }, className: "montserrat-medium" }),
                                            React.createElement("input", { type: "email", autoCapitalize: "none", name: "name", placeholder: "Email", value: this.state.email, onChange: function (event) { return _this.handleInput(event.target.value, 'email'); }, className: "montserrat-medium" }),
                                            React.createElement("div", { className: "form-group", style: { marginTop: '10px', color: '#FFF' } },
                                                React.createElement("label", { className: "checkbox-wrapper" },
                                                    React.createElement("input", { type: "checkbox", checked: this.state.checkbox, onClick: function () { return _this.setState({ checkbox: !_this.state.checkbox }); } }),
                                                    React.createElement("span", { className: "checkbox-span" }),
                                                    "I Agree to the Accumulator Club",
                                                    React.createElement(react_router_dom_1.Link, { to: "/termsandconditions", className: "btn-link" }, " Terms of Service "),
                                                    "and",
                                                    React.createElement(react_router_dom_1.Link, { to: "/privacypolicy", className: "btn-link" }, " Privacy Policy. "),
                                                    "I also confirm that I am at least 18 years of age."),
                                                React.createElement("span", { className: "error-block" },
                                                    React.createElement("span", null, "Error message"))),
                                            React.createElement("div", { className: "form-group", style: { marginTop: '10px', color: '#FFF' } },
                                                React.createElement("label", { className: "checkbox-wrapper" },
                                                    React.createElement("input", { type: "checkbox", checked: this.state.subscription, onClick: function () { return _this.setState({ subscription: !_this.state.subscription }); } }),
                                                    React.createElement("span", { className: "checkbox-span" }),
                                                    "I would like to receive game updates, reminders and tips from The Accumulator Club (once a week).")),
                                            React.createElement("div", { className: "text-right" },
                                                React.createElement("button", { type: "button", name: "button", className: "sub-btn", onClick: function () { return _this.sendUser(); } },
                                                    React.createElement("img", { src: "sub-btn.png", alt: "" })))))))
                            : null)),
                React.createElement("div", { className: "hero-bottom" },
                    React.createElement("div", { className: "container container-homepage" },
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-md-4 col-sm-4 col-md-4-homepage no-float" },
                                React.createElement("h1", { className: "montserrat-extra-bold" }, "DEADLINE"),
                                React.createElement("h3", { className: "montserrat-extra-bold" }, "FOR NEXT GAMEWEEK:")),
                            React.createElement("div", { className: "col-md-5 col-sm-6" },
                                React.createElement("div", { className: "coundown_res row" },
                                    React.createElement("div", { className: "count" },
                                        React.createElement("div", { className: "col-md-3 col-xs-3 col-sm-3" },
                                            React.createElement("h2", { id: "day" }, "-"))),
                                    React.createElement("div", { className: "count" },
                                        React.createElement("div", { className: "col-md-3 col-xs-3 col-sm-3" },
                                            React.createElement("h2", { id: "hour" }, "-"))),
                                    React.createElement("div", { className: "count" },
                                        React.createElement("div", { className: "col-md-3 col-xs-3 col-sm-3" },
                                            React.createElement("h2", { id: "month" }, "-"))),
                                    React.createElement("div", { className: "count" },
                                        React.createElement("div", { className: "col-md-3 col-xs-3 col-sm-3" },
                                            React.createElement("h2", { id: "second" }, "-"))))),
                            React.createElement("div", { className: "col-md-3 col-sm-2" },
                                React.createElement("button", { type: "button", name: "button", className: "play-btn montserrat-extra-bold" },
                                    React.createElement(react_router_dom_1.Link, { to: "/lounge", style: { color: '#FFF' } }, "PLAY NOW!"))))))),
            React.createElement("div", { className: "big-lenght-area" },
                React.createElement("div", { className: "container container-homepage" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-12" },
                            React.createElement("div", { className: "big-title" },
                                React.createElement("h1", null,
                                    React.createElement("span", null, "THE ULTIMATE PUNTING"),
                                    " CHAMPIONSHIP")))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-4 col-md-4-homepage" },
                            React.createElement("div", { className: "big-area-text" },
                                React.createElement("p", { className: "montserrat-medium" }, "Our Triple Threat game format combines multiple betting markets and punting disciplines."),
                                React.createElement("p", { className: "montserrat-medium" }, "Every round, users make 9 predictions across 3 betting criteria\u2026"))),
                        React.createElement("div", { className: "col-md-8" },
                            React.createElement("div", { className: "big-area-img" },
                                React.createElement("img", { src: "mobile-text.png", alt: "mobile-text" })))),
                    React.createElement("div", { className: "row pad_100" },
                        React.createElement("div", { className: "col-md-6" },
                            React.createElement("div", { className: "big-area-text" },
                                React.createElement("h1", null, "#WHATSYOURSTRATEGY?"),
                                React.createElement("h2", { className: "montserrat-extra-bold" }, "Our unique points system is "),
                                React.createElement("h2", { className: "montserrat-extra-bold" },
                                    " ",
                                    React.createElement("strong", null, "based on sportsbook odds"),
                                    " "),
                                React.createElement("h3", { className: "montserrat-extra-bold" }, "In each discipline, points for your correct selections are multiplied, just like an accumulator!"),
                                React.createElement("h2", { className: "montserrat-extra-bold" },
                                    " ",
                                    React.createElement("strong", { className: "up_text" }, "So how will you play?"),
                                    " "),
                                React.createElement("h3", { className: "montserrat-extra-bold" }, "Safe and consistent, or will you throw in a couple of punts and aim for the big time!?"))),
                        React.createElement("div", { className: "col-md-6" },
                            React.createElement("div", { className: "big-area-img" },
                                React.createElement("img", { src: "chart.png", alt: "chart" })))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-12" },
                            React.createElement("div", { className: "big-title" },
                                React.createElement("h1", null,
                                    React.createElement("span", null, "POINTS"),
                                    " MEAN PRIZES")))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-4-homepage col-sm-3" },
                            React.createElement("div", { className: "single_ser" },
                                React.createElement("img", { src: "img-1.png", alt: "img-1" }),
                                React.createElement("p", { className: "montserrat-medium" }, "Create private leagues and compete with friends and colleagues to be the top punter"))),
                        React.createElement("div", { className: "col-md-4-homepage col-sm-3" },
                            React.createElement("div", { className: "single_ser" },
                                React.createElement("img", { src: "img-3.png", alt: "img-1" }),
                                React.createElement("p", { className: "montserrat-medium" }, "Track their progress and share your highlights"))),
                        React.createElement("div", { className: "col-md-4-homepage col-sm-3" },
                            React.createElement("div", { className: "single_ser" },
                                React.createElement("img", { src: "img-2.png", alt: "img-1" }),
                                React.createElement("p", { className: "montserrat-medium" }, "The overall winner of every round will win a cash prize")))))),
            React.createElement("div", { className: "big-two" },
                React.createElement("div", { className: "container container-homepage" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-12" },
                            React.createElement("div", { className: "big-title" },
                                React.createElement("h1", null,
                                    React.createElement("span", null, "INTEGRATED"),
                                    "  STATS")))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-3" },
                            React.createElement("div", { className: "big-area-text" },
                                React.createElement("p", { className: "montserrat-medium" }, "During the selection process you can check team form, recent results and key stats"),
                                React.createElement("p", { className: "montserrat-medium" }, "When picking anytime gaolscorers you can also access the statistics you need to make those vital decisions"),
                                React.createElement("p", { className: "montserrat-medium" }, "Now you\u00B4re armed with the stats, you could even back your instinct with a flutter at the bookies!"))),
                        React.createElement("div", { className: "col-md-6" },
                            React.createElement("div", { className: "big-area-img mat_top" },
                                React.createElement("img", { src: "gold-scor.png", alt: "chart" }))),
                        React.createElement("div", { className: "col-md-3" },
                            React.createElement("div", { className: "big-area-img mat_top_2" },
                                React.createElement("img", { src: "scror-2.png", alt: "chart" })))))),
            React.createElement("div", { className: "footer" },
                React.createElement("div", { className: "container container-homepage" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-12" },
                            React.createElement("div", { className: "footer_inner" },
                                React.createElement("img", { src: "logo-footer.png", alt: "" }),
                                React.createElement("div", { className: "big-title" },
                                    React.createElement("h1", null,
                                        React.createElement("span", null, "join the social betting "),
                                        "  revolution!")),
                                React.createElement("button", { type: "button", name: "button", className: "play-btn montserrat-extra-bold" },
                                    React.createElement(react_router_dom_1.Link, { to: "/lounge", style: { color: '#FFF' } }, "PLAY NOW!")),
                                React.createElement("h3", { className: "montserrat-extra-bold" }, "Keep in touch with us!"),
                                React.createElement("ul", null,
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "https://www.facebook.com/accumulatorclub/", target: "_blank" },
                                            React.createElement("img", { src: "facebook.png", alt: "" }))),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: "https://twitter.com/theaccaclub", target: "_blank" },
                                            React.createElement("img", { src: "twitter.png", alt: "" })))),
                                React.createElement("p", { className: "montserrat-medium" }, "All games offered on The Accumulator Club are free to play, with cash prizes. The Accumulator Club does not offer gambling facilities, although we may link to third party sites that do. Use of any third party website is at your own risk and we will not be liable for any losses or damages. For more information, please consult our terms of service and privacy policy."),
                                React.createElement("p", null,
                                    "\u00A9",
                                    ' ' + Assets.productYear + ' ' + Assets.productOwner + '. All Rights Reserved.'),
                                React.createElement("div", { className: "powered-by-gamanza", style: { justifyContent: 'center' } },
                                    React.createElement("img", { src: Assets.poweredByGamanzaBlack }))))))),
            (registration.registration && registration.registration.message === 'Registration successful.') ? this.showPopup() : null));
    };
    Body.prototype.showPopup = function () {
        var _this = this;
        var screenPosition = document.documentElement.scrollTop + 150;
        var top = screenPosition.toString() + 'px';
        return (React.createElement("div", { className: "popup" },
            React.createElement("div", { className: "popup-inner popup-forgot", style: { top: top } },
                React.createElement("div", { style: { textAlign: 'right', marginBottom: '10px' } },
                    React.createElement("img", { onClick: function () { socket_init_1.default.Set('registration', {}), _this.setState(_this.getInitialState()); }, style: { cursor: 'pointer' }, src: "cancel-black.png" })),
                React.createElement("div", { className: "fist-bump" },
                    React.createElement("img", { src: "fist-bump.svg" })),
                React.createElement("p", { className: "congratulations-first" }, "Well played!"),
                React.createElement("p", { className: "congratulations-second" }, "Your sign up has been received..."),
                React.createElement("p", { className: "congratulations-third" }, "Please check your email inbox (and perhaps your spam) - We have sent you an email with a link to verify your email address."))));
    };
    return Body;
}(React.Component));
exports.default = react_cookie_1.withCookies(Body);


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Main_1 = __webpack_require__(13);
var Type_1 = __webpack_require__(11);
var socket_init_1 = __webpack_require__(6);
var react_cookie_1 = __webpack_require__(4);
// import * as Bet from '../Views/Main/Index/Bet'
// import * as Results from '../Views/Main/Index/Results'
function getFlag(countryName) {
    var flags = Object.assign(socket_init_1.default.Get('flags'));
    for (var _i = 0, _a = flags.flags; _i < _a.length; _i++) {
        var flag = _a[_i];
        // if (country.name.indexOf('England') !== -1) console.log (country.name)
        if (flag.name === countryName
            || (countryName === 'Iran' && flag.name === 'Iran, Islamic Republic Of')
            || (countryName === 'Serbia' && flag.name === 'Republic of Serbia')
            || (countryName === 'Korea Republic' && flag.name === 'South Korea'))
            return flag.image40;
    }
}
exports.getFlag = getFlag;
function capitalizeFirstLetter(word) {
    var x = word.toLowerCase();
    return x.charAt(0).toUpperCase() + x.slice(1);
}
exports.capitalizeFirstLetter = capitalizeFirstLetter;
function logout() {
    var cookies = new react_cookie_1.Cookies();
    cookies.remove('playerId');
    cookies.remove('username');
    cookies.remove('nationality');
    cookies.remove('competitionTab');
    localStorage.clear();
    socket_init_1.default.Set('login', {});
}
exports.logout = logout;
function setCorrectScoresResult(item, matchId, homeTeam, awayTeam, match) {
    if (item) {
        var cookies = new react_cookie_1.Cookies();
        var found = false;
        if (Main_1.Main.Instance.Fantasy.chosenResults) {
            var results = Main_1.Main.Instance.Fantasy.chosenResults.correctScores;
            for (var i = 0; i < results.length; i++) {
                if (results[i].matchId === matchId) {
                    found = true;
                    if (results[i].correctScore.name === item.name) {
                        results.splice(i, 1);
                        Main_1.Main.Instance.Fantasy.selectedResult[match] = '---';
                        Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedResult: Main_1.Main.Instance.Fantasy.selectedResult });
                        localStorage.setItem('selectedResult', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedResult));
                    }
                    else {
                        results[i].correctScore = item;
                    }
                    for (var j = 0; j < Main_1.Main.Instance.Fantasy.chosenResults.correctScores.length; j++) {
                        if (Main_1.Main.Instance.Fantasy.chosenResults.correctScores[j].matchId === matchId) {
                            Main_1.Main.Instance.Fantasy.chosenResults.correctScores[j] = {
                                matchId: matchId,
                                homeTeam: homeTeam,
                                awayTeam: awayTeam,
                                correctScore: item
                            };
                        }
                    }
                    Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: Main_1.Main.Instance.Fantasy.chosenResults });
                    localStorage.setItem('chosenResults', JSON.stringify(Main_1.Main.Instance.Fantasy.chosenResults));
                    break;
                }
            }
        }
        if (found === false) {
            var chosenResults = void 0;
            if (Main_1.Main.Instance.Fantasy.chosenResults) {
                chosenResults = Main_1.Main.Instance.Fantasy.chosenResults;
            }
            else {
                chosenResults = {
                    playerId: +cookies.get('playerId'),
                    round: +localStorage.getItem('roundId'),
                    correctScores: []
                };
            }
            if (Main_1.Main.Instance.Fantasy.chosenResults && Main_1.Main.Instance.Fantasy.chosenResults.correctScores.length > 2) {
                var selectedResult = Main_1.Main.Instance.Fantasy.selectedResult;
                selectedResult[match] = '---';
                Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedResult: selectedResult });
                localStorage.setItem('selectedResult', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedResult));
                alert('You have already selected 3 matches.');
            }
            else {
                chosenResults.correctScores.push({
                    matchId: matchId,
                    homeTeam: homeTeam,
                    awayTeam: awayTeam,
                    correctScore: {
                        name: item.name,
                        odds: +item.odds,
                        odds1X2: item.odds1X2,
                        bonus: item.bonus,
                        outCome: item.outCome
                    }
                });
            }
            Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: chosenResults });
            localStorage.setItem('chosenResults', JSON.stringify(Main_1.Main.Instance.Fantasy.chosenResults));
        }
    }
    // console.log(Main.Instance.Fantasy.chosenResults)
}
exports.setCorrectScoresResult = setCorrectScoresResult;
function setAccumulatorBtts(item, matchId, match, type, homeTeam, awayTeam) {
    var selectedAcc = Main_1.Main.Instance.Fantasy.selectedAcc;
    var found = false;
    if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator) {
        var results = Main_1.Main.Instance.Fantasy.chosenResults.accumulator;
        for (var i = 0; i < results.length; i++) {
            if (results[i].matchId === matchId) {
                found = true;
                if (results[i].type === 'BTTS' && results[i].correctScore.name === item.name) {
                    results.splice(i, 1);
                    Main_1.Main.Instance.Fantasy.selectedAcc[match] = 0;
                    Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: selectedAcc });
                    localStorage.setItem('selectedAcc', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedAcc));
                }
                else {
                    results[i].correctScore = item;
                    Main_1.Main.Instance.Fantasy.selectedAcc[match] = type;
                    Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: selectedAcc });
                    localStorage.setItem('selectedAcc', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedAcc));
                }
                for (var j = 0; j < Main_1.Main.Instance.Fantasy.chosenResults.accumulator.length; j++) {
                    if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator[j].matchId === matchId) {
                        Main_1.Main.Instance.Fantasy.chosenResults.accumulator[j] = {
                            matchId: matchId,
                            homeTeam: homeTeam,
                            awayTeam: awayTeam,
                            type: 'BTTS',
                            correctScore: item
                        };
                    }
                }
                Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: Main_1.Main.Instance.Fantasy.chosenResults });
                localStorage.setItem('chosenResults', JSON.stringify(Main_1.Main.Instance.Fantasy.chosenResults));
                break;
            }
        }
    }
    if (found === false) {
        var chosenResults = Main_1.Main.Instance.Fantasy.chosenResults;
        if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator) {
            chosenResults.accumulator = Main_1.Main.Instance.Fantasy.chosenResults.accumulator;
        }
        else {
            chosenResults.accumulator = [];
        }
        if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator && Main_1.Main.Instance.Fantasy.chosenResults.accumulator.length > 2) {
            alert('You have already selected 3 matches.');
        }
        else {
            chosenResults.accumulator.push({
                matchId: matchId,
                homeTeam: homeTeam,
                awayTeam: awayTeam,
                type: 'BTTS',
                correctScore: { odds: +item.odds, outCome: item.outCome, name: item.name },
            });
            Main_1.Main.Instance.Fantasy.selectedAcc[match] = type;
            Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: selectedAcc });
            localStorage.setItem('selectedAcc', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedAcc));
        }
        Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: chosenResults });
        localStorage.setItem('chosenResults', JSON.stringify(Main_1.Main.Instance.Fantasy.chosenResults));
    }
    // console.log(Main.Instance.Fantasy.chosenResults)
}
exports.setAccumulatorBtts = setAccumulatorBtts;
function setAccumulatorOver(item, matchId, match, type, homeTeam, awayTeam) {
    var selectedAcc = Main_1.Main.Instance.Fantasy.selectedAcc;
    var found = false;
    if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator) {
        var results = Main_1.Main.Instance.Fantasy.chosenResults.accumulator;
        for (var i = 0; i < results.length; i++) {
            if (results[i].matchId === matchId) {
                found = true;
                if (results[i].type === 'Over' && results[i].correctScore.name === item.name) {
                    results.splice(i, 1);
                    Main_1.Main.Instance.Fantasy.selectedAcc[match] = 0;
                    Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: selectedAcc });
                    localStorage.setItem('selectedAcc', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedAcc));
                }
                else {
                    results[i].correctScore = item;
                    Main_1.Main.Instance.Fantasy.selectedAcc[match] = type;
                    Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: selectedAcc });
                    localStorage.setItem('selectedAcc', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedAcc));
                }
                for (var j = 0; j < Main_1.Main.Instance.Fantasy.chosenResults.accumulator.length; j++) {
                    if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator[j].matchId === matchId) {
                        Main_1.Main.Instance.Fantasy.chosenResults.accumulator[j] = {
                            matchId: matchId,
                            homeTeam: homeTeam,
                            awayTeam: awayTeam,
                            type: 'Over',
                            correctScore: item
                        };
                    }
                }
                Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: Main_1.Main.Instance.Fantasy.chosenResults });
                localStorage.setItem('chosenResults', JSON.stringify(Main_1.Main.Instance.Fantasy.chosenResults));
                break;
            }
        }
    }
    if (found === false) {
        var chosenResults = Main_1.Main.Instance.Fantasy.chosenResults;
        if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator) {
            chosenResults.accumulator = Main_1.Main.Instance.Fantasy.chosenResults.accumulator;
        }
        else {
            chosenResults.accumulator = [];
        }
        if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator && Main_1.Main.Instance.Fantasy.chosenResults.accumulator.length > 2) {
            alert('You have already selected 3 matches.');
        }
        else {
            chosenResults.accumulator.push({
                matchId: matchId,
                homeTeam: homeTeam,
                awayTeam: awayTeam,
                type: 'Over',
                correctScore: { odds: +item.odds, outCome: item.outCome, name: item.name, specialBetValue: item.specialBetValue },
            });
            Main_1.Main.Instance.Fantasy.selectedAcc[match] = type;
            Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: selectedAcc });
            localStorage.setItem('selectedAcc', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedAcc));
        }
        Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: chosenResults });
        localStorage.setItem('chosenResults', JSON.stringify(Main_1.Main.Instance.Fantasy.chosenResults));
    }
    // console.log(Main.Instance.Fantasy.chosenResults)
}
exports.setAccumulatorOver = setAccumulatorOver;
function setAccumulatorUnder(item, matchId, match, type, homeTeam, awayTeam) {
    var selectedAcc = Main_1.Main.Instance.Fantasy.selectedAcc;
    var found = false;
    if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator) {
        var results = Main_1.Main.Instance.Fantasy.chosenResults.accumulator;
        for (var i = 0; i < results.length; i++) {
            if (results[i].matchId === matchId) {
                found = true;
                if (results[i].type === 'Under' && results[i].correctScore.name === item.name) {
                    results.splice(i, 1);
                    Main_1.Main.Instance.Fantasy.selectedAcc[match] = 0;
                    Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: selectedAcc });
                    localStorage.setItem('selectedAcc', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedAcc));
                }
                else {
                    results[i].correctScore = item;
                    Main_1.Main.Instance.Fantasy.selectedAcc[match] = type;
                    Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: selectedAcc });
                    localStorage.setItem('selectedAcc', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedAcc));
                }
                for (var j = 0; j < Main_1.Main.Instance.Fantasy.chosenResults.accumulator.length; j++) {
                    if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator[j].matchId === matchId) {
                        Main_1.Main.Instance.Fantasy.chosenResults.accumulator[j] = {
                            matchId: matchId,
                            homeTeam: homeTeam,
                            awayTeam: awayTeam,
                            type: 'Under',
                            correctScore: item
                        };
                    }
                }
                Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: Main_1.Main.Instance.Fantasy.chosenResults });
                localStorage.setItem('chosenResults', JSON.stringify(Main_1.Main.Instance.Fantasy.chosenResults));
                break;
            }
        }
    }
    if (found === false) {
        var chosenResults = Main_1.Main.Instance.Fantasy.chosenResults;
        if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator) {
            chosenResults.accumulator = Main_1.Main.Instance.Fantasy.chosenResults.accumulator;
        }
        else {
            chosenResults.accumulator = [];
        }
        if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator && Main_1.Main.Instance.Fantasy.chosenResults.accumulator.length > 2) {
            alert('You have already selected 3 matches.');
        }
        else {
            chosenResults.accumulator.push({
                matchId: matchId,
                homeTeam: homeTeam,
                awayTeam: awayTeam,
                type: 'Under',
                correctScore: { odds: +item.odds, outCome: item.outCome, name: item.name, specialBetValue: item.specialBetValue },
            });
            Main_1.Main.Instance.Fantasy.selectedAcc[match] = type;
            Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: selectedAcc });
            localStorage.setItem('selectedAcc', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedAcc));
        }
        Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: chosenResults });
        localStorage.setItem('chosenResults', JSON.stringify(Main_1.Main.Instance.Fantasy.chosenResults));
    }
    // console.log(Main.Instance.Fantasy.chosenResults)
}
exports.setAccumulatorUnder = setAccumulatorUnder;
function setAccumulatorDraw(item, matchId, match, type, homeTeam, awayTeam) {
    var selectedAcc = Main_1.Main.Instance.Fantasy.selectedAcc;
    var found = false;
    if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator) {
        var results = Main_1.Main.Instance.Fantasy.chosenResults.accumulator;
        for (var i = 0; i < results.length; i++) {
            if (results[i].matchId === matchId) {
                found = true;
                if (results[i].type === 'Draw' && results[i].correctScore.name === item.name) {
                    results.splice(i, 1);
                    Main_1.Main.Instance.Fantasy.selectedAcc[match] = 0;
                    Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: selectedAcc });
                    localStorage.setItem('selectedAcc', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedAcc));
                }
                else {
                    results[i].correctScore = item;
                    Main_1.Main.Instance.Fantasy.selectedAcc[match] = type;
                    Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: selectedAcc });
                    localStorage.setItem('selectedAcc', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedAcc));
                }
                for (var j = 0; j < Main_1.Main.Instance.Fantasy.chosenResults.accumulator.length; j++) {
                    if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator[j].matchId === matchId) {
                        Main_1.Main.Instance.Fantasy.chosenResults.accumulator[j] = {
                            matchId: matchId,
                            homeTeam: homeTeam,
                            awayTeam: awayTeam,
                            type: 'Draw',
                            correctScore: item
                        };
                    }
                }
                Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: Main_1.Main.Instance.Fantasy.chosenResults });
                localStorage.setItem('chosenResults', JSON.stringify(Main_1.Main.Instance.Fantasy.chosenResults));
                break;
            }
        }
    }
    if (found === false) {
        var chosenResults = Main_1.Main.Instance.Fantasy.chosenResults;
        if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator) {
            chosenResults.accumulator = Main_1.Main.Instance.Fantasy.chosenResults.accumulator;
        }
        else {
            chosenResults.accumulator = [];
        }
        if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator && Main_1.Main.Instance.Fantasy.chosenResults.accumulator.length > 2) {
            alert('You have already selected 3 matches.');
        }
        else {
            chosenResults.accumulator.push({
                matchId: matchId,
                homeTeam: homeTeam,
                awayTeam: awayTeam,
                type: 'Draw',
                correctScore: { odds: +item.odds, outCome: item.outCome, name: item.name },
            });
            Main_1.Main.Instance.Fantasy.selectedAcc[match] = type;
            Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: selectedAcc });
            localStorage.setItem('selectedAcc', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedAcc));
        }
        Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: chosenResults });
        localStorage.setItem('chosenResults', JSON.stringify(Main_1.Main.Instance.Fantasy.chosenResults));
    }
    // console.log(Main.Instance.Fantasy.chosenResults)
}
exports.setAccumulatorDraw = setAccumulatorDraw;
function setScorers(item, matchId, homeTeam, awayTeam, team) {
    var found = false;
    var chosenResults = Main_1.Main.Instance.Fantasy.chosenResults;
    if (Main_1.Main.Instance.Fantasy.chosenResults.goalscorers) {
        var results = Main_1.Main.Instance.Fantasy.chosenResults.goalscorers;
        for (var i = 0; i < results.length; i++) {
            if (results[i].matchId === matchId) {
                found = true;
                var clicked = results.find(function (a) { return (a.matchId === matchId && a.correctScore.id === +item.id); });
                if (clicked) {
                    results.splice(results.indexOf(clicked), 1);
                }
                else {
                    if (Main_1.Main.Instance.Fantasy.chosenResults.goalscorers.length < 3) {
                        results.push({
                            matchId: matchId,
                            homeTeam: homeTeam,
                            awayTeam: awayTeam,
                            correctScore: {
                                id: +item.id,
                                name: item.player,
                                odds: item.odds,
                                outCome: item.outCome
                            },
                            team: team
                        });
                    }
                    else {
                        alert('You have already selected 3 goalscorers.');
                    }
                }
                Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: chosenResults });
                localStorage.setItem('chosenResults', JSON.stringify(Main_1.Main.Instance.Fantasy.chosenResults));
                break;
            }
        }
    }
    if (found === false) {
        if (Main_1.Main.Instance.Fantasy.chosenResults.goalscorers) {
            chosenResults.goalscorers = Main_1.Main.Instance.Fantasy.chosenResults.goalscorers;
        }
        else {
            chosenResults.goalscorers = [];
        }
        if (Main_1.Main.Instance.Fantasy.chosenResults && Main_1.Main.Instance.Fantasy.chosenResults.goalscorers.length > 2) {
            alert('You have already selected 3 goalscorers.');
        }
        else {
            chosenResults.goalscorers.push({
                matchId: matchId,
                homeTeam: homeTeam,
                awayTeam: awayTeam,
                correctScore: {
                    id: +item.id,
                    name: item.player,
                    odds: item.odds,
                    outCome: item.outCome
                },
                team: team
            });
        }
        Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: chosenResults });
        localStorage.setItem('chosenResults', JSON.stringify(Main_1.Main.Instance.Fantasy.chosenResults));
    }
    // console.log(Main.Instance.Fantasy.chosenResults)
}
exports.setScorers = setScorers;
function fillChosenResults(matches, results) {
    var selectedCorrect = Main_1.Main.Instance.Fantasy.selectedResult;
    var selectedAcc = Main_1.Main.Instance.Fantasy.selectedAcc;
    var correctScores = [];
    var accumulator = [];
    var goalscorers = [];
    for (var _i = 0, _a = results.results.correctScores; _i < _a.length; _i++) {
        var score = _a[_i];
        var oldScore = {
            matchId: score.matchId,
            homeTeam: score.homeTeam,
            awayTeam: score.awayTeam,
            correctScore: score.correctScore
        };
        correctScores.push(oldScore);
    }
    for (var _b = 0, _c = results.results.accumulator; _b < _c.length; _b++) {
        var score = _c[_b];
        var oldScore = {
            matchId: score.matchId,
            homeTeam: score.homeTeam,
            awayTeam: score.awayTeam,
            correctScore: score.correctScore,
            type: score.type
        };
        accumulator.push(oldScore);
    }
    for (var _d = 0, _e = results.results.goalscorers; _d < _e.length; _d++) {
        var score = _e[_d];
        var oldScore = {
            matchId: score.matchId,
            homeTeam: score.homeTeam,
            awayTeam: score.awayTeam,
            correctScore: score.correctScore,
            team: score.team
        };
        goalscorers.push(oldScore);
    }
    var _loop_1 = function (match) {
        var correctFound = results.results.correctScores.find(function (elt) { return +elt.matchId === +match.matchId; });
        var accFound = results.results.accumulator.find(function (elt) { return +elt.matchId === +match.matchId; });
        if (correctFound)
            selectedCorrect[matches.matches.indexOf(match)] = correctFound.correctScore.name;
        if (accFound)
            selectedAcc[matches.matches.indexOf(match)] = checkType(accFound.type);
    };
    for (var _f = 0, _g = matches.matches; _f < _g.length; _f++) {
        var match = _g[_f];
        _loop_1(match);
    }
    var chosenResults = {
        playerId: results.results.playerId,
        round: results.results.round,
        correctScores: correctScores,
        accumulator: accumulator,
        goalscorers: goalscorers
    };
    Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: chosenResults, selectedResult: selectedCorrect, selectedAcc: selectedAcc });
    localStorage.setItem('chosenResults', JSON.stringify(Main_1.Main.Instance.Fantasy.chosenResults));
    localStorage.setItem('selectedResult', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedResult));
    localStorage.setItem('selectedAcc', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedAcc));
}
exports.fillChosenResults = fillChosenResults;
function checkType(type) {
    switch (type) {
        case 'BTTS':
            return 1;
        case 'Over':
            return 2;
        case 'Under':
            return 3;
        default:
            return 4;
    }
}
function sortF(ob1, ob2) {
    if (ob1.position > ob2.position) {
        return 1;
    }
    else if (ob1.position < ob2.position) {
        return -1;
    }
    // Else go to the 2nd item
    if (ob1.odds < ob2.odds) {
        return -1;
    }
    else if (ob1.odds > ob2.odds) {
        return 1;
    }
    else {
        return 0;
    }
}
exports.sortF = sortF;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Assets_1 = __webpack_require__(3);
var Loader = /** @class */ (function (_super) {
    __extends(Loader, _super);
    function Loader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Loader.prototype.render = function () {
        return (React.createElement("div", { className: "loader" },
            React.createElement("img", { src: Assets_1.loaderImage })));
    };
    return Loader;
}(React.Component));
exports.default = Loader;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Logic;
(function (Logic) {
    var Type = /** @class */ (function () {
        function Type(model) {
            this.model = model ? model : Type.none.model;
        }
        // tslint:disable-next-line:no-shadowed-variable
        Type.New = function (value, state) {
            if (value == state) {
                return value;
            }
            var t = Object.assign(new value.constructor(value.model), value, state);
            for (var m in t) {
                var x = t[m];
                if (x instanceof Type) {
                    Type.Add(t, x);
                }
            }
            t.model.Update(t);
            return t;
        };
        // tslint:disable-next-line:no-shadowed-variable
        Type.Add = function (owner, field) {
            var t = new /** @class */ (function () {
                function class_1() {
                }
                class_1.prototype.Update = function (value) {
                    for (var m in owner) {
                        var x = owner[m];
                        if (x == field) {
                            Type.New(owner, (_a = {}, _a[m] = value, _a));
                        }
                    }
                    var _a;
                };
                return class_1;
            }());
            field.model = t;
            return field;
        };
        Type.none = new Type(new /** @class */ (function () {
            function class_2() {
            }
            class_2.prototype.Update = function (value) {
            };
            return class_2;
        }()));
        return Type;
    }());
    Logic.Type = Type;
})(Logic = exports.Logic || (exports.Logic = {}));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Type_1 = __webpack_require__(11);
var Index_1 = __webpack_require__(62);
var Login_1 = __webpack_require__(69);
// import {S} from './Search'
// import {M} from './Modal'
var Main = /** @class */ (function (_super) {
    __extends(Main, _super);
    function Main() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Login = Type_1.Logic.Type.Add(_this, new Login_1.Login);
        _this.Fantasy = Type_1.Logic.Type.Add(_this, new Index_1.Fantasy);
        return _this;
        // S = Logic.Type.Add(this, new S)
        // M = Logic.Type.Add(this, new M)
    }
    Main.Instance = new Main(new /** @class */ (function () {
        function class_1() {
        }
        class_1.prototype.Update = function (state) {
            Main.Instance = state;
        };
        return class_1;
    }()));
    return Main;
}(Type_1.Logic.Type));
exports.Main = Main;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(15);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(109);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _reactFastCompare = __webpack_require__(112);

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _HelmetUtils = __webpack_require__(113);

var _HelmetConstants = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _reactFastCompare2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIOROITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(116)(module)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cookies = __webpack_require__(76);

var _Cookies2 = _interopRequireDefault(_Cookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Cookies2.default;
module.exports = exports['default'];

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(34);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(35);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(1);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(24);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(47);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 28 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var statelogic_1 = __webpack_require__(31);
var routes_1 = __webpack_require__(73);
var SocketState = new statelogic_1.default(routes_1.default);
exports.default = SocketState;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
function subscribe() {
    var stores = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        stores[_i] = arguments[_i];
    }
    return function (WrappedComponent) {
        var FinalComponent = WrappedComponent;
        for (var _i = 0, stores_1 = stores; _i < stores_1.length; _i++) {
            var store = stores_1[_i];
            FinalComponent = store.subscribe(FinalComponent);
        }
        return FinalComponent;
    };
}
exports.subscribe = subscribe;
var AppState = /** @class */ (function () {
    function AppState(propsAndValues) {
        this._propsAndValues = propsAndValues; // each prop with initial value
        this._components = []; // each subscribed component
        this._instanceCount = 0; // how many instances to call setState()
    }
    AppState.prototype.subscribe = function (WrappedComponent) {
        var component = {
            instances: {},
            nextInstanceId: 0
        };
        this._components.push(component);
        var THIS = this; // so we can access it inside class below
        return /** @class */ (function (_super) {
            __extends(AppStateSubscriber, _super);
            function AppStateSubscriber(props) {
                var _this = _super.call(this, props) || this;
                _this._instanceId = 'in' + (component.nextInstanceId++);
                component.instances[_this._instanceId] = _this; // store instance using ID as key
                ++THIS._instanceCount;
                _this.state = __assign({}, THIS._propsAndValues); // receive current values right away
                return _this;
            }
            AppStateSubscriber.prototype.componentWillUnmount = function () {
                --THIS._instanceCount;
                delete component.instances[this._instanceId]; // so set() won't dispatch to inexistent instance
            };
            AppStateSubscriber.prototype.render = function () {
                return React.createElement(WrappedComponent, __assign({}, this.props, this.state));
            };
            return AppStateSubscriber;
        }(React.Component));
    };
    AppState.prototype.get = function (propName) {
        if (!this._propsAndValues.hasOwnProperty(propName)) {
            return;
            // throw new Error('Retrieving an inexistent prop: ' + propName);
        }
        return this._propsAndValues[propName];
    };
    AppState.prototype.set = function (propsAndValues, callback) {
        for (var _i = 0, _a = Object.keys(propsAndValues); _i < _a.length; _i++) {
            var propName = _a[_i];
            if (!this._propsAndValues.hasOwnProperty(propName)) {
                return;
                // throw new Error('Updating an inexistent prop: ' + propName);
            }
        }
        this._propsAndValues = __assign({}, this._propsAndValues, propsAndValues); // update internal store
        var asyncCallback = null;
        if (callback) {
            var instanceCount_1 = this._instanceCount;
            asyncCallback = function () {
                if (--instanceCount_1 === 0) {
                    callback(); // user callback is fired after last setState() returns
                }
            };
        }
        for (var _b = 0, _c = this._components; _b < _c.length; _b++) {
            var component = _c[_b];
            for (var _d = 0, _e = Object.keys(component.instances); _d < _e.length; _d++) {
                var instanceId = _e[_d];
                component.instances[instanceId].setState(__assign({}, propsAndValues), asyncCallback); // AppStateSubscriber.setState()
            }
        }
    };
    return AppState;
}());
exports.default = AppState;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/** INTERFACES FROM SERVER */
/** Base Class to extend */
var Route = /** @class */ (function () {
    function Route(loading) {
        if (!loading) {
            this.loading = 'init';
        }
        else {
            this.loading = loading;
        }
    }
    return Route;
}());
exports.Route = Route;
/* CLASS EXTENDS ROUTE IMPLEMENTS INTERFACE FROM SERVER ALWAYS INITIALIZE OBJECTS */
var Rounds = /** @class */ (function (_super) {
    __extends(Rounds, _super);
    function Rounds() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Rounds;
}(Route));
exports.Rounds = Rounds;
var Matches = /** @class */ (function (_super) {
    __extends(Matches, _super);
    function Matches() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Matches;
}(Route));
exports.Matches = Matches;
var InsertBet = /** @class */ (function (_super) {
    __extends(InsertBet, _super);
    function InsertBet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InsertBet;
}(Route));
exports.InsertBet = InsertBet;
var UpdateBet = /** @class */ (function (_super) {
    __extends(UpdateBet, _super);
    function UpdateBet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UpdateBet;
}(Route));
exports.UpdateBet = UpdateBet;
var Results = /** @class */ (function (_super) {
    __extends(Results, _super);
    function Results() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Results;
}(Route));
exports.Results = Results;
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Login;
}(Route));
exports.Login = Login;
var ForgotPassword = /** @class */ (function (_super) {
    __extends(ForgotPassword, _super);
    function ForgotPassword() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ForgotPassword;
}(Route));
exports.ForgotPassword = ForgotPassword;
var ChangePassword = /** @class */ (function (_super) {
    __extends(ChangePassword, _super);
    function ChangePassword() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ChangePassword;
}(Route));
exports.ChangePassword = ChangePassword;
var Unsubscribe = /** @class */ (function (_super) {
    __extends(Unsubscribe, _super);
    function Unsubscribe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Unsubscribe;
}(Route));
exports.Unsubscribe = Unsubscribe;
var MyProfileSelect = /** @class */ (function (_super) {
    __extends(MyProfileSelect, _super);
    function MyProfileSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MyProfileSelect;
}(Route));
exports.MyProfileSelect = MyProfileSelect;
var MyProfileUpdate = /** @class */ (function (_super) {
    __extends(MyProfileUpdate, _super);
    function MyProfileUpdate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MyProfileUpdate;
}(Route));
exports.MyProfileUpdate = MyProfileUpdate;
var Registration = /** @class */ (function (_super) {
    __extends(Registration, _super);
    function Registration() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Registration;
}(Route));
exports.Registration = Registration;
var UserConfirmation = /** @class */ (function (_super) {
    __extends(UserConfirmation, _super);
    function UserConfirmation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UserConfirmation;
}(Route));
exports.UserConfirmation = UserConfirmation;
var Flags = /** @class */ (function (_super) {
    __extends(Flags, _super);
    function Flags() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Flags;
}(Route));
exports.Flags = Flags;
var Leaderboards = /** @class */ (function (_super) {
    __extends(Leaderboards, _super);
    function Leaderboards() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Leaderboards;
}(Route));
exports.Leaderboards = Leaderboards;
var CreateLeague = /** @class */ (function (_super) {
    __extends(CreateLeague, _super);
    function CreateLeague() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CreateLeague;
}(Route));
exports.CreateLeague = CreateLeague;
var JoinLeague = /** @class */ (function (_super) {
    __extends(JoinLeague, _super);
    function JoinLeague() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return JoinLeague;
}(Route));
exports.JoinLeague = JoinLeague;
var SendLeagueCode = /** @class */ (function (_super) {
    __extends(SendLeagueCode, _super);
    function SendLeagueCode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SendLeagueCode;
}(Route));
exports.SendLeagueCode = SendLeagueCode;
var UserLeagues = /** @class */ (function (_super) {
    __extends(UserLeagues, _super);
    function UserLeagues() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UserLeagues;
}(Route));
exports.UserLeagues = UserLeagues;
var UpcomingFixtures = /** @class */ (function (_super) {
    __extends(UpcomingFixtures, _super);
    function UpcomingFixtures() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UpcomingFixtures;
}(Route));
exports.UpcomingFixtures = UpcomingFixtures;
var Usr = /** @class */ (function (_super) {
    __extends(Usr, _super);
    function Usr() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Usr;
}(Route));
exports.Usr = Usr;
var LeaderboardFeed = /** @class */ (function (_super) {
    __extends(LeaderboardFeed, _super);
    function LeaderboardFeed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LeaderboardFeed;
}(Route));
exports.LeaderboardFeed = LeaderboardFeed;
var TeamFeed = /** @class */ (function (_super) {
    __extends(TeamFeed, _super);
    function TeamFeed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TeamFeed;
}(Route));
exports.TeamFeed = TeamFeed;
var PlayerFeed = /** @class */ (function (_super) {
    __extends(PlayerFeed, _super);
    function PlayerFeed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PlayerFeed;
}(Route));
exports.PlayerFeed = PlayerFeed;
var LastMatchesFeed = /** @class */ (function (_super) {
    __extends(LastMatchesFeed, _super);
    function LastMatchesFeed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LastMatchesFeed;
}(Route));
exports.LastMatchesFeed = LastMatchesFeed;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(39);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
// import { Main } from '../../../Logic/Main'
var Body = __webpack_require__(7);
var Bet_1 = __webpack_require__(43);
// import * as Lounge from './Lounge'
var socket_init_1 = __webpack_require__(6);
var Assets = __webpack_require__(3);
var Utils = __webpack_require__(9);
// import * as Utils from '../../../Logic/Utils'
// import * as Assets from '../../../assets/Assets'
var react_router_dom_1 = __webpack_require__(5);
var react_cookie_1 = __webpack_require__(4);
var Loader_1 = __webpack_require__(10);
var teamShirts = [
    { teamName: 'Arsenal', src: 'arsenal.png', color: '#FFF' },
    { teamName: 'Chelsea', src: 'chelsea.png', color: '#FFF' },
    { teamName: 'Everton', src: 'everton.png', color: '#FFF' },
    { teamName: 'Fulham', src: 'tottenham.png', color: '#000' },
    { teamName: 'Liverpool', src: 'liverpool.png', color: '#FFF' },
    { teamName: 'Manchester City', src: 'manchester-city.png', color: '#000' },
    { teamName: 'Manchester United', src: 'manchester-united.png', color: '#FFF' },
    { teamName: 'Newcastle United', src: 'wba.png', color: '#000' },
    { teamName: 'Tottenham Hotspur', src: 'tottenham.png', color: '#000' },
    { teamName: 'West Ham United', src: 'west-ham.png', color: '#FFF' },
    { teamName: 'Burnley', src: 'burnley.png', color: '#FFF' },
    { teamName: 'Cardiff City', src: 'crystal-palace.png', color: '#FFF' },
    { teamName: 'Crystal Palace', src: 'crystal-palace.png', color: '#FFF' },
    { teamName: 'Leicester', src: 'leicester.png', color: '#FFF' },
    { teamName: 'Southampton', src: 'southampton.png', color: '#FFF' },
    { teamName: 'Watford', src: 'watford.png', color: '#000' },
    { teamName: 'Wolverhampton Wanderers', src: 'hull-city.png', color: '#000' },
    { teamName: 'Brighton & Hove Albion', src: 'everton.png', color: '#FFF' },
    { teamName: 'Huddersfield Town', src: 'everton.png', color: '#FFF' },
    { teamName: 'AFC Bournemouth', src: 'bournemouth.png', color: '#FFF' },
    { teamName: 'Leicester City', src: 'leicester.png', color: '#FFF' }
];
function setPosition(position) {
    switch (position) {
        case 'G':
            return 'Goalkeeper';
        case 'D':
            return 'Defender';
        case 'M':
            return 'Midfielder';
        default:
            return 'Attacker';
    }
}
exports.setPosition = setPosition;
function getTeamShirt(team) {
    for (var _i = 0, teamShirts_1 = teamShirts; _i < teamShirts_1.length; _i++) {
        var shirt = teamShirts_1[_i];
        if (team === shirt.teamName) {
            return shirt;
        }
    }
}
exports.getTeamShirt = getTeamShirt;
var Standings = /** @class */ (function (_super) {
    __extends(Standings, _super);
    function Standings(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        _this.cookies = new react_cookie_1.Cookies();
        _this.state = {
            userDropdown: false,
            popupTeam: false,
            popupPlayer: false,
            team: {},
            player: {},
            injury: {},
            mobileMenu: false
        };
        socket_init_1.default.Send('get-leaderboard', { league: 'england' });
        return _this;
    }
    Standings.prototype.render = function () {
        var _this = this;
        if (socket_init_1.default.Get('get-leaderboard').loading !== 'loaded') {
            return React.createElement(Loader_1.default, null);
        }
        else {
            return (React.createElement("section", { className: "wrapper" },
                React.createElement("div", { className: "header", role: "banner" },
                    React.createElement("header", { className: "navbar navbar-default", style: { marginBottom: '0' } },
                        React.createElement("div", { className: "container" },
                            React.createElement("div", { className: "navbar-header" },
                                React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                    React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" })),
                                React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                    React.createElement("img", { src: Assets.logoMain, alt: "", className: "logo" })),
                                React.createElement("span", { className: "navbar-toggle user-profile-trigger" }, this.cookies.get('username'))),
                            React.createElement("nav", { className: (this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse', id: "navbar-collapse-left", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' } }, (this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)),
                            React.createElement("nav", { className: "collapse navbar-collapse", id: "user-profile" },
                                React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                                    React.createElement("li", { className: "user-nav-option" },
                                        React.createElement("div", { className: "user" },
                                            React.createElement("div", { className: "user-info-wrap" },
                                                " ",
                                                React.createElement("span", { className: "user-name" }, this.cookies.get('username')),
                                                React.createElement("div", { className: "balance-info" },
                                                    " Balance",
                                                    React.createElement("span", { className: "text-primary" }, "5,000 \u20AC "),
                                                    React.createElement("a", { href: "javascript:void(0);" },
                                                        React.createElement("i", { className: "icon-plus-circular" })))))),
                                    (this.cookies.get('username')) ?
                                        React.createElement("li", { className: (this.state.userDropdown === true) ? 'dropdown open' : 'dropdown' },
                                            React.createElement("a", { href: "javascript:void(0);", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (this.state.userDropdown) ? 'true' : 'false' },
                                                React.createElement("i", { className: "icon-menu-dots", onClick: function () { return _this.setState({ userDropdown: !_this.state.userDropdown }); } })),
                                            React.createElement("ul", { className: "dropdown-menu" },
                                                React.createElement("li", null,
                                                    React.createElement(react_router_dom_1.Link, { to: "/myprofile" },
                                                        React.createElement("i", { className: "icon-profile" }),
                                                        "MY PROFILE")),
                                                React.createElement("li", { onClick: function () { return Utils.logout(); } },
                                                    React.createElement(react_router_dom_1.Link, { to: "/login" },
                                                        React.createElement("i", { className: "icon-logout" }),
                                                        "LOGOUT"))))
                                        :
                                            null))))),
                React.createElement("main", { className: "main" },
                    React.createElement("div", { className: "standings" },
                        React.createElement("table", null,
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("th", null, "#"),
                                    React.createElement("th", { className: "standings-team-name" }, "Team"),
                                    React.createElement("th", null, "GP"),
                                    React.createElement("th", { className: "mobile-hide" }, "W"),
                                    React.createElement("th", { className: "mobile-hide" }, "D"),
                                    React.createElement("th", { className: "mobile-hide" }, "L"),
                                    React.createElement("th", { className: "mobile-hide" }, "GF"),
                                    React.createElement("th", { className: "mobile-hide" }, "GA"),
                                    React.createElement("th", null, "GD"),
                                    React.createElement("th", { style: { borderRight: '0' } }, "PTS"))),
                            React.createElement("tbody", null, this.setStandings()))),
                    (this.state.popupTeam) ? this.showPopupTeam() : null,
                    (this.state.popupPlayer) ? this.showPopupPlayer() : null)));
        }
    };
    Standings.prototype.setStandings = function () {
        var _this = this;
        var leaderboard = socket_init_1.default.Get('get-leaderboard').leaderboard[0];
        var standings = [];
        var _loop_1 = function (team) {
            standings.push(React.createElement("tr", { key: standings.length, style: { background: (leaderboard.indexOf(team) % 2 !== 0) ? '#E7E7E7' : 'rgb(255, 255, 255)' } },
                React.createElement("td", { style: { borderLeft: '1px solid rgb(225, 225, 225)' } }, team.position),
                React.createElement("td", null,
                    React.createElement("div", { style: { width: '20%', textAlign: 'center' } },
                        React.createElement("img", { src: Bet_1.getLogo(team.name) })),
                    React.createElement("div", { style: { width: '80%' } },
                        React.createElement("a", { onClick: function () { _this.setState({ popupTeam: true, team: team }), socket_init_1.default.Send('get-team-info', { teamId: team.id }); } }, team.name))),
                React.createElement("td", null, team.gamesPlayed),
                React.createElement("td", { className: "mobile-hide" }, team.wins),
                React.createElement("td", { className: "mobile-hide" }, team.draws),
                React.createElement("td", { className: "mobile-hide" }, team.losses),
                React.createElement("td", { className: "mobile-hide" }, team.goalsFor),
                React.createElement("td", { className: "mobile-hide" }, team.goalsAgainst),
                React.createElement("td", null, team.goalsDifference),
                React.createElement("td", null, team.points)));
        };
        for (var _i = 0, leaderboard_1 = leaderboard; _i < leaderboard_1.length; _i++) {
            var team = leaderboard_1[_i];
            _loop_1(team);
        }
        return standings;
    };
    Standings.prototype.showPopupTeam = function () {
        var _this = this;
        var team = socket_init_1.default.Get('get-team-info');
        if (team.loading !== 'loaded') {
            return React.createElement(Loader_1.default, null);
        }
        else {
            var screenPosition = document.documentElement.scrollTop + 150;
            var top = screenPosition.toString() + 'px';
            var selectedTeam = team.teamInfo;
            return (React.createElement("div", { className: "popup" },
                React.createElement("div", { className: "popup-inner", style: { bottom: '10%', overflow: 'scroll', top: top } },
                    React.createElement("div", { className: "team-info" },
                        React.createElement("div", null,
                            React.createElement("span", { style: { width: '10%', marginRight: '10px' } },
                                React.createElement("img", { src: 'data:image/png;base64,' + selectedTeam.logo, style: { width: '60px', height: '60px' } })),
                            React.createElement("span", { className: "team-info-name" }, selectedTeam.name.toUpperCase()),
                            React.createElement("span", { className: "team-info-close" },
                                React.createElement("img", { src: "cancel.svg", style: { width: '30px', height: '30px' }, onClick: function () { return _this.setState({ popupTeam: false }); } }))),
                        React.createElement("div", { className: "team-data" },
                            React.createElement("span", null,
                                "Country: ",
                                React.createElement("p", null, selectedTeam.country)),
                            React.createElement("span", null,
                                "Founded: ",
                                React.createElement("p", null, selectedTeam.founded)),
                            React.createElement("span", null,
                                "Coach: ",
                                React.createElement("p", null, selectedTeam.coach))),
                        React.createElement("div", { className: "team-data-second" },
                            React.createElement("span", null,
                                "Stadium: ",
                                React.createElement("p", null, selectedTeam.venueName)),
                            React.createElement("span", null,
                                "Stadium capacity: ",
                                React.createElement("p", null, selectedTeam.venueCapacity)))),
                    React.createElement("div", { className: "team-players" },
                        React.createElement("p", { style: { fontSize: '16px' } },
                            React.createElement("b", null, "TEAM SQUAD")),
                        React.createElement("div", { className: "team-table" }, this.setSquad(selectedTeam))))));
        }
    };
    Standings.prototype.setSquad = function (team) {
        var _this = this;
        var players = [];
        var teamShirt = getTeamShirt(team.name);
        var _loop_2 = function (i) {
            var injured = this_1.checkInjury(team.squad[i].name, team.sidelined);
            if (i === 0 || (team.squad[i - 1] && team.squad[i - 1].position !== team.squad[i].position)) {
                players.push(React.createElement("p", { key: players.length, style: { fontSize: '15px', marginBottom: '0' } },
                    React.createElement("b", null, setPosition(team.squad[i].position) + 's')));
            }
            players.push(React.createElement("div", { key: players.length, className: "team-table-player" },
                React.createElement("div", { className: "team-table-player-shirt" },
                    React.createElement("img", { src: teamShirt.src }),
                    React.createElement("div", { className: (team.squad[i].number.toString().length === 1) ? 'text-on-image shirt-one-number' : 'text-on-image shirt-two-numbers', style: { color: teamShirt.color } }, team.squad[i].number)),
                React.createElement("div", { style: { width: '65%', marginLeft: '5%' } },
                    React.createElement("span", { onClick: function () {
                            _this.setState({ popupPlayer: true, injury: injured, player: team.squad[i] }),
                                socket_init_1.default.Send('get-player-info', { teamId: _this.state.team.id, playerId: team.squad[i].id });
                        } },
                        React.createElement("a", { style: { color: (injured) ? '#F03300' : 'rgb(41, 160, 0)' } }, team.squad[i].name)),
                    React.createElement("span", null, 'Age: ' + team.squad[i].age),
                    React.createElement("span", null, 'Appearances: ' + team.squad[i].appearences))));
        };
        var this_1 = this;
        for (var i = 0; i < team.squad.length; i++) {
            _loop_2(i);
        }
        return players;
    };
    Standings.prototype.checkInjury = function (player, sidelined) {
        for (var _i = 0, sidelined_1 = sidelined; _i < sidelined_1.length; _i++) {
            var item = sidelined_1[_i];
            if (item.name === player)
                return item;
        }
    };
    Standings.prototype.showPopupPlayer = function () {
        var _this = this;
        var screenPosition = document.documentElement.scrollTop + 50;
        var top = screenPosition.toString() + 'px';
        return (React.createElement("div", { className: "popup" },
            React.createElement("div", { className: "popup-inner", style: { top: top } },
                React.createElement("div", { className: "team-players" },
                    React.createElement("span", { className: "team-players-name" },
                        React.createElement("b", null, this.state.player.name)),
                    React.createElement("span", { className: "team-info-close" },
                        React.createElement("img", { src: "cancel.svg", onClick: function () { return _this.setState({ popupPlayer: false }); } })),
                    React.createElement("table", { className: "team-table" },
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", { className: "player-stats-hide" }, "Position"),
                                React.createElement("th", { className: "player-stats-hide" }, "Age"),
                                React.createElement("th", { className: "player-stats-hide" }, "Shirt number"),
                                React.createElement("th", null, "Appearances"),
                                React.createElement("th", null, "Starts"),
                                React.createElement("th", null, "Minutes"),
                                React.createElement("th", null, "Goals"),
                                React.createElement("th", null, "Assists"),
                                React.createElement("th", { className: "player-stats-hide" }, "Yellow Cards"),
                                React.createElement("th", { className: "player-stats-hide" }, "Red Cards"))),
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("td", { className: "player-stats-hide" }, setPosition(this.state.player.position)),
                                React.createElement("td", { className: "player-stats-hide" }, this.state.player.age),
                                React.createElement("td", { className: "player-stats-hide" }, this.state.player.number),
                                React.createElement("td", null, this.state.player.appearences),
                                React.createElement("td", null, this.state.player.lineups),
                                React.createElement("td", null, this.state.player.minutes),
                                React.createElement("td", null, this.state.player.goals),
                                React.createElement("td", null, this.state.player.assists),
                                React.createElement("td", { className: "player-stats-hide" }, this.state.player.yellowCards),
                                React.createElement("td", { className: "player-stats-hide" }, this.state.player.redcards + this.state.player.yellowRedCards)))),
                    (this.state.injury) ?
                        React.createElement("div", null,
                            React.createElement("span", { style: { marginTop: '20px', fontSize: '20px', color: '#F03300' } },
                                React.createElement("b", null, "Injury stats")),
                            React.createElement("div", { className: "injury-stats" },
                                React.createElement("span", null,
                                    React.createElement("b", null, "Injury: "),
                                    React.createElement("i", null, this.state.injury.description)),
                                React.createElement("span", null,
                                    React.createElement("b", null, "Injured from: "),
                                    React.createElement("i", null, this.state.injury.startDate)),
                                React.createElement("span", null,
                                    React.createElement("b", null, "Expected comeback: "),
                                    React.createElement("i", null, (this.state.injury.endDate !== '') ? this.state.injury.endDate : 'Unknown'))))
                        : null))));
    };
    return Standings;
}(React.Component));
exports.default = react_cookie_1.withCookies(Standings);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var moment = __webpack_require__(19);
var Assets = __webpack_require__(3);
var socket_init_1 = __webpack_require__(6);
// import SocketState from '../../../Socket/socketstate'
var Utils = __webpack_require__(9);
var Main_1 = __webpack_require__(13);
var Type_1 = __webpack_require__(11);
// import * as Results from './Results'
var Body = __webpack_require__(7);
var react_router_dom_1 = __webpack_require__(5);
var react_cookie_1 = __webpack_require__(4);
var Loader_1 = __webpack_require__(10);
var logos = [
    { teamName: 'Liverpool', src: 'liverpool-shirt.png' },
    { teamName: 'Stoke', src: 'stoke-shirt.png' },
    { teamName: 'Burnley', src: 'burnley-shirt.png' },
    { teamName: 'Brighton', src: 'middlesbrough-shirt.png' },
    { teamName: 'Crystal Palace', src: 'crystal-palace-shirt.png' },
    { teamName: 'Leicester', src: 'leicester-shirt.png' },
    { teamName: 'Huddersfield', src: 'sunderland-shirt.png' },
    { teamName: 'Everton', src: 'everton-shirt.png' },
    { teamName: 'Newcastle', src: 'hull-shirt.png' },
    { teamName: 'West Brom', src: 'west-brom-shirt.png' },
    { teamName: 'Southampton', src: 'southampton-shirt.png' },
    { teamName: 'Bournemouth', src: 'bournemouth-shirt.png' },
    { teamName: 'Swansea', src: 'swansea-shirt.png' },
    { teamName: 'Chelsea', src: 'chelsea-shirt.png' },
    { teamName: 'West Ham', src: 'west-ham-shirt.png' },
    { teamName: 'Man City', src: 'manchester-city-shirt.png' },
    { teamName: 'Man Utd', src: 'manchester-united-shirt.png' },
    { teamName: 'Manchester City', src: 'manchester-city-shirt.png' },
    { teamName: 'Manchester United', src: 'manchester-united-shirt.png' },
    { teamName: 'Tottenham', src: 'tottenham-shirt.png' },
    { teamName: 'Watford', src: 'watford-shirt.png' }
];
function getLogo(teamName) {
    for (var _i = 0, logos_1 = logos; _i < logos_1.length; _i++) {
        var logo = logos_1[_i];
        if (logo.teamName === teamName)
            return logo.src;
    }
}
exports.getLogo = getLogo;
function setVisible(i, homeAway, closeAll) {
    var matches = socket_init_1.default.Get('matches');
    if (closeAll) {
        for (var _i = 0, _a = matches.matches; _i < _a.length; _i++) {
            var match = _a[_i];
            match.open = false;
        }
    }
    else {
        matches.matches[i].open = !matches.matches[i].open;
    }
    if (homeAway) {
        for (var _b = 0, _c = matches.matches; _b < _c.length; _b++) {
            var match = _c[_b];
            match.open = false;
        }
        matches.matches[i].open = !matches.matches[i].open;
        if (matches.matches[i].homeAway === 1 && homeAway === 1)
            matches.matches[i].homeAway = 0;
        else if (matches.matches[i].homeAway === 2 && homeAway === 2)
            matches.matches[i].homeAway = 0;
        else
            matches.matches[i].homeAway = homeAway;
        if (matches.matches[i].homeAway === 0)
            matches.matches[i].open = !matches.matches[i].open;
    }
    socket_init_1.default.Set('matches', matches);
}
function checkNumber(type) {
    switch (type) {
        case 'correctScores':
            if (Main_1.Main.Instance.Fantasy.chosenResults.correctScores.length === 1) {
                return '1 match (required 3).';
            }
            else {
                return Main_1.Main.Instance.Fantasy.chosenResults.correctScores.length.toString() + ' matches (required 3).';
            }
        case 'accumulator':
            if (Main_1.Main.Instance.Fantasy.chosenResults.accumulator.length === 1) {
                return '1 match (required 3).';
            }
            else {
                return Main_1.Main.Instance.Fantasy.chosenResults.accumulator.length.toString() + ' matches (required 3).';
            }
        case 'goalscorers':
            if (Main_1.Main.Instance.Fantasy.chosenResults.goalscorers.length === 1) {
                return '1 goalscorer (required 3).';
            }
            else {
                return Main_1.Main.Instance.Fantasy.chosenResults.goalscorers.length.toString() + ' goalscorers (required 3).';
            }
        default:
            return '';
    }
}
function updateBet(playerId) {
    var bet = {
        playerId: +playerId,
        round: +localStorage.getItem('roundId'),
        correctScores: Main_1.Main.Instance.Fantasy.chosenResults.correctScores,
        accumulator: Main_1.Main.Instance.Fantasy.chosenResults.accumulator,
        goalscorers: Main_1.Main.Instance.Fantasy.chosenResults.goalscorers
    };
    socket_init_1.default.Send('update-bet', bet);
}
var Bet1 = /** @class */ (function (_super) {
    __extends(Bet1, _super);
    function Bet1(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        window.onload = function () {
            socket_init_1.default.Send('matches', { round: +localStorage.getItem('roundId') });
            Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: JSON.parse(localStorage.getItem('chosenResults')) });
            if (JSON.parse(localStorage.getItem('selectedResult')) === null) {
                Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedResult: ['---', '---', '---', '---', '---', '---', '---', '---', '---', '---'] });
            }
            else {
                Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedResult: JSON.parse(localStorage.getItem('selectedResult')) });
            }
            if (JSON.parse(localStorage.getItem('selectedAcc')) === null) {
                Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0] });
            }
            else {
                Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: JSON.parse(localStorage.getItem('selectedAcc')) });
            }
        };
        _this.cookies = new react_cookie_1.Cookies();
        _this.state = {
            userDropdown: false,
            popup: false,
            team: '',
            homeAway: 0,
            mobileMenu: false,
            checkPoints: false,
            allMatches: false,
            homeDrawAway: (screen.width > 768) ? [4, 4, 4, 4, 4, 4, 4, 4, 4, 4] : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        };
        socket_init_1.default.Send('matches', { round: +localStorage.getItem('roundId') });
        socket_init_1.default.Send('flags', {});
        return _this;
    }
    Bet1.prototype.render = function () {
        var _this = this;
        if (socket_init_1.default.Get('matches').loading !== 'loaded' || socket_init_1.default.Get('flags').loading !== 'loaded') {
            return React.createElement(Loader_1.default, null);
        }
        else {
            var possibleTotal = this.calculatePossibleTotal(Main_1.Main.Instance.Fantasy.chosenResults);
            return (React.createElement("section", { className: "wrapper" },
                React.createElement("div", { className: "header", role: "banner" },
                    React.createElement("header", { className: "navbar navbar-default", style: { marginBottom: '0' } },
                        React.createElement("div", { className: "container" },
                            React.createElement("div", { className: "navbar-header" },
                                React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                    React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" })),
                                React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                    React.createElement("img", { src: Assets.logoMain, alt: "", className: "logo" })),
                                React.createElement("span", { className: "navbar-toggle user-profile-trigger" }, this.cookies.get('username'))),
                            React.createElement("nav", { className: (this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse', id: "navbar-collapse-left", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' } }, (this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)),
                            React.createElement("nav", { className: "collapse navbar-collapse", id: "user-profile" },
                                React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                                    React.createElement("li", { className: "user-nav-option" },
                                        React.createElement("div", { className: "user" },
                                            React.createElement("div", { className: "user-info-wrap" },
                                                " ",
                                                React.createElement("span", { className: "user-name" }, this.cookies.get('username')),
                                                React.createElement("div", { className: "balance-info" },
                                                    " Balance",
                                                    React.createElement("span", { className: "text-primary" }, "5,000 \u20AC "),
                                                    React.createElement("a", { href: "javascript:void(0);" },
                                                        React.createElement("i", { className: "icon-plus-circular" })))))),
                                    (this.cookies.get('username')) ?
                                        React.createElement("li", { className: (this.state.userDropdown === true) ? 'dropdown open' : 'dropdown' },
                                            React.createElement("a", { href: "javascript:void(0);", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (this.state.userDropdown) ? 'true' : 'false' },
                                                React.createElement("i", { className: "icon-menu-dots", onClick: function () { return _this.setState({ userDropdown: !_this.state.userDropdown }); } })),
                                            React.createElement("ul", { className: "dropdown-menu" },
                                                React.createElement("li", null,
                                                    React.createElement(react_router_dom_1.Link, { to: "/myprofile" },
                                                        React.createElement("i", { className: "icon-profile" }),
                                                        "MY PROFILE")),
                                                React.createElement("li", { onClick: function () { return Utils.logout(); } },
                                                    React.createElement(react_router_dom_1.Link, { to: "/login" },
                                                        React.createElement("i", { className: "icon-logout" }),
                                                        "LOGOUT"))))
                                        :
                                            null))))),
                React.createElement("div", { className: "info-ribbon" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "h4 text-center" }, 'GAMEWEEK ' + localStorage.getItem('roundId')))),
                React.createElement("main", { className: "main" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "step-numbers" },
                            React.createElement("ul", { className: "" },
                                React.createElement("li", { className: "active" },
                                    React.createElement("span", { "data-li": "1" },
                                        React.createElement("b", null, "1")),
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Correct Score"))),
                                React.createElement("li", { className: "" },
                                    React.createElement("span", { "data-li": "2" },
                                        React.createElement("b", null, "2")),
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Goal Markets"))),
                                React.createElement("li", { className: " " },
                                    React.createElement("span", { "data-li": "3" },
                                        React.createElement("b", null, "3")),
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Goalscorers"))))),
                        React.createElement("h1", { className: "section-heading-main" },
                            " CORRECT ",
                            React.createElement("span", { className: "brod-text" }, "SCORE")),
                        React.createElement("p", { className: "text-center", style: { fontSize: '20px', color: 'rgb(41, 160, 0)' } }, "*Predict the full time result (in 90 mins) for any 3 fixtures"),
                        React.createElement("div", { className: "listing-section" },
                            this.setMatches(),
                            React.createElement("div", { className: "clearfix" }),
                            (Main_1.Main.Instance.Fantasy.chosenResults && Main_1.Main.Instance.Fantasy.chosenResults.correctScores.length > 0) ?
                                React.createElement("div", { className: "possible-total" },
                                    React.createElement("span", { className: "possible-total-green-background" },
                                        React.createElement("img", { src: "info-white.png", onClick: function () { return _this.setState({ checkPoints: true }); } }),
                                        React.createElement("b", null, "Accumulator points")),
                                    React.createElement("span", { className: "possible-total-white-background" },
                                        React.createElement("b", null, (possibleTotal[0] + possibleTotal[1]).toFixed(2))))
                                : null,
                            React.createElement("div", { className: "row btn-wrapper mT20" }, (this.props.location.state.showConfirmButton === false)
                                ?
                                    React.createElement("div", null,
                                        React.createElement("div", { className: "col-sm-6" },
                                            React.createElement(react_router_dom_1.Link, { to: { pathname: '/confirmation', state: { showConfirmButton: this.props.location.state.showConfirmButton } }, className: "btn-default btn-lg no-shadow btn-block btn" }, "BACK")),
                                        React.createElement("div", { className: "col-sm-6" }, (Main_1.Main.Instance.Fantasy.chosenResults && Main_1.Main.Instance.Fantasy.chosenResults.correctScores.length === 3) ?
                                            React.createElement(react_router_dom_1.Link, { to: { pathname: '/confirmation', state: { showConfirmButton: this.props.location.state.showConfirmButton } }, className: "btn-primary btn-lg no-shadow btn-block btn", onClick: function () { return updateBet(+_this.cookies.get('playerId')); } }, "SAVE")
                                            :
                                                React.createElement("a", { className: "btn-primary btn-lg no-shadow btn-block btn", onClick: function () { return ((!Main_1.Main.Instance.Fantasy.chosenResults || (Main_1.Main.Instance.Fantasy.chosenResults && Main_1.Main.Instance.Fantasy.chosenResults.correctScores.length) === 0) ? alert('You haven\'t selected any match.') : alert('You have selected only ' + checkNumber('correctScores'))); } }, "SAVE")))
                                :
                                    React.createElement("div", { className: "col-sm-12" }, (Main_1.Main.Instance.Fantasy.chosenResults && Main_1.Main.Instance.Fantasy.chosenResults.correctScores.length === 3) ?
                                        React.createElement(react_router_dom_1.Link, { className: "btn-primary btn-lg no-shadow btn-block btn", onClick: function () { return _this.closeMatches(); }, to: { pathname: '/betstep2', state: { showConfirmButton: true } } }, "CONTINUE")
                                        :
                                            React.createElement("a", { className: "btn-primary btn-lg no-shadow btn-block btn", onClick: function () { return ((!Main_1.Main.Instance.Fantasy.chosenResults || (Main_1.Main.Instance.Fantasy.chosenResults && Main_1.Main.Instance.Fantasy.chosenResults.correctScores.length) === 0) ? alert('You haven\'t selected any match.') : alert('You have selected only ' + checkNumber('correctScores'))); } }, "CONTINUE"))))),
                    (this.state.popup) ? this.showPopup() : null,
                    (this.state.checkPoints) ? this.showCheckPoints() : null)));
        }
    };
    Bet1.prototype.calculatePossibleTotal = function (bets) {
        if (bets) {
            var possible1X2 = 1;
            var possibleBonus = 1;
            for (var _i = 0, _a = bets.correctScores; _i < _a.length; _i++) {
                var score = _a[_i];
                possible1X2 *= score.correctScore.odds1X2;
                possibleBonus *= score.correctScore.bonus;
            }
            return [possible1X2, possibleBonus];
        }
    };
    Bet1.prototype.returnDate = function (i, match1, match2) {
        if (i == 0) {
            return React.createElement("li", { className: "header-li" }, moment(match1.date).format('LL ddd'));
        }
        if (i > 0 && (moment(match1.date).format('LL ddd') !== moment(match2.date).format('LL ddd'))) {
            return React.createElement("li", { className: "header-li" }, moment(match1.date).format('LL ddd'));
        }
    };
    Bet1.prototype.setScore = function (position, result) {
        Main_1.Main.Instance.Fantasy.selectedResult[position] = result;
        Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedResult: Main_1.Main.Instance.Fantasy.selectedResult });
        localStorage.setItem('selectedResult', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedResult));
        if (Main_1.Main.Instance.Fantasy.selectedResult[position][0] !== '-' && Main_1.Main.Instance.Fantasy.selectedResult[position][2] !== '-')
            setVisible(position);
    };
    Bet1.prototype.showOddsPremier = function (odds, matchId, homeTeam, awayTeam, position) {
        var _this = this;
        var homeWins = [];
        var draws = [];
        var awayWins = [];
        for (var _i = 0, odds_1 = odds; _i < odds_1.length; _i++) {
            var item = odds_1[_i];
            if (+item.name[0] > +item.name[2])
                homeWins.push(item);
            else if (+item.name[0] === +item.name[2])
                draws.push(item);
            else if (+item.name[0] < +item.name[2])
                awayWins.push(item);
        }
        var homeWinsSorted = homeWins.sort(function (a, b) {
            if (+a.name[0] === +b.name[0])
                return +a.name[2] - +b.name[2];
            else
                return +a.name[0] - +b.name[0];
        });
        var drawsSorted = draws.sort(function (a, b) {
            if (+a.name[0] === +b.name[0])
                return +a.name[2] - +b.name[2];
            else
                return +a.name[0] - +b.name[0];
        });
        var awayWinsSorted = awayWins.sort(function (a, b) {
            if (+a.name[0] === +b.name[0])
                return +a.name[2] - +b.name[2];
            else
                return +a.name[0] - +b.name[0];
        });
        var homeWinsResults = [];
        var drawsResults = [];
        var awayWinsResults = [];
        var _loop_1 = function (home) {
            homeWinsResults.push(React.createElement("div", { key: homeWinsResults.length, className: (home.name === Main_1.Main.Instance.Fantasy.selectedResult[position]) ? 'score-and-odds-colored' : 'score-and-odds', onClick: function () {
                    _this.setScore(position, home.name),
                        Utils.setCorrectScoresResult(home, matchId, homeTeam, awayTeam, position);
                } },
                React.createElement("span", null,
                    React.createElement("b", null, home.name)),
                React.createElement("span", null,
                    React.createElement("i", null, home.odds))));
        };
        for (var _a = 0, homeWinsSorted_1 = homeWinsSorted; _a < homeWinsSorted_1.length; _a++) {
            var home = homeWinsSorted_1[_a];
            _loop_1(home);
        }
        var _loop_2 = function (draw) {
            drawsResults.push(React.createElement("div", { key: drawsResults.length, className: (draw.name === Main_1.Main.Instance.Fantasy.selectedResult[position]) ? 'score-and-odds-draw-colored' : 'score-and-odds-draw', onClick: function () {
                    _this.setScore(position, draw.name),
                        Utils.setCorrectScoresResult(draw, matchId, homeTeam, awayTeam, position);
                } },
                React.createElement("span", null,
                    React.createElement("b", null, draw.name)),
                React.createElement("span", null,
                    React.createElement("i", null, draw.odds))));
        };
        for (var _b = 0, drawsSorted_1 = drawsSorted; _b < drawsSorted_1.length; _b++) {
            var draw = drawsSorted_1[_b];
            _loop_2(draw);
        }
        if (screen.width > 768) {
            for (var i = draws.length; i < homeWins.length; i++) {
                drawsResults.push(React.createElement("div", { key: drawsResults.length, className: "score-and-odds-draw hover-disabled" },
                    React.createElement("span", null),
                    React.createElement("span", null)));
            }
        }
        var _loop_3 = function (away) {
            awayWinsResults.push(React.createElement("div", { key: awayWinsResults.length, className: (away.name === Main_1.Main.Instance.Fantasy.selectedResult[position]) ? 'score-and-odds-colored' : 'score-and-odds', onClick: function () {
                    _this.setScore(position, away.name),
                        Utils.setCorrectScoresResult(away, matchId, homeTeam, awayTeam, position);
                } },
                React.createElement("span", null,
                    React.createElement("b", null, away.name)),
                React.createElement("span", null,
                    React.createElement("i", null, away.odds))));
        };
        for (var _c = 0, awayWinsSorted_1 = awayWinsSorted; _c < awayWinsSorted_1.length; _c++) {
            var away = awayWinsSorted_1[_c];
            _loop_3(away);
        }
        return (React.createElement("div", { className: "correctscore-third" },
            React.createElement("div", { className: "correctscore-40" },
                React.createElement("div", { className: "correctscore-results" },
                    React.createElement("div", { className: "team-win", onClick: function () { return (screen.width <= 768) ? _this.updateHomeDrawAway(position, 1) : null; } }, "Team 1 to win"),
                    (this.state.homeDrawAway[position] === 1 || this.state.homeDrawAway[position] === 4) ?
                        React.createElement("div", { style: { padding: '0' } }, homeWinsResults)
                        : null)),
            React.createElement("div", { className: "correctscore-20" },
                React.createElement("div", { className: "correctscore-results" },
                    React.createElement("div", { className: "team-win-draw", onClick: function () { return (screen.width <= 768) ? _this.updateHomeDrawAway(position, 2) : null; } }, "Draw"),
                    (this.state.homeDrawAway[position] === 2 || this.state.homeDrawAway[position] === 4) ? React.createElement("div", { style: { padding: '0' } }, drawsResults) : null)),
            React.createElement("div", { className: "correctscore-40" },
                React.createElement("div", { className: "correctscore-results" },
                    React.createElement("div", { className: "team-win", onClick: function () { return (screen.width <= 768) ? _this.updateHomeDrawAway(position, 3) : null; } }, "Team 2 to win"),
                    (this.state.homeDrawAway[position] === 3 || this.state.homeDrawAway[position] === 4) ? React.createElement("div", { style: { padding: '0' } }, awayWinsResults) : null))));
    };
    Bet1.prototype.updateHomeDrawAway = function (position, type) {
        var state = this.state.homeDrawAway;
        if (state[position] === type)
            state[position] = 0;
        else
            state[position] = type;
        this.setState({ homeDrawAway: state });
    };
    Bet1.prototype.closeMatches = function () {
        var matches = socket_init_1.default.Get('matches');
        for (var _i = 0, _a = matches.matches; _i < _a.length; _i++) {
            var match = _a[_i];
            match.open = false;
        }
        socket_init_1.default.Set('matches', matches);
    };
    Bet1.prototype.deleteScore = function (result) {
        if (result) {
            var index = Main_1.Main.Instance.Fantasy.chosenResults.correctScores.indexOf(result);
            Main_1.Main.Instance.Fantasy.chosenResults.correctScores.splice(index, 1);
            Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: Main_1.Main.Instance.Fantasy.chosenResults });
            localStorage.setItem('chosenResults', JSON.stringify(Main_1.Main.Instance.Fantasy.chosenResults));
        }
    };
    Bet1.prototype.checkWin = function (result) {
        if (result.correctScore.name[0] > result.correctScore.name[2])
            return 1;
        else if (result.correctScore.name[0] === result.correctScore.name[2])
            return 0;
        else
            return 2;
    };
    Bet1.prototype.setMatches = function () {
        var _this = this;
        var matchesReturn = [];
        var matches = socket_init_1.default.Get('matches').matches;
        var _loop_4 = function (i) {
            var homeWin = (matches[i].odds.correctScore.find(function (elt) { return elt.name === '1-0'; })).odds1X2.toFixed(2);
            var draw = (matches[i].odds.correctScore.find(function (elt) { return elt.name === '0-0'; })).odds1X2.toFixed(2);
            var awayWin = (matches[i].odds.correctScore.find(function (elt) { return elt.name === '0-1'; })).odds1X2.toFixed(2);
            var chosenResult = (Main_1.Main.Instance.Fantasy.chosenResults) ? Main_1.Main.Instance.Fantasy.chosenResults.correctScores.find(function (elt) { return +elt.matchId === +matches[i].matchId && elt.correctScore.name === Main_1.Main.Instance.Fantasy.selectedResult[i]; }) : null;
            var winner = (chosenResult) ? this_1.checkWin(chosenResult) : null;
            var utcDate = moment.utc(matches[i].date);
            matchesReturn.push(React.createElement("ul", { key: i.toString(), className: "versus-ul" },
                this_1.returnDate(i, matches[i], matches[i - 1]),
                React.createElement("li", { className: "content-li no-value", style: (chosenResult || matches[i].open) ? { marginBottom: '0' } : { marginBottom: '20px' } },
                    React.createElement("div", { className: "value-reset-btn", style: { color: '#000', top: '0px' } },
                        React.createElement("span", { className: "match-odds", style: (winner === 1) ? { color: 'rgb(41, 160, 0)', float: 'left' } : { float: 'left' }, onClick: function () { return setVisible(i); } }, 'To Win: ' + homeWin),
                        React.createElement("span", { className: "match-odds", style: (winner === 0) ? { color: 'rgb(41, 160, 0)' } : null, onClick: function () { return setVisible(i); } },
                            "Draw: ",
                            draw),
                        React.createElement("span", { className: "match-odds", style: (winner === 2) ? { color: 'rgb(41, 160, 0)', float: 'right', marginRight: '5px' } : { float: 'right', marginRight: '5px' }, onClick: function () { return setVisible(i); } }, 'To Win: ' + awayWin)),
                    (chosenResult) ?
                        React.createElement("div", { className: "reset-button", onClick: function () {
                                _this.deleteScore(chosenResult),
                                    Main_1.Main.Instance.Fantasy.selectedResult[i] = '---',
                                    Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedResult: Main_1.Main.Instance.Fantasy.selectedResult }),
                                    localStorage.setItem('selectedResult', JSON.stringify(Main_1.Main.Instance.Fantasy.selectedResult));
                            } },
                            React.createElement("img", { src: "cancel.svg" }))
                        : null,
                    React.createElement("div", { className: "team" },
                        React.createElement("span", { style: { cursor: 'pointer' }, className: "flag flag-lg-max", onClick: function () {
                                _this.setState({ popup: true, team: matches[i].homeTeam, homeAway: 1 }),
                                    socket_init_1.default.Send('get-last-matches-info', { homeId: +matches[i].homeId,
                                        awayId: +matches[i].awayId });
                            } },
                            React.createElement("img", { src: 'data:image/png;base64,' + matches[i].homeLogo, alt: "" })),
                        React.createElement("span", { className: "country-name", style: {
                                verticalAlign: 'middle',
                                cursor: 'pointer',
                                display: 'inline-block',
                                maxWidth: '60%',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }, onClick: function () {
                                _this.setState({ popup: true, team: matches[i].homeTeam, homeAway: 1 }),
                                    socket_init_1.default.Send('get-last-matches-info', { homeId: +matches[i].homeId,
                                        awayId: +matches[i].awayId });
                            } }, matches[i].homeTeam),
                        React.createElement("span", { className: "info-button", onClick: function () {
                                _this.setState({ popup: true, team: matches[i].homeTeam, homeAway: 1 }),
                                    socket_init_1.default.Send('get-last-matches-info', { homeId: +matches[i].homeId,
                                        awayId: +matches[i].awayId });
                            } },
                            React.createElement("img", { style: { width: '18px', height: '18px', cursor: 'pointer' }, src: "info.png" }),
                            React.createElement("span", { className: "tooltip-text tooltip-text-right" }, "View Stats"))),
                    React.createElement("div", { className: "input", onClick: function () { return setVisible(i); } },
                        React.createElement("input", { className: "form-control circular-input", style: { cursor: 'pointer' }, disabled: true, placeholder: Main_1.Main.Instance.Fantasy.selectedResult[i][0] /*(chosenResult) ? ((chosenResult.correctScore.name === 'Others') ? 'X' : chosenResult.correctScore.name[0]) : '-'*/ })),
                    React.createElement("div", { className: "match-time" }, utcDate.local().format('LT')),
                    React.createElement("div", { className: "input", onClick: function () { return setVisible(i); } },
                        React.createElement("input", { className: "form-control circular-input", style: { cursor: 'pointer' }, disabled: true, placeholder: Main_1.Main.Instance.Fantasy.selectedResult[i][2] /*(chosenResult) ? ((chosenResult.correctScore.name === 'Others') ? 'X' : chosenResult.correctScore.name[2]) : '-'*/ })),
                    React.createElement("div", { className: "team second-team" },
                        React.createElement("span", { style: { cursor: 'pointer' }, className: "flag flag-lg-max", onClick: function () {
                                _this.setState({ popup: true, team: matches[i].awayTeam, homeAway: 2 }),
                                    socket_init_1.default.Send('get-last-matches-info', { homeId: +matches[i].homeId,
                                        awayId: +matches[i].awayId });
                            } },
                            React.createElement("img", { src: 'data:image/png;base64,' + matches[i].awayLogo, alt: "" })),
                        React.createElement("span", { className: "info-button-right", onClick: function () {
                                _this.setState({ popup: true, team: matches[i].awayTeam, homeAway: 2 }),
                                    socket_init_1.default.Send('get-last-matches-info', { homeId: +matches[i].homeId,
                                        awayId: +matches[i].awayId });
                            } },
                            React.createElement("img", { style: { width: '18px', height: '18px', cursor: 'pointer' }, src: "info.png" }),
                            React.createElement("span", { className: "tooltip-text tooltip-text-left" }, "View Stats")),
                        React.createElement("span", { className: "country-name", style: {
                                verticalAlign: 'middle',
                                cursor: 'pointer',
                                display: 'inline-block',
                                maxWidth: '60%',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }, onClick: function () {
                                _this.setState({ popup: true, team: matches[i].awayTeam, homeAway: 2 }),
                                    socket_init_1.default.Send('get-last-matches-info', { homeId: +matches[i].homeId,
                                        awayId: +matches[i].awayId });
                            } }, matches[i].awayTeam)),
                    (chosenResult) ?
                        React.createElement("div", { className: "value-reset-btn value-reset-btn-bottom", style: { color: 'rgb(41, 160, 0)', cursor: 'none' } },
                            React.createElement("span", { className: "match-odds" }, 'Correct Score Odds: ' + chosenResult.correctScore.odds))
                        : null),
                (matches[i].open) ? this_1.showOddsPremier(matches[i].odds.correctScore, matches[i].matchId, matches[i].homeTeam, matches[i].awayTeam, i) : null,
                (chosenResult && !matches[i].open)
                    ?
                        React.createElement("div", { className: "chosen-result" },
                            '1X2 Points: ',
                            React.createElement("b", null, chosenResult.correctScore.odds1X2.toFixed(2)),
                            "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0",
                            'Correct Score Bonus: ',
                            React.createElement("b", null, chosenResult.correctScore.bonus))
                    :
                        null));
        };
        var this_1 = this;
        for (var i = 0; i < matches.length; i++) {
            _loop_4(i);
        }
        return matchesReturn;
    };
    Bet1.prototype.showPopup = function () {
        var _this = this;
        var lastMatches = socket_init_1.default.Get('get-last-matches-info');
        if (lastMatches.loading !== 'loaded') {
            return React.createElement(Loader_1.default, null);
        }
        else {
            var screenPosition = document.documentElement.scrollTop + 50;
            var top = screenPosition.toString() + 'px';
            var selectedLastMatches = lastMatches.teamInfo;
            var logo = (this.state.homeAway === 1) ? selectedLastMatches.homeLogo : selectedLastMatches.awayLogo;
            var form = (this.state.homeAway === 1) ? selectedLastMatches.homeForm : selectedLastMatches.awayForm;
            var last5Home = (this.state.homeAway === 1) ? selectedLastMatches.last5HomeTeam1 : selectedLastMatches.last5HomeTeam2;
            var last5Away = (this.state.homeAway === 1) ? selectedLastMatches.last5AwayTeam1 : selectedLastMatches.last5AwayTeam2;
            var PLData = (this.state.homeAway === 1) ? selectedLastMatches.homePLData : selectedLastMatches.awayPLData;
            return (React.createElement("div", { className: "popup" },
                React.createElement("div", { className: "popup-inner", style: { top: top, maxHeight: '700px', overflow: 'scroll' } },
                    React.createElement("div", { className: "team-info" },
                        React.createElement("div", { style: { marginBottom: '20px', position: 'relative' } },
                            React.createElement("span", { style: { width: '10%', marginRight: '20px' } },
                                React.createElement("img", { src: 'data:image/png;base64,' + logo, style: { width: '70px', height: '60px' } })),
                            React.createElement("span", { className: "team-info-name" }, this.state.team.toUpperCase()),
                            React.createElement("span", { style: { width: '10%' }, className: "team-info-close" },
                                React.createElement("img", { src: "cancel.svg", style: { width: '30px', height: '30px' }, onClick: function () { return _this.setState({ popup: false, allMatches: false }); } }))),
                        React.createElement("div", { className: "team-info-form" },
                            React.createElement("span", null, "Form: "),
                            React.createElement("span", null,
                                React.createElement("img", { src: this.getFormIcon(form[0]) })),
                            React.createElement("span", null,
                                React.createElement("img", { src: this.getFormIcon(form[1]) })),
                            React.createElement("span", null,
                                React.createElement("img", { src: this.getFormIcon(form[2]) })),
                            React.createElement("span", null,
                                React.createElement("img", { src: this.getFormIcon(form[3]) })),
                            React.createElement("span", null,
                                React.createElement("img", { src: this.getFormIcon(form[4]) }))),
                        React.createElement("div", { className: "last-matches", style: { marginBottom: '30px' } },
                            React.createElement("p", null, "Recent H2H Results"),
                            this.setLastMatches(selectedLastMatches.lastH2H)),
                        React.createElement("div", { className: "last-matches", style: { marginBottom: '30px' } },
                            React.createElement("p", null, "Recent Premier League Results"),
                            React.createElement("div", { className: "pl-overall-info" },
                                React.createElement("div", null,
                                    React.createElement("span", null, "Matches played:"),
                                    React.createElement("span", null, PLData.matchesPlayed)),
                                React.createElement("div", null,
                                    React.createElement("span", null, "Goals For:"),
                                    React.createElement("span", null, PLData.goalsFor)),
                                React.createElement("div", null,
                                    React.createElement("span", null, "Goals Against:"),
                                    React.createElement("span", null, PLData.goalsAgainst)),
                                React.createElement("div", null,
                                    React.createElement("span", null, "Clean Sheets:"),
                                    React.createElement("span", null, PLData.cleanSheets)),
                                React.createElement("div", null,
                                    React.createElement("span", { onClick: function () { return _this.setState({ allMatches: !_this.state.allMatches }); } }, "View All Matches"))),
                            (this.state.allMatches) ? this.setLastMatches(PLData.matches) : null),
                        React.createElement("div", { className: "last-matches", style: { marginBottom: '30px' } },
                            React.createElement("p", null, "Last 5 Home Matches"),
                            this.setLastMatches(last5Home)),
                        React.createElement("div", { className: "last-matches", style: { marginBottom: '30px' } },
                            React.createElement("p", null, "Last 5 Away Matches"),
                            this.setLastMatches(last5Away))))));
        }
    };
    Bet1.prototype.setLastMatches = function (matches) {
        var lastH2H = [];
        for (var _i = 0, matches_1 = matches; _i < matches_1.length; _i++) {
            var match = matches_1[_i];
            lastH2H.push(React.createElement("div", { key: lastH2H.length, style: { background: (matches.indexOf(match) % 2 === 0) ? 'rgb(225, 225, 225)' : 'rgb(240, 240, 240)' } },
                React.createElement("span", { className: "last-matches-date" }, match.date),
                React.createElement("span", { className: "last-matches-competition" }, match.competition),
                React.createElement("span", { className: "last-matches-match" },
                    React.createElement("span", { className: "last-matches-match-span" }, match.homeTeam),
                    React.createElement("span", { className: "last-matches-match-span" },
                        React.createElement("b", { style: { color: 'rgb(41, 160, 0' } }, match.result)),
                    React.createElement("span", { className: "last-matches-match-span" }, match.awayTeam))));
        }
        return lastH2H;
    };
    Bet1.prototype.showCheckPoints = function () {
        var _this = this;
        var screenPosition = document.documentElement.scrollTop + 100;
        var top = screenPosition.toString() + 'px';
        return (React.createElement("div", { className: "popup" },
            React.createElement("div", { className: "popup-inner", style: { top: top } },
                React.createElement("div", { className: "check-points-system-popup" },
                    React.createElement("span", { className: "team-players-name" },
                        React.createElement("b", null, "POINTS SYSTEM")),
                    React.createElement("span", { className: "team-info-close" },
                        React.createElement("img", { src: "cancel.svg", onClick: function () { return _this.setState({ checkPoints: false }); } }))),
                React.createElement("div", { className: "check-points-system-third" },
                    React.createElement("h3", null, "Correct scores"),
                    React.createElement("p", null, "There are two parts to the points calculation in the Correct Score predictions..."),
                    React.createElement("p", null, "Part 1 - Correct win/draw/win (1X2) outcome = Earn the 1X2 odds for that selection, as points."),
                    React.createElement("p", null, "Part 2 - Correct score at full time (90mins) = Additional bonus points according to the table below;"),
                    React.createElement("p", null, "Correct score odds 1 \u2192 9.99 | 2 points"),
                    React.createElement("p", null, "Correct score odds 10 \u2192 24.99 | 3 points"),
                    React.createElement("p", null, "Correct score odds 25+ | 5 points"),
                    React.createElement("br", null),
                    React.createElement("p", null, "1X2 points are multiplied together to get the 1X2 Accumulator points."),
                    React.createElement("p", null, "Then, Correct Score bonus points are multiplied and the two totals are added together."),
                    React.createElement("p", null, "A further bonus of 3 points is awarded if the user correctly predicts the win/draw/win (1X2) outcome of all 3 selections. Or, a bonus of 9 points if the user correctly predicts all 3 correct scores!")))));
    };
    Bet1.prototype.getFormIcon = function (type) {
        switch (type) {
            case 'W':
                return 'win.png';
            case 'D':
                return 'draw.png';
            default:
                return 'loss.png';
        }
    };
    return Bet1;
}(React.Component));
exports.Bet1 = Bet1;
var Bet2 = /** @class */ (function (_super) {
    __extends(Bet2, _super);
    function Bet2(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        window.onload = function () {
            socket_init_1.default.Send('matches', { round: +localStorage.getItem('roundId') });
            Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: JSON.parse(localStorage.getItem('chosenResults')) });
            Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedResult: JSON.parse(localStorage.getItem('selectedResult')) });
            if (JSON.parse(localStorage.getItem('selectedAcc')) === null) {
                Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0] });
            }
            else {
                Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: JSON.parse(localStorage.getItem('selectedAcc')) });
            }
        };
        _this.cookies = new react_cookie_1.Cookies();
        _this.state = {
            userDropdown: false,
            popup: false,
            team: '',
            homeAway: 0,
            mobileMenu: false,
            checkPoints: false,
            allMatches: false
        };
        socket_init_1.default.Send('flags', {});
        return _this;
    }
    Bet2.prototype.render = function () {
        var _this = this;
        if (socket_init_1.default.Get('matches').loading !== 'loaded' || socket_init_1.default.Get('flags').loading !== 'loaded') {
            return React.createElement(Loader_1.default, null);
        }
        else {
            return (React.createElement("section", { className: "wrapper" },
                React.createElement("div", { className: "header", role: "banner" },
                    React.createElement("header", { className: "navbar navbar-default", style: { marginBottom: '0' } },
                        React.createElement("div", { className: "container" },
                            React.createElement("div", { className: "navbar-header" },
                                React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                    React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" })),
                                React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                    React.createElement("img", { src: Assets.logoMain, alt: "", className: "logo" })),
                                React.createElement("span", { className: "navbar-toggle user-profile-trigger" }, this.cookies.get('username'))),
                            React.createElement("nav", { className: (this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse', id: "navbar-collapse-left", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' } }, (this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)),
                            React.createElement("nav", { className: "collapse navbar-collapse", id: "user-profile" },
                                React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                                    React.createElement("li", { className: "user-nav-option" },
                                        React.createElement("div", { className: "user" },
                                            React.createElement("div", { className: "user-info-wrap" },
                                                " ",
                                                React.createElement("span", { className: "user-name" }, this.cookies.get('username')),
                                                React.createElement("div", { className: "balance-info" },
                                                    " Balance",
                                                    React.createElement("span", { className: "text-primary" }, "5,000 \u20AC "),
                                                    React.createElement("a", { href: "javascript:void(0);" },
                                                        React.createElement("i", { className: "icon-plus-circular" })))))),
                                    (this.cookies.get('username')) ?
                                        React.createElement("li", { className: (this.state.userDropdown === true) ? 'dropdown open' : 'dropdown' },
                                            React.createElement("a", { href: "javascript:void(0);", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (this.state.userDropdown) ? 'true' : 'false' },
                                                React.createElement("i", { className: "icon-menu-dots", onClick: function () { return _this.setState({ userDropdown: !_this.state.userDropdown }); } })),
                                            React.createElement("ul", { className: "dropdown-menu" },
                                                React.createElement("li", null,
                                                    React.createElement(react_router_dom_1.Link, { to: "/myprofile" },
                                                        React.createElement("i", { className: "icon-profile" }),
                                                        "MY PROFILE")),
                                                React.createElement("li", { onClick: function () { return Utils.logout(); } },
                                                    React.createElement(react_router_dom_1.Link, { to: "/login" },
                                                        React.createElement("i", { className: "icon-logout" }),
                                                        "LOGOUT"))))
                                        :
                                            null))))),
                React.createElement("div", { className: "info-ribbon" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "h4 text-center" }, 'GAMEWEEK ' + localStorage.getItem('roundId')))),
                React.createElement("main", { className: "main" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "step-numbers" },
                            React.createElement("ul", { className: "" },
                                React.createElement("li", { className: "active completed" },
                                    React.createElement("span", { "data-li": "1" },
                                        React.createElement("b", null, "1")),
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Correct Score"))),
                                React.createElement("li", { className: "active" },
                                    React.createElement("span", { "data-li": "2" },
                                        React.createElement("b", null, "2")),
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Goal Markets"))),
                                React.createElement("li", { className: " " },
                                    React.createElement("span", { "data-li": "3" },
                                        React.createElement("b", null, "3")),
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Goalscorers"))))),
                        React.createElement("h1", { className: "section-heading-main" },
                            " GOAL ",
                            React.createElement("span", { className: "brod-text" }, "MARKETS")),
                        React.createElement("p", { className: "text-center", style: { fontSize: '20px', color: 'rgb(41, 160, 0)' } }, "*Predict a goal markets outcome for any 3 fixtures"),
                        React.createElement("div", { className: "listing-section" },
                            this.setAccumulator(),
                            React.createElement("div", { className: "clearfix" }),
                            (Main_1.Main.Instance.Fantasy.chosenResults.accumulator && Main_1.Main.Instance.Fantasy.chosenResults.accumulator.length > 0) ?
                                React.createElement("div", { className: "row equal-height-wrapper mB10" },
                                    React.createElement("div", { className: "possible-total" },
                                        React.createElement("span", { className: "possible-total-green-background" },
                                            React.createElement("img", { src: "info-white.png", onClick: function () { return _this.setState({ checkPoints: true }); } }),
                                            React.createElement("b", null, "Accumulator points")),
                                        React.createElement("span", { className: "possible-total-white-background" },
                                            React.createElement("b", null, this.calculatePossibleTotal().toFixed(2)))))
                                : null,
                            React.createElement("div", { className: "row btn-wrapper mT20", style: { width: '75%', margin: '0 auto' } }, (this.props.location.state.showConfirmButton === false)
                                ?
                                    React.createElement("div", null,
                                        React.createElement("div", { className: "col-sm-6" },
                                            React.createElement(react_router_dom_1.Link, { to: { pathname: '/confirmation', state: { showConfirmButton: this.props.location.state.showConfirmButton } }, className: "btn-default btn-lg no-shadow btn-block btn" }, "BACK")),
                                        React.createElement("div", { className: "col-sm-6" }, (Main_1.Main.Instance.Fantasy.chosenResults.accumulator && Main_1.Main.Instance.Fantasy.chosenResults.accumulator.length === 3) ?
                                            React.createElement(react_router_dom_1.Link, { to: { pathname: '/confirmation', state: { showConfirmButton: this.props.location.state.showConfirmButton } }, className: "btn-primary btn-lg no-shadow btn-block btn", onClick: function () { return updateBet(+_this.cookies.get('playerId')); } }, "SAVE")
                                            :
                                                React.createElement("a", { className: "btn-primary btn-lg no-shadow btn-block btn", onClick: function () { return ((Main_1.Main.Instance.Fantasy.chosenResults.accumulator === undefined || Main_1.Main.Instance.Fantasy.chosenResults.accumulator.length === 0) ? alert('You haven\'t selected any match.') : alert('You have selected only ' + checkNumber('accumulator'))); } }, "SAVE")))
                                :
                                    React.createElement("div", null,
                                        React.createElement("div", { className: "col-sm-6" },
                                            React.createElement(react_router_dom_1.Link, { to: { pathname: '/betstep1', state: { showConfirmButton: this.props.location.state.showConfirmButton } }, className: "btn-default btn-lg no-shadow btn-block btn" }, "BACK")),
                                        React.createElement("div", { className: "col-sm-6" }, Main_1.Main.Instance.Fantasy.chosenResults.accumulator && Main_1.Main.Instance.Fantasy.chosenResults.accumulator.length === 3 ?
                                            React.createElement(react_router_dom_1.Link, { className: "btn-primary btn-lg no-shadow btn-block btn", to: { pathname: '/betstep3', state: { showConfirmButton: true } } }, "CONTINUE")
                                            :
                                                React.createElement("a", { className: "btn-primary btn-lg no-shadow btn-block btn", onClick: function () { return ((Main_1.Main.Instance.Fantasy.chosenResults.accumulator === undefined || Main_1.Main.Instance.Fantasy.chosenResults.accumulator.length === 0) ? alert('You haven\'t selected any match.') : alert('You have selected only ' + checkNumber('accumulator'))); } }, "CONTINUE")))))),
                    (this.state.popup) ? this.showPopup() : null,
                    (this.state.checkPoints) ? this.showCheckPoints() : null)));
        }
    };
    Bet2.prototype.calculatePossibleTotal = function () {
        var possibleTotal = 1;
        for (var _i = 0, _a = Main_1.Main.Instance.Fantasy.chosenResults.accumulator; _i < _a.length; _i++) {
            var acc = _a[_i];
            possibleTotal *= acc.correctScore.odds;
        }
        return possibleTotal;
    };
    Bet2.prototype.setAccumulator = function () {
        var _this = this;
        var matchesReturn = [];
        var matches = Object.assign(socket_init_1.default.Get('matches')).matches;
        var _loop_5 = function (i) {
            matchesReturn.push(React.createElement("div", { key: i.toString(), className: "row equal-height-wrapper mB10" },
                React.createElement("div", { className: "equal-height-col acc-column" },
                    React.createElement("div", { className: "white-box", style: { padding: '10px' } },
                        React.createElement("div", { className: "match-team" },
                            React.createElement("span", { style: { cursor: 'pointer' }, className: "flag flag-lg-max", onClick: function () {
                                    _this.setState({ popup: true, team: matches[i].homeTeam, homeAway: 1 }),
                                        socket_init_1.default.Send('get-last-matches-info', { homeId: +matches[i].homeId,
                                            awayId: +matches[i].awayId });
                                } },
                                React.createElement("img", { src: 'data:image/png;base64,' + matches[i].homeLogo, alt: "" })),
                            React.createElement("span", { className: "team-name", style: { cursor: 'pointer' }, onClick: function () {
                                    _this.setState({ popup: true, team: matches[i].homeTeam, homeAway: 1 }),
                                        socket_init_1.default.Send('get-last-matches-info', { homeId: +matches[i].homeId,
                                            awayId: +matches[i].awayId });
                                } }, matches[i].homeTeam),
                            React.createElement("span", { className: "info-button info-button-acc", onClick: function () {
                                    _this.setState({ popup: true, team: matches[i].homeTeam, homeAway: 1 }),
                                        socket_init_1.default.Send('get-last-matches-info', { homeId: +matches[i].homeId,
                                            awayId: +matches[i].awayId });
                                } },
                                React.createElement("img", { style: { width: '18px', height: '18px', cursor: 'pointer' }, src: "info.png" }),
                                React.createElement("span", { className: "tooltip-text tooltip-text-right" }, "View Stats"))),
                        React.createElement("div", { className: "versus" },
                            React.createElement("span", null, "vs")),
                        React.createElement("div", { className: "match-team", style: { textAlign: 'right' } },
                            React.createElement("span", { className: "info-button-right info-button-acc", onClick: function () {
                                    _this.setState({ popup: true, team: matches[i].awayTeam, homeAway: 2 }),
                                        socket_init_1.default.Send('get-last-matches-info', { homeId: +matches[i].homeId,
                                            awayId: +matches[i].awayId });
                                } },
                                React.createElement("img", { style: { width: '18px', height: '18px', cursor: 'pointer' }, src: "info.png" }),
                                React.createElement("span", { className: "tooltip-text tooltip-text-left" }, "View Stats")),
                            React.createElement("span", { className: "team-name", style: { cursor: 'pointer' }, onClick: function () {
                                    _this.setState({ popup: true, team: matches[i].awayTeam, homeAway: 2 }),
                                        socket_init_1.default.Send('get-last-matches-info', { homeId: +matches[i].homeId,
                                            awayId: +matches[i].awayId });
                                } }, matches[i].awayTeam),
                            React.createElement("span", { className: "flag flag-lg-max", style: { float: 'right', marginRight: '0', marginLeft: '20px', cursor: 'pointer' }, onClick: function () {
                                    _this.setState({ popup: true, team: matches[i].awayTeam, homeAway: 2 }),
                                        socket_init_1.default.Send('get-last-matches-info', { homeId: +matches[i].homeId,
                                            awayId: +matches[i].awayId });
                                } },
                                React.createElement("img", { src: 'data:image/png;base64,' + matches[i].awayLogo, alt: "" }))),
                        React.createElement("div", { className: "checkbox-section display-table" },
                            React.createElement("div", { className: "table-row" },
                                React.createElement("div", { className: ((Main_1.Main.Instance.Fantasy.selectedAcc[i] === 2)) ? 'accumulator-colored' : 'accumulator' },
                                    React.createElement("a", { className: "accumulator-name", onClick: function () { Utils.setAccumulatorOver(matches[i].odds.accumulator.over, matches[i].matchId, i, 2, matches[i].homeTeam, matches[i].awayTeam); } },
                                        React.createElement("b", null, "Over 2.5 goals")),
                                    React.createElement("a", { className: "accumulator-odds", onClick: function () { Utils.setAccumulatorOver(matches[i].odds.accumulator.over, matches[i].matchId, i, 2, matches[i].homeTeam, matches[i].awayTeam); } },
                                        React.createElement("b", null, matches[i].odds.accumulator.over.odds.toString()))),
                                React.createElement("div", { className: ((Main_1.Main.Instance.Fantasy.selectedAcc[i] === 3)) ? 'accumulator-colored' : 'accumulator' },
                                    React.createElement("a", { className: "accumulator-name", onClick: function () { Utils.setAccumulatorUnder(matches[i].odds.accumulator.under, matches[i].matchId, i, 3, matches[i].homeTeam, matches[i].awayTeam); } },
                                        React.createElement("b", null, "Under 2.5 goals")),
                                    React.createElement("a", { className: "accumulator-odds", onClick: function () { Utils.setAccumulatorUnder(matches[i].odds.accumulator.under, matches[i].matchId, i, 3, matches[i].homeTeam, matches[i].awayTeam); } },
                                        React.createElement("b", null, matches[i].odds.accumulator.under.odds.toString())))),
                            React.createElement("div", { className: "table-row" },
                                React.createElement("div", { className: (Main_1.Main.Instance.Fantasy.selectedAcc[i] === 1) ? 'accumulator-colored' : 'accumulator' },
                                    React.createElement("a", { className: "accumulator-name", onClick: function () { Utils.setAccumulatorBtts(matches[i].odds.accumulator.btts, matches[i].matchId, i, 1, matches[i].homeTeam, matches[i].awayTeam); } },
                                        React.createElement("b", null, "Both"),
                                        " ",
                                        React.createElement("b", { className: "mobile-hide" }, "Teams"),
                                        " ",
                                        React.createElement("b", null, "to Score")),
                                    React.createElement("a", { className: "accumulator-odds", onClick: function () { Utils.setAccumulatorBtts(matches[i].odds.accumulator.btts, matches[i].matchId, i, 1, matches[i].homeTeam, matches[i].awayTeam); } },
                                        React.createElement("b", null, matches[i].odds.accumulator.btts.odds.toString()))),
                                React.createElement("div", { className: (Main_1.Main.Instance.Fantasy.selectedAcc[i] === 4) ? 'accumulator-colored' : 'accumulator' },
                                    React.createElement("a", { className: "accumulator-name", onClick: function () { Utils.setAccumulatorDraw(matches[i].odds.accumulator.draw, matches[i].matchId, i, 4, matches[i].homeTeam, matches[i].awayTeam); } },
                                        React.createElement("b", null, "Draw in 90 mins")),
                                    React.createElement("a", { className: "accumulator-odds", onClick: function () { Utils.setAccumulatorDraw(matches[i].odds.accumulator.draw, matches[i].matchId, i, 4, matches[i].homeTeam, matches[i].awayTeam); } },
                                        React.createElement("b", null, matches[i].odds.accumulator.draw.odds.toString())))))))));
        };
        for (var i = 0; i < matches.length; i++) {
            _loop_5(i);
        }
        return matchesReturn;
    };
    Bet2.prototype.showPopup = function () {
        var _this = this;
        var lastMatches = socket_init_1.default.Get('get-last-matches-info');
        if (lastMatches.loading !== 'loaded') {
            return React.createElement(Loader_1.default, null);
        }
        else {
            var screenPosition = document.documentElement.scrollTop + 50;
            var top = screenPosition.toString() + 'px';
            var selectedLastMatches = lastMatches.teamInfo;
            var logo = (this.state.homeAway === 1) ? selectedLastMatches.homeLogo : selectedLastMatches.awayLogo;
            var form = (this.state.homeAway === 1) ? selectedLastMatches.homeForm : selectedLastMatches.awayForm;
            var last5Home = (this.state.homeAway === 1) ? selectedLastMatches.last5HomeTeam1 : selectedLastMatches.last5HomeTeam2;
            var last5Away = (this.state.homeAway === 1) ? selectedLastMatches.last5AwayTeam1 : selectedLastMatches.last5AwayTeam2;
            var PLData = (this.state.homeAway === 1) ? selectedLastMatches.homePLData : selectedLastMatches.awayPLData;
            return (React.createElement("div", { className: "popup" },
                React.createElement("div", { className: "popup-inner", style: { top: top, maxHeight: '700px', overflow: 'scroll' } },
                    React.createElement("div", { className: "team-info" },
                        React.createElement("div", { style: { marginBottom: '20px', position: 'relative' } },
                            React.createElement("span", { style: { width: '10%', marginRight: '20px' } },
                                React.createElement("img", { src: 'data:image/png;base64,' + logo, style: { width: '70px', height: '60px' } })),
                            React.createElement("span", { className: "team-info-name" }, this.state.team.toUpperCase()),
                            React.createElement("span", { style: { width: '10%' }, className: "team-info-close" },
                                React.createElement("img", { src: "cancel.svg", style: { width: '30px', height: '30px' }, onClick: function () { return _this.setState({ popup: false, allMatches: false }); } }))),
                        React.createElement("div", { className: "team-info-form" },
                            React.createElement("span", null, "Form: "),
                            React.createElement("span", null,
                                React.createElement("img", { src: this.getFormIcon(form[0]) })),
                            React.createElement("span", null,
                                React.createElement("img", { src: this.getFormIcon(form[1]) })),
                            React.createElement("span", null,
                                React.createElement("img", { src: this.getFormIcon(form[2]) })),
                            React.createElement("span", null,
                                React.createElement("img", { src: this.getFormIcon(form[3]) })),
                            React.createElement("span", null,
                                React.createElement("img", { src: this.getFormIcon(form[4]) }))),
                        React.createElement("div", { className: "last-matches", style: { marginBottom: '30px' } },
                            React.createElement("p", null, "Recent H2H Results"),
                            this.setLastMatches(selectedLastMatches.lastH2H)),
                        React.createElement("div", { className: "last-matches", style: { marginBottom: '30px' } },
                            React.createElement("p", null, "Recent Premier League Results"),
                            React.createElement("div", { className: "pl-overall-info" },
                                React.createElement("div", null,
                                    React.createElement("span", null, "Matches played:"),
                                    React.createElement("span", null, PLData.matchesPlayed)),
                                React.createElement("div", null,
                                    React.createElement("span", null, "Goals For:"),
                                    React.createElement("span", null, PLData.goalsFor)),
                                React.createElement("div", null,
                                    React.createElement("span", null, "Goals Against:"),
                                    React.createElement("span", null, PLData.goalsAgainst)),
                                React.createElement("div", null,
                                    React.createElement("span", null, "Clean Sheets:"),
                                    React.createElement("span", null, PLData.cleanSheets)),
                                React.createElement("div", null,
                                    React.createElement("span", { onClick: function () { return _this.setState({ allMatches: !_this.state.allMatches }); } }, "View All Matches"))),
                            (this.state.allMatches) ? this.setLastMatches(PLData.matches) : null),
                        React.createElement("div", { className: "last-matches", style: { marginBottom: '30px' } },
                            React.createElement("p", null, "Last 5 Home Matches"),
                            this.setLastMatches(last5Home)),
                        React.createElement("div", { className: "last-matches", style: { marginBottom: '30px' } },
                            React.createElement("p", null, "Last 5 Away Matches"),
                            this.setLastMatches(last5Away))))));
        }
    };
    Bet2.prototype.setLastMatches = function (matches) {
        var lastH2H = [];
        for (var _i = 0, matches_2 = matches; _i < matches_2.length; _i++) {
            var match = matches_2[_i];
            lastH2H.push(React.createElement("div", { key: lastH2H.length, style: { background: (matches.indexOf(match) % 2 === 0) ? 'rgb(225, 225, 225)' : 'rgb(240, 240, 240)' } },
                React.createElement("span", { className: "last-matches-date" }, match.date),
                React.createElement("span", { className: "last-matches-competition" }, match.competition),
                React.createElement("span", { className: "last-matches-match" },
                    React.createElement("span", { className: "last-matches-match-span" }, match.homeTeam),
                    React.createElement("span", { className: "last-matches-match-span" },
                        React.createElement("b", { style: { color: 'rgb(41, 160, 0' } }, match.result)),
                    React.createElement("span", { className: "last-matches-match-span" }, match.awayTeam))));
        }
        return lastH2H;
    };
    Bet2.prototype.showCheckPoints = function () {
        var _this = this;
        var screenPosition = document.documentElement.scrollTop + 100;
        var top = screenPosition.toString() + 'px';
        return (React.createElement("div", { className: "popup" },
            React.createElement("div", { className: "popup-inner", style: { top: top } },
                React.createElement("div", { className: "check-points-system-popup" },
                    React.createElement("span", { className: "team-players-name" },
                        React.createElement("b", null, "POINTS SYSTEM")),
                    React.createElement("span", { className: "team-info-close" },
                        React.createElement("img", { src: "cancel.svg", onClick: function () { return _this.setState({ checkPoints: false }); } }))),
                React.createElement("div", { className: "check-points-system-third" },
                    React.createElement("h3", null, "Goal markets"),
                    React.createElement("p", null, "User will earn the decimal odds of each correct selection, as points. Points from each correct selection are multiplied together to give a Goal Markets total."),
                    React.createElement("p", null, "A further bonus of 3 points is awarded if the user correctly predicts a goal markets outcome in all 3 selections.")))));
    };
    Bet2.prototype.getFormIcon = function (type) {
        switch (type) {
            case 'W':
                return 'win.png';
            case 'D':
                return 'draw.png';
            default:
                return 'loss.png';
        }
    };
    return Bet2;
}(React.Component));
exports.Bet2 = Bet2;
var Bet3 = /** @class */ (function (_super) {
    __extends(Bet3, _super);
    function Bet3(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        window.onload = function () {
            socket_init_1.default.Send('matches', { round: +localStorage.getItem('roundId') });
            Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: JSON.parse(localStorage.getItem('chosenResults')) });
            Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedResult: JSON.parse(localStorage.getItem('selectedResult')) });
            Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: JSON.parse(localStorage.getItem('selectedAcc')) });
        };
        _this.cookies = new react_cookie_1.Cookies();
        _this.state = {
            userDropdown: false,
            popup: false,
            player: '',
            mobileMenu: false,
            position: 0,
            team: 0,
            playerInfo: {},
            checkPoints: false
        };
        socket_init_1.default.Send('matches', { round: +localStorage.getItem('roundId') });
        socket_init_1.default.Send('flags', {});
        return _this;
    }
    Bet3.prototype.render = function () {
        var _this = this;
        if (socket_init_1.default.Get('matches').loading !== 'loaded' || socket_init_1.default.Get('flags').loading !== 'loaded') {
            return React.createElement(Loader_1.default, null);
        }
        else {
            return (React.createElement("section", { className: "wrapper" },
                React.createElement("div", { className: "header", role: "banner" },
                    React.createElement("header", { className: "navbar navbar-default", style: { marginBottom: '0' } },
                        React.createElement("div", { className: "container" },
                            React.createElement("div", { className: "navbar-header" },
                                React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                    React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" })),
                                React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                    React.createElement("img", { src: Assets.logoMain, alt: "", className: "logo" })),
                                React.createElement("span", { className: "navbar-toggle user-profile-trigger" }, this.cookies.get('username'))),
                            React.createElement("nav", { className: (this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse', id: "navbar-collapse-left", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' } }, (this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)),
                            React.createElement("nav", { className: "collapse navbar-collapse", id: "user-profile" },
                                React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                                    React.createElement("li", { className: "user-nav-option" },
                                        React.createElement("div", { className: "user" },
                                            React.createElement("div", { className: "user-info-wrap" },
                                                " ",
                                                React.createElement("span", { className: "user-name" }, this.cookies.get('username')),
                                                React.createElement("div", { className: "balance-info" },
                                                    " Balance",
                                                    React.createElement("span", { className: "text-primary" }, "5,000 \u20AC "),
                                                    React.createElement("a", { href: "javascript:void(0);" },
                                                        React.createElement("i", { className: "icon-plus-circular" })))))),
                                    (this.cookies.get('username')) ?
                                        React.createElement("li", { className: (this.state.userDropdown === true) ? 'dropdown open' : 'dropdown' },
                                            React.createElement("a", { href: "javascript:void(0);", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (this.state.userDropdown) ? 'true' : 'false' },
                                                React.createElement("i", { className: "icon-menu-dots", onClick: function () { return _this.setState({ userDropdown: !_this.state.userDropdown }); } })),
                                            React.createElement("ul", { className: "dropdown-menu" },
                                                React.createElement("li", null,
                                                    React.createElement(react_router_dom_1.Link, { to: "/myprofile" },
                                                        React.createElement("i", { className: "icon-profile" }),
                                                        "MY PROFILE")),
                                                React.createElement("li", { onClick: function () { return Utils.logout(); } },
                                                    React.createElement(react_router_dom_1.Link, { to: "/login" },
                                                        React.createElement("i", { className: "icon-logout" }),
                                                        "LOGOUT"))))
                                        :
                                            null))))),
                React.createElement("div", { className: "info-ribbon" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "h4 text-center" }, 'GAMEWEEK ' + localStorage.getItem('roundId')))),
                React.createElement("main", { className: "main" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "step-numbers" },
                            React.createElement("ul", { className: "" },
                                React.createElement("li", { className: "active completed" },
                                    React.createElement("span", { "data-li": "1" },
                                        React.createElement("b", null, "1")),
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Correct Score"))),
                                React.createElement("li", { className: "active completed" },
                                    React.createElement("span", { "data-li": "2" },
                                        React.createElement("b", null, "2")),
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Goal Markets"))),
                                React.createElement("li", { className: "active " },
                                    React.createElement("span", { "data-li": "3" },
                                        React.createElement("b", null, "3")),
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Goalscorers"))))),
                        React.createElement("h1", { className: "section-heading-main" },
                            "ANYTIME ",
                            React.createElement("span", { className: "brod-text" }, "GOALSCORERS")),
                        React.createElement("p", { className: "text-center", style: { fontSize: '20px', color: 'rgb(41, 160, 0)' } }, "*Predict any 3 players to score at any time"),
                        React.createElement("div", { className: "listing-section" },
                            this.setGoalscorers(),
                            React.createElement("div", { className: "clearfix mT10" }),
                            (Main_1.Main.Instance.Fantasy.chosenResults.goalscorers && Main_1.Main.Instance.Fantasy.chosenResults.goalscorers.length > 0) ?
                                React.createElement("div", { className: "row equal-height-wrapper" },
                                    React.createElement("div", { className: "possible-total" },
                                        React.createElement("span", { className: "possible-total-green-background" },
                                            React.createElement("img", { src: "info-white.png", onClick: function () { return _this.setState({ checkPoints: true }); } }),
                                            React.createElement("b", null, "Accumulator points")),
                                        React.createElement("span", { className: "possible-total-white-background" },
                                            React.createElement("b", null, this.calculatePossibleTotal().toFixed(2)))))
                                : null,
                            React.createElement("div", { className: "row btn-wrapper mT20", style: { width: '75%', margin: '0 auto' } }, (this.props.location.state.showConfirmButton === false)
                                ?
                                    React.createElement("div", null,
                                        React.createElement("div", { className: "col-sm-6" },
                                            React.createElement(react_router_dom_1.Link, { to: { pathname: '/confirmation', state: { showConfirmButton: this.props.location.state.showConfirmButton } }, className: "btn-default btn-lg no-shadow btn-block btn" }, "BACK")),
                                        React.createElement("div", { className: "col-sm-6" }, (Main_1.Main.Instance.Fantasy.chosenResults.goalscorers && Main_1.Main.Instance.Fantasy.chosenResults.goalscorers.length === 3) ?
                                            React.createElement(react_router_dom_1.Link, { to: { pathname: '/confirmation', state: { showConfirmButton: this.props.location.state.showConfirmButton } }, className: "btn-primary btn-lg no-shadow btn-block btn", onClick: function () { return updateBet(+_this.cookies.get('playerId')); } }, "SAVE")
                                            :
                                                React.createElement("a", { className: "btn-primary btn-lg no-shadow btn-block btn", onClick: function () { return ((Main_1.Main.Instance.Fantasy.chosenResults.goalscorers === undefined || Main_1.Main.Instance.Fantasy.chosenResults.goalscorers.length === 0) ? alert('You haven\'t selected any goalscorer.') : alert('You have selected only ' + checkNumber('goalscorers'))); } }, "SAVE")))
                                :
                                    React.createElement("div", null,
                                        React.createElement("div", { className: "col-sm-6" },
                                            React.createElement(react_router_dom_1.Link, { to: { pathname: '/betstep2', state: { showConfirmButton: this.props.location.state.showConfirmButton } }, className: "btn-default btn-lg no-shadow btn-block btn" }, "BACK")),
                                        React.createElement("div", { className: "col-sm-6" }, Main_1.Main.Instance.Fantasy.chosenResults.goalscorers && Main_1.Main.Instance.Fantasy.chosenResults.goalscorers.length === 3 ?
                                            React.createElement(react_router_dom_1.Link, { className: "btn-primary btn-lg no-shadow btn-block btn", to: (!this.cookies.get('playerId')) ? '/login' : '/inserting', onClick: function () { return _this.insertBet(); } }, "CONTINUE")
                                            :
                                                React.createElement("a", { className: "btn-primary btn-lg no-shadow btn-block btn", onClick: function () { return ((Main_1.Main.Instance.Fantasy.chosenResults.goalscorers === undefined || Main_1.Main.Instance.Fantasy.chosenResults.goalscorers.length === 0) ? alert('You haven\'t selected any goalscorer.') : alert('You have selected only ' + checkNumber('goalscorers'))); } }, "CONTINUE")))))),
                    (this.state.popup) ? this.findPlayer() : null,
                    (this.state.checkPoints) ? this.showCheckPoints() : null)));
        }
    };
    Bet3.prototype.calculatePossibleTotal = function () {
        var possibleTotal = 1;
        for (var _i = 0, _a = Main_1.Main.Instance.Fantasy.chosenResults.goalscorers; _i < _a.length; _i++) {
            var goal = _a[_i];
            if (goal.correctScore.odds < 100)
                possibleTotal *= goal.correctScore.odds;
        }
        return possibleTotal;
    };
    Bet3.prototype.setGoalscorers = function () {
        var _this = this;
        var goalscorersReturn = [];
        var matches = Object.assign(socket_init_1.default.Get('matches')).matches;
        var _loop_6 = function (i) {
            goalscorersReturn.push(React.createElement("div", { key: i.toString(), className: "row equal-height-wrapper" },
                React.createElement("div", { className: "equal-height-col goalscorers-match" },
                    React.createElement("div", { className: " advanced-versus-wrap dropdown divider display-table" },
                        React.createElement("div", { className: "table-row height-100" },
                            React.createElement("div", { className: (matches[i].open === true) ? 'advanced-versus-menu table-cell vertical-mid open' : 'advanced-versus-menu table-cell vertical-mid' },
                                React.createElement("a", { className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (matches[i].open === true) ? 'true' : 'false', onClick: function () {
                                        setVisible(i, 1),
                                            socket_init_1.default.Send('get-team-info', { teamId: +matches[i].homeId });
                                        _this.setState({ position: i, team: 1 });
                                    }, style: { cursor: 'pointer' } },
                                    React.createElement("span", { className: "flag flag-md" },
                                        React.createElement("img", { src: 'data:image/png;base64,' + matches[i].homeLogo, alt: "" })),
                                    React.createElement("i", { className: "icon-arrow-down pull-right" }),
                                    React.createElement("span", { className: "country-name" }, matches[i].homeTeam)),
                                (matches[i].open === true && matches[i].homeAway === 1) ?
                                    React.createElement("div", { className: "dropdown-menu goalscorers-dropdown" }, this_2.getMatchGoalscorers(matches[i].odds.goalscorers.homeTeam, matches[i].matchId, matches[i].homeTeam, matches[i].awayTeam, i, 1))
                                    : null),
                            React.createElement("div", { className: "vs-divider vertical-mid" },
                                React.createElement("span", null,
                                    React.createElement("span", { style: { zIndex: (this_2.state.popup || this_2.state.checkPoints) ? 0 : 1 } }, "vs"))),
                            React.createElement("div", { className: (matches[i].open === true) ? 'advanced-versus-menu table-cell vertical-mid open' : 'advanced-versus-menu table-cell vertical-mid' },
                                React.createElement("a", { className: "dropdown-toggle text-right", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (matches[i].open === true) ? 'true' : 'false', onClick: function () {
                                        setVisible(i, 2),
                                            socket_init_1.default.Send('get-team-info', { teamId: +matches[i].awayId });
                                        _this.setState({ position: i, team: 2 });
                                    }, style: { cursor: 'pointer' } },
                                    React.createElement("span", { className: "flag flag-right flag-md" },
                                        React.createElement("img", { src: 'data:image/png;base64,' + matches[i].awayLogo, alt: "" })),
                                    React.createElement("i", { className: "pull-left icon-arrow-down" }),
                                    React.createElement("span", { className: "country-name" }, matches[i].awayTeam)),
                                (matches[i].open === true && matches[i].homeAway === 2) ?
                                    React.createElement("div", { className: "dropdown-menu goalscorers-dropdown goalscorers-dropdown-away" }, this_2.getMatchGoalscorers(matches[i].odds.goalscorers.awayTeam, matches[i].matchId, matches[i].homeTeam, matches[i].awayTeam, i, 2))
                                    : null)))),
                React.createElement("div", { className: "selected-scorers selected-scorers-home" }, this_2.setSelectedScorers(matches[i].matchId, 1)),
                React.createElement("div", { className: "selected-scorers selected-scorers-away" }, this_2.setSelectedScorers(matches[i].matchId, 2))));
        };
        var this_2 = this;
        for (var i = 0; i < matches.length; i++) {
            _loop_6(i);
        }
        return goalscorersReturn;
    };
    Bet3.prototype.getMatchGoalscorers = function (odds, matchId, homeTeam, awayTeam, position, team) {
        var _this = this;
        var teamInfo = socket_init_1.default.Get('get-team-info');
        var matchGoalscorers = [];
        var goalscorers = [];
        if (teamInfo.loading === 'loaded') {
            var teamSquad_1 = teamInfo.teamInfo.squad;
            // console.log('Odds: ', odds)
            // console.log('Squad: ', teamSquad)
            var sidelined = teamInfo.teamInfo.sidelined;
            var _loop_7 = function (i) {
                if (teamSquad_1[i].position === 'G')
                    return "continue";
                var oddsFound = undefined;
                oddsFound = odds.find(function (elt) { return +elt.id === +teamSquad_1[i].id; });
                if (oddsFound) {
                    goalscorers.push({
                        id: oddsFound.id,
                        name: oddsFound.name,
                        odds: oddsFound.odds,
                        position: (teamSquad_1[i].position === 'A') ? 1 : (teamSquad_1[i].position === 'M') ? 2 : 3
                    });
                }
                else if (odds.length === 0) {
                    goalscorers.push({
                        id: +teamSquad_1[i].id,
                        name: teamSquad_1[i].name,
                        odds: 1,
                        position: (teamSquad_1[i].position === 'A') ? 1 : (teamSquad_1[i].position === 'M') ? 2 : 3
                    });
                }
            };
            for (var i = 0; i < teamSquad_1.length; i++) {
                _loop_7(i);
            }
            var sortedGoalscorers_1 = goalscorers.sort(Utils.sortF);
            var _loop_8 = function (i) {
                var set = false;
                if (Main_1.Main.Instance.Fantasy.chosenResults.goalscorers) {
                    for (var _i = 0, _a = Main_1.Main.Instance.Fantasy.chosenResults.goalscorers; _i < _a.length; _i++) {
                        var item = _a[_i];
                        if (+item.matchId === +matchId && item.correctScore.name === sortedGoalscorers_1[i].name) {
                            set = true;
                        }
                    }
                }
                if (i === 0 || (sortedGoalscorers_1[i - 1] && sortedGoalscorers_1[i - 1].position !== sortedGoalscorers_1[i].position)) {
                    matchGoalscorers.push(React.createElement("p", { key: matchGoalscorers.length, style: { fontSize: '15px', marginBottom: '0' } },
                        React.createElement("b", null, this_3.setPositionNumber(sortedGoalscorers_1[i].position))));
                }
                var injured = sidelined.find(function (elt) { return +elt.id === +sortedGoalscorers_1[i].id; });
                if (sortedGoalscorers_1[i].position !== '') {
                    matchGoalscorers.push(React.createElement("div", { key: matchGoalscorers.length, className: (set === true) ? 'accumulator-colored' : 'accumulator', style: { width: '98%' } },
                        React.createElement("a", { className: "accumulator-name accumulator-name-non-colored" },
                            React.createElement("b", { className: (injured) ? 'injured-color' : '', style: { cursor: 'pointer' }, onClick: function () {
                                    setVisible(position, team, true),
                                        _this.setState({ popup: true }),
                                        socket_init_1.default.Send('get-player-info', { playerId: +sortedGoalscorers_1[i].id, leagueId: 1204, competitionType: Assets.CompetitionTypes.League });
                                } }, (sortedGoalscorers_1[i].name)),
                            React.createElement("span", { style: { marginLeft: '6px', position: 'relative', bottom: '1px' }, onClick: function () {
                                    setVisible(position, team, true),
                                        _this.setState({ popup: true }),
                                        socket_init_1.default.Send('get-player-info', { playerId: +sortedGoalscorers_1[i].id, leagueId: 1204, competitionType: Assets.CompetitionTypes.League });
                                } },
                                React.createElement("img", { src: (set === true) ? 'info-white.png' : 'info.png' }))),
                        React.createElement("a", { className: "accumulator-odds", onClick: function () {
                                Utils.setScorers({ id: +sortedGoalscorers_1[i].id, player: sortedGoalscorers_1[i].name, odds: sortedGoalscorers_1[i].odds, outCome: 1 }, matchId, homeTeam, awayTeam, team),
                                    setVisible(position, team);
                            } },
                            React.createElement("b", null, (+sortedGoalscorers_1[i].odds > 1) ? sortedGoalscorers_1[i].odds : 'SP'))));
                }
            };
            var this_3 = this;
            for (var i = 0; i < sortedGoalscorers_1.length; i++) {
                _loop_8(i);
            }
        }
        return matchGoalscorers;
    };
    Bet3.prototype.findPlayer = function () {
        var _this = this;
        var team = socket_init_1.default.Get('get-team-info');
        var chosenPlayer = socket_init_1.default.Get('get-player-info');
        if (team.loading === 'loaded' && chosenPlayer.loading === 'loaded') {
            var playerProfile_1 = chosenPlayer.playerInfo;
            var selectedTeam = team.teamInfo;
            var screenPosition = document.documentElement.scrollTop + 100;
            var top = screenPosition.toString() + 'px';
            var injured = selectedTeam.sidelined.find(function (elt) { return +elt.id === +playerProfile_1.playerId; });
            return (React.createElement("div", { className: "popup" },
                React.createElement("div", { className: "popup-inner", style: { top: top } },
                    React.createElement("div", { className: "team-players" },
                        React.createElement("div", { style: { marginBottom: '20px', position: 'relative' } },
                            React.createElement("span", { style: { marginRight: '20px' } },
                                React.createElement("img", { src: 'data:image/png;base64,' + playerProfile_1.image, className: "player-profile-picture" })),
                            React.createElement("span", { className: "team-info-name team-info-player-name" }, playerProfile_1.name.toUpperCase()),
                            React.createElement("span", { className: "team-info-close" },
                                React.createElement("img", { src: "cancel.svg", style: { width: '30px', height: '30px' }, onClick: function () { return _this.setState({ popup: false }); } }))),
                        React.createElement("h3", null, "Profile"),
                        React.createElement("table", { className: "team-table" },
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("th", null, "Team"),
                                    React.createElement("th", null, "Position"),
                                    React.createElement("th", { className: "player-stats-hide" }, "Age"),
                                    React.createElement("th", null, "Club"),
                                    React.createElement("th", { className: "player-stats-hide" }, "Height"),
                                    React.createElement("th", { className: "player-stats-hide" }, "Weight"))),
                            React.createElement("tbody", null,
                                React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement("img", { src: 'data:image/png;base64,' + selectedTeam.logo, className: "player-team-logo" })),
                                    React.createElement("td", null, playerProfile_1.position),
                                    React.createElement("td", { className: "player-stats-hide" }, playerProfile_1.age),
                                    React.createElement("td", null, playerProfile_1.club),
                                    React.createElement("td", { className: "player-stats-hide" }, playerProfile_1.height),
                                    React.createElement("td", { className: "player-stats-hide" }, playerProfile_1.weight)))),
                        (injured) ?
                            React.createElement("div", null,
                                React.createElement("span", { style: { marginTop: '20px', fontSize: '20px', color: '#F03300' } },
                                    React.createElement("b", null, "Injury stats")),
                                React.createElement("div", { className: "injury-stats" },
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Injury: "),
                                        React.createElement("i", null, injured.description)),
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Injured from: "),
                                        React.createElement("i", null, injured.startDate)),
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Expected comeback: "),
                                        React.createElement("i", null, (injured.endDate !== '') ? injured.endDate : 'Unknown'))))
                            : null,
                        React.createElement("div", null,
                            (playerProfile_1.thisSeasonStats) ? this.setPlayerStats(playerProfile_1.thisSeasonStats) : null,
                            (playerProfile_1.lastSeasonStats) ? this.setPlayerStats(playerProfile_1.lastSeasonStats) : null)))));
        }
    };
    Bet3.prototype.setPlayerStats = function (stats) {
        return (React.createElement("div", { className: "previous-seasons" },
            React.createElement("span", null,
                React.createElement("b", null, stats.competition + ' ' + stats.season)),
            React.createElement("table", { className: "team-table" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Appearances"),
                        React.createElement("th", null, "Starts"),
                        React.createElement("th", null, "Minutes"),
                        React.createElement("th", { className: "player-stats-hide" }, "Substitutes In"),
                        React.createElement("th", { className: "player-stats-hide" }, "Substitutes Out"),
                        React.createElement("th", null, "Goals"))),
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, stats.appearances),
                        React.createElement("td", null, stats.starts),
                        React.createElement("td", null, stats.minutes),
                        React.createElement("td", { className: "player-stats-hide" }, stats.substitutesin),
                        React.createElement("td", { className: "player-stats-hide" }, stats.substitutesout),
                        React.createElement("td", null, stats.goals))))));
    };
    Bet3.prototype.showCheckPoints = function () {
        var _this = this;
        var screenPosition = document.documentElement.scrollTop + 100;
        var top = screenPosition.toString() + 'px';
        return (React.createElement("div", { className: "popup" },
            React.createElement("div", { className: "popup-inner", style: { top: top } },
                React.createElement("div", { className: "check-points-system-popup" },
                    React.createElement("span", { className: "team-players-name" },
                        React.createElement("b", null, "POINTS SYSTEM")),
                    React.createElement("span", { className: "team-info-close" },
                        React.createElement("img", { src: "cancel.svg", onClick: function () { return _this.setState({ checkPoints: false }); } }))),
                React.createElement("div", { className: "check-points-system-third" },
                    React.createElement("h3", null, "Goalscorers"),
                    React.createElement("p", null, "User will earn the decimal odds of each correct selection, as points. Points from each correct selection are multiplied together to give a Goalscorers total."),
                    React.createElement("p", null, "A further bonus of 3 points is awarded if all three of the user\u00B4s selections score 1 goal or more.")))));
    };
    Bet3.prototype.checkInjury = function (player, sidelined) {
        for (var _i = 0, sidelined_1 = sidelined; _i < sidelined_1.length; _i++) {
            var item = sidelined_1[_i];
            if (item.name === player)
                return item;
        }
    };
    Bet3.prototype.deleteScorer = function (scorer) {
        var index = Main_1.Main.Instance.Fantasy.chosenResults.goalscorers.indexOf(scorer);
        Main_1.Main.Instance.Fantasy.chosenResults.goalscorers.splice(index, 1);
        Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: Main_1.Main.Instance.Fantasy.chosenResults });
        localStorage.setItem('chosenResults', JSON.stringify(Main_1.Main.Instance.Fantasy.chosenResults));
    };
    Bet3.prototype.setSelectedScorers = function (matchId, team) {
        var _this = this;
        var selectedScorers = [];
        var goalscorers = Main_1.Main.Instance.Fantasy.chosenResults.goalscorers;
        if (goalscorers) {
            var _loop_9 = function (i) {
                if (goalscorers[i].matchId === matchId && goalscorers[i].team === team) {
                    selectedScorers.push(React.createElement("div", { className: "scorer-line", key: i.toString() },
                        React.createElement("div", { className: "name-odds" },
                            "Player: ",
                            React.createElement("b", null, goalscorers[i].correctScore.name)),
                        React.createElement("div", { className: "name-odds" },
                            React.createElement("i", null, 'Odds: ' + ((goalscorers[i].correctScore.odds < 100) ? goalscorers[i].correctScore.odds : 'SP'))),
                        React.createElement("div", { className: "clear-button", onClick: function () { return _this.deleteScorer(goalscorers[i]); } },
                            React.createElement("img", { src: "cancel-white.svg" }))));
                }
            };
            for (var i = 0; i < goalscorers.length; i++) {
                _loop_9(i);
            }
        }
        return selectedScorers;
    };
    Bet3.prototype.insertBet = function () {
        if (!this.cookies.get('playerId')) {
            alert('You will need to register to enter your predictions! Click OK to go to the sign up page.');
        }
        else {
            var playerId = +this.cookies.get('playerId');
            var roundId = +localStorage.getItem('roundId');
            var round = roundId;
            var bet = {
                playerId: playerId,
                round: round,
                correctScores: Main_1.Main.Instance.Fantasy.chosenResults.correctScores,
                accumulator: Main_1.Main.Instance.Fantasy.chosenResults.accumulator,
                goalscorers: Main_1.Main.Instance.Fantasy.chosenResults.goalscorers
            };
            socket_init_1.default.Send('insert-bet', bet);
        }
    };
    Bet3.prototype.setPositionNumber = function (position) {
        switch (position) {
            case 1:
                return 'Attackers';
            case 2:
                return 'Midfielders';
            default:
                return 'Defenders';
        }
    };
    return Bet3;
}(React.Component));
exports.Bet3 = Bet3;
var Confirmation = /** @class */ (function (_super) {
    __extends(Confirmation, _super);
    function Confirmation(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        window.onload = function () {
            Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { chosenResults: JSON.parse(localStorage.getItem('chosenResults')) });
            Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedResult: JSON.parse(localStorage.getItem('selectedResult')) });
            Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, { selectedAcc: JSON.parse(localStorage.getItem('selectedAcc')) });
        };
        _this.cookies = new react_cookie_1.Cookies();
        _this.state = {
            userDropdown: false,
            mobileMenu: false,
            popup: false,
            pointsSystem: 0,
            confirmationPopup: _this.props.location.state.showConfirmationPopup
        };
        return _this;
    }
    Confirmation.prototype.render = function () {
        var _this = this;
        if (!Main_1.Main.Instance.Fantasy.chosenResults) {
            return React.createElement(Loader_1.default, null);
        }
        else {
            var accumulatedAccOdds = 1;
            for (var _i = 0, _a = Main_1.Main.Instance.Fantasy.chosenResults.accumulator; _i < _a.length; _i++) {
                var acc = _a[_i];
                accumulatedAccOdds *= acc.correctScore.odds;
            }
            window.scroll(0, 0);
            return (React.createElement("section", { className: "wrapper" },
                React.createElement("div", { className: "header", role: "banner" },
                    React.createElement("header", { className: "navbar navbar-default", style: { marginBottom: '0' } },
                        React.createElement("div", { className: "container" },
                            React.createElement("div", { className: "navbar-header" },
                                React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                    React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" })),
                                React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                    React.createElement("img", { src: Assets.logoMain, alt: "", className: "logo" })),
                                React.createElement("span", { className: "navbar-toggle user-profile-trigger" }, this.cookies.get('username'))),
                            React.createElement("nav", { className: (this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse', id: "navbar-collapse-left", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' } }, (this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)),
                            React.createElement("nav", { className: "collapse navbar-collapse", id: "user-profile" },
                                React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                                    React.createElement("li", { className: "user-nav-option" },
                                        React.createElement("div", { className: "user" },
                                            React.createElement("div", { className: "user-info-wrap" },
                                                " ",
                                                React.createElement("span", { className: "user-name" }, this.cookies.get('username')),
                                                React.createElement("div", { className: "balance-info" },
                                                    " Balance",
                                                    React.createElement("span", { className: "text-primary" }, "5,000 \u20AC "),
                                                    React.createElement("a", { href: "javascript:void(0);" },
                                                        React.createElement("i", { className: "icon-plus-circular" })))))),
                                    (this.cookies.get('username')) ?
                                        React.createElement("li", { className: (this.state.userDropdown === true) ? 'dropdown open' : 'dropdown' },
                                            React.createElement("a", { href: "javascript:void(0);", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (this.state.userDropdown) ? 'true' : 'false' },
                                                React.createElement("i", { className: "icon-menu-dots", onClick: function () { return _this.setState({ userDropdown: !_this.state.userDropdown }); } })),
                                            React.createElement("ul", { className: "dropdown-menu" },
                                                React.createElement("li", null,
                                                    React.createElement(react_router_dom_1.Link, { to: "/myprofile" },
                                                        React.createElement("i", { className: "icon-profile" }),
                                                        "MY PROFILE")),
                                                React.createElement("li", { onClick: function () { return Utils.logout(); } },
                                                    React.createElement(react_router_dom_1.Link, { to: "/login" },
                                                        React.createElement("i", { className: "icon-logout" }),
                                                        "LOGOUT"))))
                                        :
                                            null))))),
                React.createElement("div", { className: "info-ribbon" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "h4 text-center" }, 'GAMEWEEK ' + localStorage.getItem('roundId')))),
                React.createElement("main", { className: "main" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "stage-view" },
                            React.createElement("div", { className: "stage-view-content" },
                                React.createElement("div", { className: "stage-view-header" },
                                    React.createElement("div", { className: "stage-view-row" },
                                        React.createElement("div", { className: "stage-view-cell stage-view-heading" },
                                            React.createElement("div", { className: "pro" },
                                                React.createElement("div", { className: "relative-wrap" },
                                                    "Correct Score",
                                                    React.createElement(react_router_dom_1.Link, { to: { pathname: '/betstep1', state: { showConfirmButton: false } } },
                                                        React.createElement("i", { className: "icon-pencil" }, "\u00A0EDIT"))))),
                                        React.createElement("div", { className: "stage-view-cell" }, "Predictions"),
                                        React.createElement("div", { className: "stage-view-cell" }, "1X2 odds"),
                                        React.createElement("div", { className: "stage-view-cell" }, "Score odds"))),
                                React.createElement("div", { className: "stage-view-body" }, this.getCorrectScores()),
                                React.createElement("div", { className: "check-points-system", onClick: function () { return _this.setState({ popup: true, pointsSystem: 1 }); } },
                                    React.createElement("img", { src: "info-black.png" }),
                                    React.createElement("i", null, "Check points system"))),
                            React.createElement("div", { className: "stage-view-content" },
                                React.createElement("div", { className: "stage-view-header" },
                                    React.createElement("div", { className: "stage-view-row" },
                                        React.createElement("div", { className: "stage-view-cell stage-view-heading" },
                                            React.createElement("div", { className: "pro" },
                                                React.createElement("div", { className: "relative-wrap" },
                                                    "Goal Markets",
                                                    React.createElement(react_router_dom_1.Link, { to: { pathname: '/betstep2', state: { showConfirmButton: false } } },
                                                        React.createElement("i", { className: "icon-pencil" }, "\u00A0EDIT"))))),
                                        React.createElement("div", { className: "stage-view-cell" }),
                                        React.createElement("div", { className: "stage-view-cell" }),
                                        React.createElement("div", { className: "stage-view-cell" }, "Odds"))),
                                React.createElement("div", { className: "stage-view-body" },
                                    this.getAccumulator('Both teams to score'),
                                    this.getAccumulator('Over 2.5 goals'),
                                    this.getAccumulator('Under 2.5 goals'),
                                    this.getAccumulator('Draw'),
                                    React.createElement("div", { className: "stage-view-row acc-odds-padding", style: { background: '#E7E7E7' } },
                                        React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
                                        React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
                                        React.createElement("div", { className: "stage-view-cell acc-odds-padding", "data-span": "Predictions", style: { background: '#FFF' } }, "Accumulator odds"),
                                        React.createElement("div", { className: "stage-view-cell accumulated-odds-total acc-odds-padding", "data-span": "Odds" }, accumulatedAccOdds.toFixed(2).toString())),
                                    React.createElement("div", { className: "stage-view-row acc-odds-padding", style: { background: '#E7E7E7' } },
                                        React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
                                        React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
                                        React.createElement("div", { className: "stage-view-cell acc-odds-padding", "data-span": "Predictions", style: { background: '#FFF' } }, "WHY NOT?"),
                                        React.createElement("div", { className: "stage-view-cell place-real-money acc-odds-padding", "data-span": "" },
                                            React.createElement("a", { href: "https://affiliates.vbet.com/links/?btag=40895", target: "_blank" }, "Go to Vbet!")))),
                                React.createElement("div", { className: "check-points-system", onClick: function () { return _this.setState({ popup: true, pointsSystem: 2 }); } },
                                    React.createElement("img", { src: "info-black.png" }),
                                    React.createElement("i", null, "Check points system"))),
                            React.createElement("div", { className: "stage-view-content" },
                                React.createElement("div", { className: "stage-view-header" },
                                    React.createElement("div", { className: "stage-view-row" },
                                        React.createElement("div", { className: "stage-view-cell stage-view-heading" },
                                            React.createElement("div", { className: "pro" },
                                                React.createElement("div", { className: "relative-wrap" },
                                                    "Goalscorers",
                                                    React.createElement(react_router_dom_1.Link, { to: { pathname: '/betstep3', state: { showConfirmButton: false } } },
                                                        React.createElement("i", { className: "icon-pencil" }, "\u00A0EDIT"))))),
                                        React.createElement("div", { className: "stage-view-cell" }),
                                        React.createElement("div", { className: "stage-view-cell" }),
                                        React.createElement("div", { className: "stage-view-cell" }, "Odds"))),
                                React.createElement("div", { className: "stage-view-body" }, this.getGoalscorers()),
                                React.createElement("div", { className: "check-points-system", onClick: function () { return _this.setState({ popup: true, pointsSystem: 3 }); } },
                                    React.createElement("img", { src: "info-black.png" }),
                                    React.createElement("i", null, "Check points system")))),
                        React.createElement("div", { className: "clearfix" })),
                    (this.state.popup) ? this.showPopup() : null,
                    (this.state.confirmationPopup) ? this.showConfirmationPopup() : null)));
        }
    };
    Confirmation.prototype.getCorrectScores = function () {
        var scoresReturn = [];
        var accumulated1X2 = 1;
        var accumulated = 1;
        for (var _i = 0, _a = Main_1.Main.Instance.Fantasy.chosenResults.correctScores; _i < _a.length; _i++) {
            var score = _a[_i];
            accumulated1X2 *= score.correctScore.odds1X2;
            accumulated *= score.correctScore.odds;
            scoresReturn.push(React.createElement("div", { key: scoresReturn.length, className: "stage-view-row" },
                React.createElement("div", { className: "stage-view-cell" },
                    " ",
                    score.homeTeam,
                    React.createElement("small", { className: "text-gray vs" }, " vs "),
                    score.awayTeam),
                React.createElement("div", { className: "stage-view-cell", "data-span": "Predictions" }, score.correctScore.name[0] + '-' + score.correctScore.name[2]),
                React.createElement("div", { className: "stage-view-cell", "data-span": "Odds1X2" }, score.correctScore.odds1X2.toString()),
                React.createElement("div", { className: "stage-view-cell", "data-span": "OddsCorrectScore" }, score.correctScore.odds.toString())));
        }
        scoresReturn.push(React.createElement("div", { key: scoresReturn.length, className: "stage-view-row acc-odds-padding", style: { background: '#E7E7E7' } },
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", "data-span": "Predictions", style: { background: '#FFF' } }, "Accumulator odds"),
            React.createElement("div", { className: "stage-view-cell accumulated-odds-total acc-odds-padding", "data-span": "1X2 odds" }, accumulated1X2.toFixed(2).toString()),
            React.createElement("div", { className: "stage-view-cell accumulated-odds-total acc-odds-padding", "data-span": "Score odds" }, accumulated.toFixed(2).toString())));
        scoresReturn.push(React.createElement("div", { key: scoresReturn.length, className: "stage-view-row acc-odds-padding", style: { background: '#E7E7E7' } },
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", "data-span": "Predictions", style: { background: '#FFF' } }, "WHY NOT?"),
            React.createElement("div", { className: "stage-view-cell place-real-money acc-odds-padding mobile-hide", "data-span": "1X2 odds" }),
            React.createElement("div", { className: "stage-view-cell place-real-money acc-odds-padding", "data-span": "" },
                React.createElement("a", { href: "https://affiliates.vbet.com/links/?btag=40895", target: "_blank" }, "Go to Vbet!"))));
        return scoresReturn;
    };
    Confirmation.prototype.getAccumulator = function (type) {
        var betType = '';
        if (type === 'Both teams to score')
            betType = 'BTTS';
        else if (type === 'Over 2.5 goals')
            betType = 'Over';
        else if (type === 'Under 2.5 goals')
            betType = 'Under';
        else
            betType = 'Draw';
        var accReturn = [];
        var types = Main_1.Main.Instance.Fantasy.chosenResults.accumulator.filter(function (elt) { return elt.type === betType; });
        if (types.length > 0) {
            accReturn.push(React.createElement("div", { key: accReturn.length, className: "stage-view-row stage-view-row-alt" },
                React.createElement("div", { className: "stage-view-cell" }),
                React.createElement("div", { className: "stage-view-cell" }),
                React.createElement("div", { className: "stage-view-cell" }),
                React.createElement("div", { className: "stage-view-cell-alt stage-view-cell" },
                    React.createElement("span", { "data-span": type }, type))));
            for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
                var res = types_1[_i];
                accReturn.push(React.createElement("div", { key: accReturn.length, className: "stage-view-row" },
                    React.createElement("div", { className: "stage-view-cell" },
                        " ",
                        res.homeTeam + ' / ' + res.awayTeam,
                        " "),
                    React.createElement("div", { className: "stage-view-cell mobile-hide" }),
                    React.createElement("div", { className: "stage-view-cell mobile-hide" }),
                    React.createElement("div", { className: "stage-view-cell", "data-span": "Odds" }, res.correctScore.odds.toFixed(2).toString())));
            }
        }
        return accReturn;
    };
    Confirmation.prototype.getGoalscorers = function () {
        var goalsReturn = [];
        var accumulatedOdds = 1;
        var noSPOdds = true;
        for (var _i = 0, _a = Main_1.Main.Instance.Fantasy.chosenResults.goalscorers; _i < _a.length; _i++) {
            var score = _a[_i];
            if (+score.correctScore.odds > 0)
                accumulatedOdds *= score.correctScore.odds;
            if (+score.correctScore.odds === 100)
                noSPOdds = false;
            goalsReturn.push(React.createElement("div", { key: goalsReturn.length, className: "stage-view-row" },
                React.createElement("div", { className: "stage-view-cell" },
                    score.correctScore.name + ' (',
                    React.createElement("span", { style: (score.team !== 1) ? { color: '#AAA' } : {} }, score.homeTeam),
                    " ",
                    React.createElement("small", { className: "text-gray vs" }, " vs "),
                    " ",
                    React.createElement("span", { style: (score.team !== 2) ? { color: '#AAA' } : {} }, score.awayTeam),
                    ")"),
                React.createElement("div", { className: "stage-view-cell mobile-hide" }),
                React.createElement("div", { className: "stage-view-cell mobile-hide" }),
                React.createElement("div", { className: "stage-view-cell", "data-span": "Odds" }, (score.correctScore.odds > 0 && score.correctScore.odds < 100) ? score.correctScore.odds.toFixed(2).toString() : 'SP')));
        }
        goalsReturn.push(React.createElement("div", { key: goalsReturn.length, className: "stage-view-row acc-odds-padding", style: { background: '#E7E7E7' } },
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", "data-span": "Predictions", style: { background: '#FFF' } }, "Accumulator odds"),
            React.createElement("div", { className: "stage-view-cell accumulated-odds-total acc-odds-padding", "data-span": "Odds" }, (noSPOdds) ? accumulatedOdds.toFixed(2).toString() : 'SP')));
        goalsReturn.push(React.createElement("div", { key: goalsReturn.length, className: "stage-view-row acc-odds-padding", style: { background: '#E7E7E7' } },
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", "data-span": "Predictions", style: { background: '#FFF' } }, "WHY NOT?"),
            React.createElement("div", { className: "stage-view-cell place-real-money acc-odds-padding", "data-span": "" },
                React.createElement("a", { href: "https://affiliates.vbet.com/links/?btag=40895", target: "_blank" }, "Go to Vbet!"))));
        return goalsReturn;
    };
    Confirmation.prototype.showPopup = function () {
        var _this = this;
        var screenPosition = document.documentElement.scrollTop + 150;
        var top = screenPosition.toString() + 'px';
        return (React.createElement("div", { className: "popup" },
            React.createElement("div", { className: "popup-inner", style: { top: top } },
                React.createElement("div", { className: "check-points-system-popup" },
                    React.createElement("span", { className: "team-players-name" },
                        React.createElement("b", null, "POINTS SYSTEM")),
                    React.createElement("span", { className: "team-info-close" },
                        React.createElement("img", { src: "cancel.svg", onClick: function () { return _this.setState({ popup: false }); } }))),
                (this.state.pointsSystem === 1) ?
                    React.createElement("div", { className: "check-points-system-third" },
                        React.createElement("h3", null, "Correct scores"),
                        React.createElement("p", null, "There are two parts to the points calculation in the Correct Score predictions..."),
                        React.createElement("p", null, "Part 1 - Correct win/draw/win (1X2) outcome = Earn the 1X2 odds for that selection, as points."),
                        React.createElement("p", null, "Part 2 - Correct score at full time (90mins) = Additional bonus points according to the table below;"),
                        React.createElement("p", null, "Correct score odds 1 \u2192 9.99 | 2 points"),
                        React.createElement("p", null, "Correct score odds 10 \u2192 24.99 | 3 points"),
                        React.createElement("p", null, "Correct score odds 25+ | 5 points"),
                        React.createElement("br", null),
                        React.createElement("p", null, "1X2 points are multiplied together to get the 1X2 Accumulator points."),
                        React.createElement("p", null, "Then, Correct Score bonus points are multiplied and the two totals are added together."),
                        React.createElement("p", null, "A further bonus of 3 points is awarded if the user correctly predicts the win/draw/win (1X2) outcome of all 3 selections. Or, a bonus of 9 points if the user correctly predicts all 3 correct scores!"))
                    : (this.state.pointsSystem === 2) ?
                        React.createElement("div", { className: "check-points-system-third" },
                            React.createElement("h3", null, "Goal markets"),
                            React.createElement("p", null, "User will earn the decimal odds of each correct selection, as points. Points from each correct selection are multiplied together to give a Goal Markets total."),
                            React.createElement("p", null, "A further bonus of 3 points is awarded if the user correctly predicts a goal markets outcome in all 3 selections."))
                        :
                            React.createElement("div", { className: "check-points-system-third" },
                                React.createElement("h3", null, "Goalscorers"),
                                React.createElement("p", null, "User will earn the decimal odds of each correct selection, as points. Points from each correct selection are multiplied together to give a Goalscorers total."),
                                React.createElement("p", null, "A further bonus of 3 points is awarded if all three of the user\u00B4s selections score 1 goal or more.")))));
    };
    Confirmation.prototype.showConfirmationPopup = function () {
        var _this = this;
        var screenPosition = document.documentElement.scrollTop + 100;
        var top = screenPosition.toString() + 'px';
        return (React.createElement("div", { className: "popup" },
            React.createElement("div", { className: "popup-inner popup-forgot", style: { top: top } },
                React.createElement("div", { style: { textAlign: 'right' } },
                    React.createElement("img", { src: "cancel.svg", style: { width: '30px', height: '30px', cursor: 'pointer' }, onClick: function () { return _this.setState({ confirmationPopup: false }); } })),
                React.createElement("div", { className: "fist-bump" },
                    React.createElement("img", { src: "fist-bump.svg" })),
                React.createElement("p", { className: "congratulations-second" }, "Fair Play! Your entry has been confirmed..."),
                React.createElement("p", { className: "congratulations-third", style: { fontStyle: 'italic' } }, "\"Note\": You can edit any of your selections here - Access this page from the Lounge, by clicking VIEW next to the associated Gameweek."))));
    };
    return Confirmation;
}(React.Component));
exports.Confirmation = Confirmation;
var Inserting = /** @class */ (function (_super) {
    __extends(Inserting, _super);
    function Inserting(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        _this.cookies = new react_cookie_1.Cookies();
        return _this;
    }
    Inserting.prototype.render = function () {
        var betInsert = socket_init_1.default.Get('insert-bet');
        if (betInsert.loading === 'loaded') {
            return React.createElement(react_router_dom_1.Redirect, { to: { pathname: '/confirmation', state: { showConfirmationPopup: true } } });
        }
        else {
            return React.createElement(Loader_1.default, null);
        }
    };
    return Inserting;
}(React.Component));
exports.Inserting = Inserting;
react_cookie_1.withCookies(Bet1, Bet2, Bet3, Confirmation, Inserting);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(45);
module.exports = __webpack_require__(50);


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(46).enable();
  window.Promise = __webpack_require__(48);
}

// fetch() polyfill for making API calls.
__webpack_require__(49);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(12);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(27);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(27);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(52);
var Main_1 = __webpack_require__(13);
var Main_2 = __webpack_require__(70);
__webpack_require__(124);
__webpack_require__(125);
__webpack_require__(126);
// import * as Common from './import/WebSocket'
// import {Logic} from './Logic/Type'
// export let Cli = new Common.Net.modules.WebSocketServer.WebSocketClient('89.212.50.250',10100)
// const path = 'points'
// const method = 'get'
// const input =  {query:{player: 'roki321'}}
// const key = '30e73b7e1f2e3a24a941052f4e970f2c'
// const login = JSON.stringify({[path]: {method, input, key}})
// console.log(login)
// Cli.Connect((socket) => {
//     console.log('Client Connected')
//     socket.Send(Common.Text.Unicode.Binary(login))
//     socket.Read(async (data) => {
//         const p = Common.Text.Unicode.String(data)
//         if (p === 'ping') {
//             alert ('changed')
//         } else {
//             const parse = JSON.parse(p)
//             Logic.Type.New (Main.Instance.IndexState, {data: parse})
//         }
//     })
// })
// import {Index} from './Views/Main/Index/Index'
function setCookies() {
    var username = readCookie('username');
    var location = readCookie('location');
    var mail = readCookie('mail');
    if (!Main_1.Main.Instance.Location) {
        Main_1.Main.Instance.Location = location;
    }
    Main_1.Main.Instance.Login.Verified = true;
    Main_1.Main.Instance.Login.Username = username;
    Main_1.Main.Instance.Login.Mail = mail;
}
function getTime() {
    var now = new Date();
    return now.getTime();
}
function readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}
Main_1.Main.Instance = new Main_1.Main(new /** @class */ (function () {
    function class_1() {
    }
    class_1.prototype.Update = function (state) {
        Main_1.Main.Instance = state;
        var usr1 = readCookie('username');
        var loc1 = readCookie('location');
        var rl1 = readCookie('mail');
        var exp1 = readCookie('expires');
        if (loc1 && usr1 && rl1 && exp1) {
            if (parseInt(exp1, 10) > getTime()) {
                setCookies();
            }
        }
        //    window.history.replaceState(Main.Instance.Location, Main.Instance.Location, Main.Instance.Location)
        // ReactDOM.render(<Index/>, document.getElementById('root'))
        ReactDOM.render(React.createElement(Main_2.MainView, null), document.getElementById('root'));
    };
    return class_1;
}()));
var usr = readCookie('username');
var loc = readCookie('location');
var rl = readCookie('mail');
var exp = readCookie('expires');
if (loc && usr && rl && exp) {
    if (parseInt(exp, 10) > getTime()) {
        setCookies();
    }
}
ReactDOM.render(React.createElement(Main_2.MainView, null), document.getElementById('root'));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(12),n=__webpack_require__(29),p=__webpack_require__(16),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(53);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),l=__webpack_require__(54),B=__webpack_require__(12),C=__webpack_require__(16),ba=__webpack_require__(55),da=__webpack_require__(56),ea=__webpack_require__(57),fa=__webpack_require__(58),ia=__webpack_require__(61),D=__webpack_require__(29);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(16);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(59);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(60);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Type_1 = __webpack_require__(11);
var Assets = __webpack_require__(3);
var Fantasy = /** @class */ (function (_super) {
    __extends(Fantasy, _super);
    function Fantasy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.matchesSet = false;
        _this.location = Assets.location.firstPage;
        _this.openConfirmation = false;
        _this.selectedResult = ['---', '---', '---', '---', '---', '---', '---', '---', '---', '---'];
        _this.selectedAcc = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        _this.firstName = '';
        _this.lastName = '';
        _this.email = '';
        _this.username = '';
        _this.password = '';
        _this.passwordConfirmation = '';
        _this.leaderboardTypeClicked = 0;
        _this.leaderboardRoundClicked = 0;
        _this.resultRoundClicked = 0;
        _this.leaguesTab = 1;
        _this.showConfirmButton = true;
        _this.competitionTab = 1;
        return _this;
    }
    return Fantasy;
}(Type_1.Logic.Type));
exports.Fantasy = Fantasy;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zollar2.aa69bbdd.svg";

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGP6zwAAAgcBApocMXEAAAAASUVORK5CYII="

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loader.2a03aa9b.gif";

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-main.fa216c17.png";

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/powered-by-gamanza-black.35c2af59.svg";

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/powered-by-gamanza-white.049dfd41.svg";

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Type_1 = __webpack_require__(11);
// import * as Assets from '../../src/Assets/Assets'
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /*
            IframeBackground: string
            token: string
         */
        _this.Username = '';
        _this.Password = '';
        _this.Mail = '';
        _this.Name = '';
        _this.Verified = false;
        return _this;
        /*
            Nat: string
            DateOfBirth: string
            ViewLarge:boolean = false
        
            AccountJustCreated: number = 0
            // this is just intially to create an user
            UsernameNew: string = ''
            PasswordNew: string = ''
            PlayerExists: boolean = false
            Balance: string
            SocialBalance: string
            IceBalance: string
            BalanceAdd : number = 5
            XpAdd: number = 100
            PasswordIncorrect:boolean = false
            UsernameEmpty:boolean = false
            Currency: string = Assets.DefaultCurrency
            Mode: boolean = false
            GameMode = false
            IframeLink: string
        */
    }
    return Login;
}(Type_1.Logic.Type));
exports.Login = Login;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Main_1 = __webpack_require__(13);
var Fantasy_1 = __webpack_require__(71);
var react_router_dom_1 = __webpack_require__(5);
var react_cookie_1 = __webpack_require__(4);
function getTime() {
    var now = new Date();
    var time = now.getTime();
    time += 3600000;
    return time;
}
function setCookies() {
    if (Main_1.Main.Instance.Login &&
        Main_1.Main.Instance.Location &&
        Main_1.Main.Instance.Login.Username &&
        Main_1.Main.Instance.Login.Mail) {
        document.cookie = 'username=' + Main_1.Main.Instance.Login.Username;
        document.cookie = 'mail=' + Main_1.Main.Instance.Login.Mail;
        var location = Main_1.Main.Instance.Location == '/index' ? '/index' : Main_1.Main.Instance.Location;
        document.cookie = 'location=' + location;
        document.cookie = 'expires=' + getTime().toString();
    }
}
function MainView(props) {
    setCookies();
    // return(<div><div id = ""><Fantasy/></div></div>)
    return (React.createElement(react_cookie_1.CookiesProvider, null,
        React.createElement(react_router_dom_1.BrowserRouter, null,
            React.createElement(Fantasy_1.default, null))));
}
exports.MainView = MainView;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
// import * as Assets from '../../../assets/Assets'
// import { Main } from '../../../Logic/Main'
// import * as Config from '../../../Logic/Config'
var Body_1 = __webpack_require__(7);
var Footer_1 = __webpack_require__(114);
var Lounge_1 = __webpack_require__(115);
var Bet_1 = __webpack_require__(43);
var Leaderboards_1 = __webpack_require__(117);
var Leagues_1 = __webpack_require__(118);
var Standings_1 = __webpack_require__(42);
var MyProfile_1 = __webpack_require__(119);
var statelogic_1 = __webpack_require__(31);
var socket_init_1 = __webpack_require__(6);
var socketstate_1 = __webpack_require__(30);
// import axios from 'axios'
// import { Logic } from '../../../Logic/Type'
var Results_1 = __webpack_require__(120);
var Login_1 = __webpack_require__(121);
var SignUp_1 = __webpack_require__(122);
// import * as Utils from '../../../Logic/Utils'
var react_router_dom_1 = __webpack_require__(5);
// import { instanceOf } from 'prop-types'
var react_cookie_1 = __webpack_require__(4);
var Unsubscribe_1 = __webpack_require__(123);
/*
function getSubDomain() {
    const url = window.location.hostname
    return url.split('.')[0]
}
*/
var Fantasy = /** @class */ (function (_super) {
    __extends(Fantasy, _super);
    function Fantasy(props) {
        var _this = _super.call(this, props) || this;
        _this.cookies = new react_cookie_1.Cookies();
        return _this;
    }
    Fantasy.prototype.componentDidMount = function () {
        /*if (Main.Instance.Fantasy.countries === undefined) {
            axios.get(Config.asFlags).then((response) => {
                Logic.Type.New (Main.Instance.Fantasy, {countries: response.data})
            })
        }*/
        socket_init_1.default.onOpen = function () {
            // Socket.Send('flags', {})
        };
    };
    Fantasy.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(react_router_dom_1.Switch, null,
                React.createElement(react_router_dom_1.Route, { path: "/signup", component: SignUp_1.default }),
                React.createElement(react_router_dom_1.Route, { path: "/login", component: Login_1.default }),
                React.createElement(react_router_dom_1.Route, { path: "/lounge", component: Lounge_1.default }),
                React.createElement(react_router_dom_1.Route, { path: "/results", component: Results_1.default }),
                React.createElement(react_router_dom_1.Route, { path: "/betstep1", component: Bet_1.Bet1 }),
                React.createElement(react_router_dom_1.Route, { path: "/betstep2", component: Bet_1.Bet2 }),
                React.createElement(react_router_dom_1.Route, { path: "/betstep3", component: Bet_1.Bet3 }),
                React.createElement(react_router_dom_1.Route, { path: "/confirmation", component: Bet_1.Confirmation }),
                React.createElement(react_router_dom_1.Route, { path: "/leaderboards", component: Leaderboards_1.Leaderboards }),
                React.createElement(react_router_dom_1.Route, { path: "/inserting", component: Bet_1.Inserting }),
                React.createElement(react_router_dom_1.Route, { path: "/leagues", component: Leagues_1.default }),
                React.createElement(react_router_dom_1.Route, { path: "/missionstatement", component: Footer_1.HowToPlay }),
                React.createElement(react_router_dom_1.Route, { path: "/contact", component: Footer_1.Contact }),
                React.createElement(react_router_dom_1.Route, { path: "/howtoplay", component: Footer_1.HowToPlay }),
                React.createElement(react_router_dom_1.Route, { path: "/support", component: Footer_1.HowToPlay }),
                React.createElement(react_router_dom_1.Route, { path: "/termsandconditions", component: Footer_1.Terms }),
                React.createElement(react_router_dom_1.Route, { path: "/privacypolicy", component: Footer_1.Privacy }),
                React.createElement(react_router_dom_1.Route, { path: "/standings", component: Standings_1.default }),
                React.createElement(react_router_dom_1.Route, { path: "/myprofile", component: MyProfile_1.MyProfile }),
                React.createElement(react_router_dom_1.Route, { path: "/unsubscribe", component: Unsubscribe_1.default }),
                React.createElement(react_router_dom_1.Route, { path: "/", component: Body_1.default })),
            (window.location.pathname !== '/') ? React.createElement(Footer_1.Footer, null) : null));
    };
    Fantasy = __decorate([
        statelogic_1.subscribe(socketstate_1.default)
    ], Fantasy);
    return Fantasy;
}(React.Component));
exports.default = react_cookie_1.withCookies(Fantasy);


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var socketstate_1 = __webpack_require__(30);
var route_classes_1 = __webpack_require__(32);
var Message = /** @class */ (function () {
    function Message(input, path) {
        this.input = input;
        this.path = path;
    }
    Object.defineProperty(Message.prototype, "toString", {
        get: function () {
            var path = this.path;
            var input = this.input;
            return JSON.stringify({ path: path, input: input });
        },
        enumerable: true,
        configurable: true
    });
    return Message;
}());
exports.Message = Message;
var WS = /** @class */ (function () {
    function WS(options) {
        var _this = this;
        this.options = options;
        this.connected = false;
        var address = (options.wss ? 'wss' : 'ws') + "://" + options.host + (options.port ? ':' + options.port : '');
        this.Socket = new WebSocket(address);
        this.Socket.addEventListener('open', function () { if (_this.onOpen)
            _this.onOpen(); _this.connected = true; });
        this.Socket.addEventListener('error', function () { if (_this.onError)
            _this.onError(); _this.Socket.close(); });
        this.Socket.addEventListener('close', function () { if (_this.onClose)
            _this.onClose(); _this.connected = false; });
        this.Socket.addEventListener('message', function (m) {
            _this.State = m.data;
        });
    }
    WS.prototype.terminate = function () { this.Socket.close(); this.Socket = null; };
    Object.defineProperty(WS.prototype, "State", {
        set: function (input) {
            var parse;
            try {
                parse = JSON.parse(input);
                if (socketstate_1.default.get(parse.path) &&
                    parse.input !== undefined) {
                    socketstate_1.default.set((_a = {}, _a[parse.path] = Object.assign(new route_classes_1.Route('loaded'), parse.input), _a));
                }
            }
            catch (err) {
                console.log(err);
            }
            var _a;
        },
        enumerable: true,
        configurable: true
    });
    WS.prototype.Send = function (path, input) {
        var _this = this;
        if (this.Socket && this.Socket.readyState === this.Socket.CONNECTING)
            return setTimeout(function () { return _this.Send(path, input); }, 1000);
        if (this.Socket && this.connected && this.Socket.readyState === this.Socket.OPEN) {
            var m = new Message(input, path);
            var o = socketstate_1.default.get(path);
            o.loading = 'loading';
            socketstate_1.default.set((_a = {}, _a[path] = o, _a));
            this.Socket.send(m.toString);
        }
        else {
            this.connected = false;
            var address = (this.options.wss ? 'wss' : 'ws') + "://" + this.options.host + (this.options.port ? ':' + this.options.port : '');
            this.Socket = new WebSocket(address);
            this.Socket.addEventListener('open', function () {
                if (_this.onOpen)
                    _this.onOpen();
                _this.connected = true;
                var m = new Message(input, path);
                var o = socketstate_1.default.get(path);
                o.loading = 'loading';
                socketstate_1.default.set((_a = {}, _a[path] = o, _a));
                _this.Socket.send(m.toString);
                var _a;
            });
            this.Socket.addEventListener('error', function () { if (_this.onError)
                _this.onError(); _this.Socket.close(); });
            this.Socket.addEventListener('close', function () { if (_this.onClose)
                _this.onClose(); _this.connected = false; });
            this.Socket.addEventListener('message', function (m) {
                _this.State = m.data;
            });
        }
        var _a;
    };
    WS.prototype.Get = function (state) {
        return socketstate_1.default.get(state);
    };
    WS.prototype.Set = function (state, input) {
        delete input['loading'];
        socketstate_1.default.set((_a = {}, _a[state] = Object.assign(input, { loading: 'loaded' }), _a));
        var _a;
    };
    return WS;
}());
exports.default = WS;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var R = __webpack_require__(32);
var router_1 = __webpack_require__(74);
var Routes = new router_1.default();
Routes.New = {
    'rounds': new R.Rounds,
    'matches': new R.Matches,
    'insert-bet': new R.InsertBet,
    'update-bet': new R.UpdateBet,
    'results': new R.Results,
    'login': new R.Login,
    'forgot-password': new R.ForgotPassword,
    'change-password': new R.ChangePassword,
    'unsubscribe': new R.Unsubscribe,
    'my-profile-select': new R.MyProfileSelect,
    'my-profile-update': new R.MyProfileUpdate,
    'registration': new R.Registration,
    'user-confirmation': new R.UserConfirmation,
    'flags': new R.Flags,
    'leaderboards': new R.Leaderboards,
    'create-league': new R.CreateLeague,
    'join-league': new R.JoinLeague,
    'send-league-code': new R.SendLeagueCode,
    'user-leagues': new R.UserLeagues,
    'upcoming-fixtures': new R.UpcomingFixtures,
    'usr': new R.Usr,
    'get-leaderboard': new R.LeaderboardFeed,
    'get-team-info': new R.TeamFeed,
    'get-player-info': new R.PlayerFeed,
    'get-last-matches-info': new R.LastMatchesFeed
};
exports.default = Routes;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Router = /** @class */ (function () {
    function Router() {
    }
    Object.defineProperty(Router.prototype, "New", {
        // [Route: string]: Route
        set: function (data) {
            Object.assign(this, data);
        },
        enumerable: true,
        configurable: true
    });
    Router.prototype.exists = function (path) {
        return this[path] ? true : false;
    };
    Router.prototype.Get = function (route) {
        return this[route] ? this[route] : new Error('Route does not exist!');
    };
    return Router;
}());
exports.default = Router;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _universalCookie = __webpack_require__(20);

var _universalCookie2 = _interopRequireDefault(_universalCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _universalCookie2.default;
module.exports = exports['default'];

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookie = __webpack_require__(77);

var _cookie2 = _interopRequireDefault(_cookie);

var _objectAssign = __webpack_require__(12);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _utils = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cookies = function () {
  function Cookies(cookies, hooks) {
    _classCallCheck(this, Cookies);

    this.cookies = parseCookies(cookies);
    this.hooks = hooks;
    this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
  }

  _createClass(Cookies, [{
    key: '_updateBrowserValues',
    value: function _updateBrowserValues() {
      if (!this.HAS_DOCUMENT_COOKIE) {
        return;
      }

      this.cookies = _cookie2.default.parse(document.cookie);
    }
  }, {
    key: 'get',
    value: function get(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._updateBrowserValues();
      return readCookie(this.cookies[name], options);
    }
  }, {
    key: 'getAll',
    value: function getAll() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._updateBrowserValues();
      var result = {};

      for (var name in this.cookies) {
        result[name] = readCookie(this.cookies[name], options);
      }

      return result;
    }
  }, {
    key: 'set',
    value: function set(name, value, options) {
      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        value = JSON.stringify(value);
      }

      if (this.hooks && this.hooks.onSet) {
        this.hooks.onSet(name, value, options);
      }

      this.cookies[name] = value;

      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = _cookie2.default.serialize(name, value, options);
      }
    }
  }, {
    key: 'remove',
    value: function remove(name, options) {
      var finalOptions = options = (0, _objectAssign2.default)({}, options, {
        expires: new Date(1970, 1, 1, 0, 0, 1),
        maxAge: 0
      });

      if (this.hooks && this.hooks.onRemove) {
        this.hooks.onRemove(name, finalOptions);
      }

      delete this.cookies[name];

      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = _cookie2.default.serialize(name, '', finalOptions);
      }
    }
  }]);

  return Cookies;
}();

exports.default = Cookies;


function parseCookies(cookies) {
  if (typeof cookies === 'string') {
    return _cookie2.default.parse(cookies);
  } else if ((typeof cookies === 'undefined' ? 'undefined' : _typeof(cookies)) === 'object' && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}

function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === 'undefined') {
    // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
  }

  return !doNotParse;
}

function readCookie(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (isParsingCookie(value, options.doNotParse)) {
    try {
      return JSON.parse(value);
    } catch (e) {
      // At least we tried
    }
  }

  return value;
}
module.exports = exports['default'];

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.hasDocumentCookie = hasDocumentCookie;
exports.cleanCookies = cleanCookies;
// Can we get/set cookies on document.cookie?

function hasDocumentCookie() {
  return (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof document.cookie === 'string';
}

//backwards compatibility
var HAS_DOCUMENT_COOKIE = exports.HAS_DOCUMENT_COOKIE = hasDocumentCookie();

function cleanCookies() {
  document.cookie.split(';').forEach(function (c) {
    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });
}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(2);

var _universalCookie = __webpack_require__(20);

var _universalCookie2 = _interopRequireDefault(_universalCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CookiesProvider = function (_Component) {
  _inherits(CookiesProvider, _Component);

  function CookiesProvider(props) {
    _classCallCheck(this, CookiesProvider);

    var _this = _possibleConstructorReturn(this, (CookiesProvider.__proto__ || Object.getPrototypeOf(CookiesProvider)).call(this, props));

    if (props.cookies) {
      _this.cookies = props.cookies;
    } else {
      _this.cookies = new _universalCookie2.default();
    }
    return _this;
  }

  _createClass(CookiesProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        cookies: this.cookies
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return CookiesProvider;
}(_react.Component);

CookiesProvider.propTypes = {
  children: _propTypes.node,
  cookies: (0, _propTypes.instanceOf)(_universalCookie2.default)
};
CookiesProvider.childContextTypes = {
  cookies: (0, _propTypes.instanceOf)(_universalCookie2.default).isRequired
};
exports.default = CookiesProvider;
module.exports = exports['default'];

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(16);
var invariant = __webpack_require__(81);
var ReactPropTypesSecret = __webpack_require__(82);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = withCookies;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _universalCookie = __webpack_require__(20);

var _universalCookie2 = _interopRequireDefault(_universalCookie);

var _hoistNonReactStatics = __webpack_require__(33);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function withCookies(Component) {
  function Wrapper(props, _ref) {
    var cookies = _ref.cookies;

    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return _react2.default.createElement(Component, _extends({}, remainingProps, {
      cookies: cookies,
      ref: wrappedComponentRef
    }));
  }

  Wrapper.displayName = 'withCookies(' + (Component.displayName || Component.name) + ')';
  Wrapper.WrappedComponent = Component;

  Wrapper.propTypes = {
    wrappedComponentRef: _propTypes.func
  };

  Wrapper.contextTypes = {
    cookies: (0, _propTypes.instanceOf)(_universalCookie2.default).isRequired
  };

  return (0, _hoistNonReactStatics2.default)(Wrapper, Component);
}
module.exports = exports['default'];

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(23);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(1);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(8);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(21);

var _PathUtils = __webpack_require__(14);

var _createTransitionManager = __webpack_require__(22);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(23);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(1);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(8);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(21);

var _PathUtils = __webpack_require__(14);

var _createTransitionManager = __webpack_require__(22);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(89);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(24);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(1);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(14);

var _LocationUtils = __webpack_require__(21);

var _createTransitionManager = __webpack_require__(22);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(37);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(93)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(95);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(97);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(98);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(99);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(100);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(101);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(17);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(15);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(40);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(40);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(26);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(103);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(24);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(105);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(25);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(25);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(108);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(39);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var ExecutionEnvironment = _interopDefault(__webpack_require__(110));
var shallowEqual = _interopDefault(__webpack_require__(111));

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;


    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 111 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(12);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Assets = __webpack_require__(3);
var Body = __webpack_require__(7);
var react_router_dom_1 = __webpack_require__(5);
var react_cookie_1 = __webpack_require__(4);
var Utils = __webpack_require__(9);
var react_helmet_1 = __webpack_require__(18);
function getAboutHelp(content, menu) {
    var elements = [];
    for (var i = 0; i < menu.length; i++) {
        elements.push(React.createElement("li", { key: i.toString() },
            React.createElement(react_router_dom_1.Link, { to: menu[i].content.toLowerCase().replace(/\s/g, '') }, menu[i].content)));
    }
    return (React.createElement("div", { className: "col-lg-4 col-xs-4 footer-ul footer-mobile" },
        React.createElement("ul", { className: "list-unstyled" },
            React.createElement("li", null,
                React.createElement("h3", { className: "heading" }, content)),
            elements)));
}
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.render = function () {
        return (
        /*Footer Start*/
        React.createElement("footer", { className: "footer" },
            React.createElement("div", { className: "container-home" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-lg-6 col-sm-9", style: { height: '100px' } },
                        React.createElement("div", { className: "row" },
                            getAboutHelp('ABOUT', Assets.About),
                            getAboutHelp('HELP', Assets.Help),
                            React.createElement("div", { className: "col-lg-4 col-xs-4 footer-ul footer-mobile" },
                                React.createElement("div", { className: "col-lg-12 col-sm-12 " },
                                    React.createElement("ul", { className: "social-icons clearfix" },
                                        React.createElement("li", null,
                                            React.createElement("a", { href: "https://www.facebook.com/accumulatorclub/", target: "_blank", className: "fb" },
                                                React.createElement("i", { className: "icon-facebook" }))),
                                        React.createElement("li", null,
                                            React.createElement("a", { href: "https://twitter.com/theaccaclub", target: "_blank", className: "tw" },
                                                React.createElement("i", { className: "icon-twitter" }))))),
                                React.createElement("div", { className: "col-lg-12 col-sm-12 " },
                                    React.createElement("img", { className: "img-18", src: "18+.svg" })))))),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-lg-9" },
                        React.createElement("p", { className: "footer-text" }, "All games offered on The Accumulator Club are free to play, with cash prizes. The Accumulator Club does not offer gambling facilities, although we may link to third party sites that do. Use of any third party website is at your own risk and we will not be liable for any losses or damages. For more information, please consult our terms of service and privacy policy.")))),
            React.createElement("div", { className: "sub-footer" },
                React.createElement("div", { className: "container-home container-home-footer" },
                    React.createElement("div", null,
                        React.createElement("p", null,
                            "\u00A9",
                            ' ' + Assets.productYear + ' ' + Assets.productOwner + '. All Rights Reserved.')),
                    React.createElement("div", { className: "powered-by-gamanza" },
                        React.createElement("img", { src: Assets.poweredByGamanzaWhite }))))));
    };
    return Footer;
}(React.Component));
exports.Footer = Footer;
var Contact = /** @class */ (function (_super) {
    __extends(Contact, _super);
    function Contact(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        _this.cookies = new react_cookie_1.Cookies();
        _this.state = {
            userDropdown: false,
            mobileMenu: false
        };
        return _this;
    }
    Contact.prototype.render = function () {
        var _this = this;
        return (React.createElement("section", { className: "wrapper" },
            React.createElement(react_helmet_1.Helmet, null,
                React.createElement("meta", { charSet: "utf-8" }),
                React.createElement("title", null, "The Accumulator Club \u2013 Social betting \u2013 Contact"),
                React.createElement("meta", { name: "description", content: "The Accumulator Club is owned by Fair Play Gaming Ltd and powered by Gamanza\n                        Group. We develop unique free to play predictor games designed to drive customer acquisition,\n                        brand engagement and customer retention. Get in touch to discuss our white label gaming solutions." })),
            React.createElement("div", { className: "header", role: "banner" },
                React.createElement("header", { className: "navbar navbar-default", style: { marginBottom: '0' } },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "navbar-header" },
                            React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" })),
                            React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                React.createElement("img", { src: Assets.logoMain, alt: "", className: "logo" })),
                            React.createElement("span", { className: "navbar-toggle user-profile-trigger" }, this.cookies.get('username'))),
                        React.createElement("nav", { className: (this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse', id: "navbar-collapse-left", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' } }, (this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)),
                        React.createElement("nav", { className: "collapse navbar-collapse", id: "user-profile" },
                            React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                                React.createElement("li", { className: "user-nav-option" },
                                    React.createElement("div", { className: "user" },
                                        React.createElement("div", { className: "user-info-wrap" },
                                            " ",
                                            React.createElement("span", { className: "user-name" }, this.cookies.get('username')),
                                            React.createElement("div", { className: "balance-info" },
                                                " Balance",
                                                React.createElement("span", { className: "text-primary" }, "5,000 \u20AC "),
                                                React.createElement("a", { href: "javascript:void(0);" },
                                                    React.createElement("i", { className: "icon-plus-circular" })))))),
                                (this.cookies.get('username')) ?
                                    React.createElement("li", { className: (this.state.userDropdown === true) ? 'dropdown open' : 'dropdown' },
                                        React.createElement("a", { href: "javascript:void(0);", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (this.state.userDropdown) ? 'true' : 'false' },
                                            React.createElement("i", { className: "icon-menu-dots", onClick: function () { return _this.setState({ userDropdown: !_this.state.userDropdown }); } })),
                                        React.createElement("ul", { className: "dropdown-menu" },
                                            React.createElement("li", null,
                                                React.createElement(react_router_dom_1.Link, { to: "/myprofile" },
                                                    React.createElement("i", { className: "icon-profile" }),
                                                    "MY PROFILE")),
                                            React.createElement("li", { onClick: function () { return Utils.logout(); } },
                                                React.createElement(react_router_dom_1.Link, { to: "/login" },
                                                    React.createElement("i", { className: "icon-logout" }),
                                                    "LOGOUT"))))
                                    :
                                        null))))),
            React.createElement("div", { className: "info-ribbon" },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "h4 text-center" }, "Contact"))),
            React.createElement("main", { className: "main" },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "panel panel-default" },
                        React.createElement("div", { className: "panel-body" },
                            React.createElement("div", { className: "panel-icon" },
                                React.createElement("i", { className: "icon-terms" })),
                            React.createElement("div", { className: "core-text" },
                                React.createElement("div", { className: "h3" }, "For the members"),
                                "The Accumulator Club is a new online football game with a unique set of playing criteria and points scoring system. We recommend that you familiarise yourself how to play and how points are scored.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                " Check out How to Play ",
                                React.createElement("a", { href: "javascript:void(0);", title: "" }, "here"),
                                React.createElement("br", null),
                                React.createElement("br", null),
                                " Have a read through our blog ",
                                React.createElement("a", { href: "#", title: "" }, "here"),
                                " and hopefully it will help you make your selections - Feel free to comment and communicate!",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Tell your friends and colleagues about The Accumulator Club and invite them to play \u2013 You can setup a private league and establish who is the king or queen of football predictions!",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                " If you have any questions or queries about the game, or any other aspect of the website then please get in touch by email here  \u2013",
                                React.createElement("br", null),
                                " ",
                                React.createElement("a", { href: 'mailto:' + Assets.supportMail }, Assets.supportMail),
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "For the future partners"),
                                "The Accumulator Club is the BEST Premier League predictions game around. We have created an original concept that bridges the gap between sports betting and social gaming with an exciting challenge that can be enjoyed in private leagues by friends, colleagues, sports teams and social groups alike.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                " The Accumulator Club is fun to play and will massively boost engagement for sports websites, media/news outlets, or any brand interested in aligning with football. Therefore, we are keen to share our passion and ideas for collaboration with investors and media partners.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                " To find out more, please get in touch by email here - ",
                                React.createElement("a", { href: 'mailto:' + Assets.contactMail }, Assets.contactMail))))))));
    };
    return Contact;
}(React.Component));
exports.Contact = Contact;
var HowToPlay = /** @class */ (function (_super) {
    __extends(HowToPlay, _super);
    function HowToPlay(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        _this.cookies = new react_cookie_1.Cookies();
        _this.state = {
            userDropdown: false,
            mobileMenu: false,
            section: 0
        };
        return _this;
    }
    HowToPlay.prototype.render = function () {
        var _this = this;
        return (React.createElement("section", { className: "wrapper" },
            React.createElement(react_helmet_1.Helmet, null,
                React.createElement("meta", { charSet: "utf-8" }),
                React.createElement("title", null, "The Accumulator Club \u2013 Premier League predictions \u2013 How to Play"),
                React.createElement("meta", { name: "description", content: "The Accumulator Club is a free to play football game where users make predictions\n                        across a number of different betting markets. Earn points for all correct selections, based on real\n                        sportsbook odds and compete throughout the season in private leagues and the overall rankings." })),
            React.createElement("div", { className: "header", role: "banner" },
                React.createElement("header", { className: "navbar navbar-default", style: { marginBottom: '0' } },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "navbar-header" },
                            React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" })),
                            React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                React.createElement("img", { src: Assets.logoMain, alt: "", className: "logo" })),
                            React.createElement("span", { className: "navbar-toggle user-profile-trigger" }, this.cookies.get('username'))),
                        React.createElement("nav", { className: (this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse', id: "navbar-collapse-left", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' } }, (this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)),
                        React.createElement("nav", { className: "collapse navbar-collapse", id: "user-profile" },
                            React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                                React.createElement("li", { className: "user-nav-option" },
                                    React.createElement("div", { className: "user" },
                                        React.createElement("div", { className: "user-info-wrap" },
                                            " ",
                                            React.createElement("span", { className: "user-name" }, this.cookies.get('username')),
                                            React.createElement("div", { className: "balance-info" },
                                                " Balance",
                                                React.createElement("span", { className: "text-primary" }, "5,000 \u20AC "),
                                                React.createElement("a", { href: "javascript:void(0);" },
                                                    React.createElement("i", { className: "icon-plus-circular" })))))),
                                (this.cookies.get('username')) ?
                                    React.createElement("li", { className: (this.state.userDropdown === true) ? 'dropdown open' : 'dropdown' },
                                        React.createElement("a", { href: "javascript:void(0);", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (this.state.userDropdown) ? 'true' : 'false' },
                                            React.createElement("i", { className: "icon-menu-dots", onClick: function () { return _this.setState({ userDropdown: !_this.state.userDropdown }); } })),
                                        React.createElement("ul", { className: "dropdown-menu" },
                                            React.createElement("li", null,
                                                React.createElement(react_router_dom_1.Link, { to: "/myprofile" },
                                                    React.createElement("i", { className: "icon-profile" }),
                                                    "MY PROFILE")),
                                            React.createElement("li", { onClick: function () { return Utils.logout(); } },
                                                React.createElement(react_router_dom_1.Link, { to: "/login" },
                                                    React.createElement("i", { className: "icon-logout" }),
                                                    "LOGOUT"))))
                                    :
                                        null))))),
            React.createElement("div", { className: "info-ribbon" },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "h4 text-center" }, "How To Play"))),
            React.createElement("main", { className: "main" },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "panel panel-default" },
                        React.createElement("div", { className: "panel-body" },
                            React.createElement("div", { className: "panel-icon" },
                                React.createElement("i", { className: "icon-terms" })),
                            React.createElement("div", { className: "core-text-lg" },
                                React.createElement("div", { className: "how-to-play" }, this.setSections()),
                                this.setContent())))))));
    };
    HowToPlay.prototype.setSections = function () {
        var _this = this;
        var sections = [];
        var sectionsContent = ['Overview', 'Instructions', 'Points system', 'Private leagues'];
        var _loop_1 = function (i) {
            sections.push(React.createElement("span", { key: sections.length, className: (this_1.state.section === i) ? 'how-to-play-section how-to-play-section-colored' : 'how-to-play-section', onClick: function () { return _this.setState({ section: i }); } }, sectionsContent[i]));
        };
        var this_1 = this;
        for (var i = 0; i < sectionsContent.length; i++) {
            _loop_1(i);
        }
        return sections;
    };
    HowToPlay.prototype.setContent = function () {
        switch (this.state.section) {
            case 0:
                return (React.createElement("div", { className: "how-to-play-content" },
                    React.createElement("p", null, "\u201CTriple Threat\u201D is a free2play predictor format that offers an exciting new challenge to football fans everywhere! The aim of the game is to score points by predicting match outcomes in the featured set of fixtures, across 3 betting criteria. Points are based on the odds offered by our betting partners and bonus points are awarded for landing triples, so think about your strategy! At the end of each gaming round, the winner is the user with the most accumulated points!"),
                    React.createElement("br", null),
                    React.createElement("h3", null, "Triple Threat game format"),
                    React.createElement("p", null, "The group stages have been broken down into 10 gaming rounds. Each round features 4 or 6 fixtures depending on the daily tournament schedule. You will complete your predictions and entry into each game round in 3 simple steps\u2026"),
                    React.createElement("p", null,
                        React.createElement("u", null, "1. Make a correct score (and 1X2) triple!")),
                    React.createElement("p", null, "Study the fixture list, check out team form and players stats and predict the final score of any 3 matches of your choice."),
                    React.createElement("p", null,
                        React.createElement("u", null, "2. Make a Goal Markets triple!")),
                    React.createElement("p", null, "Predict a goal markets outcome for any 3 matches of your choice. Choose from Both Teams To Score, Over/Under 2.5 goals, or a Draw, in any combination."),
                    React.createElement("p", null,
                        React.createElement("u", null, "3. Make an Anytime Goalscorer triple!")),
                    React.createElement("p", null, "Back any 3 players to score at any time.")));
            case 1:
                return (React.createElement("div", { className: "how-to-play-content" },
                    React.createElement("h3", null, "Correct Scores"),
                    React.createElement("p", null, "Users predict the final score of any 3 fixtures and this will also automatically select the predicted outcome (1/X/2). Click on the circle next to one of the teams and you will see a table displaying a variety of possible scores and the associated odds/points. Click a team name if you would like to view their stats and qualifying record and when you\u00B4re ready, make your decision!"),
                    React.createElement("img", { src: "instructions1.png" }),
                    React.createElement("p", null, "To reset/remove any of your predictions simply click the red (x) and predict a different fixture. Once you are satisfied with your 3 predictions, click continue to go to the next step..."),
                    React.createElement("br", null),
                    React.createElement("p", null, "Remember: You will receive the 1X2 odds as points if the outcome is correct and you will receive bonus points according to our POINTS SYSTEM if you get the correct score as well. So how will you play? Shorter odds might be safer, but land those longer odds punts and you could hit the top of the table - #WHATSYOURSTRATEGY?"),
                    React.createElement("h3", null, "Goal Markets"),
                    React.createElement("p", null, "Here users predict a goal markets outcome on any 3 fixtures of their choice. User can choose from \u201CBoth teams to score\u201D, \u201COver 2.5 goals\u201D, \u201CUnder 2.5 goals\u201D and \u201CDraw\u201D, in any combination \u2013 just like you might do at the bookies."),
                    React.createElement("img", { src: "instructions2.png" }),
                    React.createElement("p", null, "To de-select any of your predictions you must click on it a second time, the selection will no longer be highlighted and you are free to make a different selection. Once you are satisfied with your 3 selections click continue to go to the next step."),
                    React.createElement("br", null),
                    React.createElement("h3", null, "Anytime Goalscorers"),
                    React.createElement("p", null, "TThis is straight forward. Users choose 3 anytime goalscorers from any team in the featured fixtures (and it\u2019s possible to select multiple players from the same team)."),
                    React.createElement("img", { src: "instructions3.png" }),
                    React.createElement("p", null, "To deselect a goalscorer selection, you can either click the red (x), or click the player a second time. He will no longer be highlighted in green and you are free to make a different selection. Once you are satisfied with your 3 selections click continue to confirm your free entry!")));
            case 2:
                return (React.createElement("div", { className: "how-to-play-content" },
                    React.createElement("p", null,
                        React.createElement("i", null, "Please note: We use a third party data feed to display odds and the odds dictate the points that will be distributed for correct selections. Odds are subject to change from time to time and your points may differ from those displayed. Where possible, the odds and projected points will be finalized at the time of the deadline for the round in question.")),
                    React.createElement("br", null),
                    React.createElement("h3", null, "Correct scores"),
                    React.createElement("p", null, "There are two parts to the points system in step 1."),
                    React.createElement("p", null, "First - Correct win/draw/win (1X2) outcome = Earn the 1X2 odds for that selection as points"),
                    React.createElement("p", null, "Second - Correct score at full time (90mins) = Earn 1X2 odds as above + bonus according to the table below;"),
                    React.createElement("p", null, "Correct score odds 1 \u2192 9.99 | 2 points"),
                    React.createElement("p", null, "Correct score odds 10 \u2192 24.99 | 3 points"),
                    React.createElement("p", null, "Correct score odds 25+ | 5 points"),
                    React.createElement("br", null),
                    React.createElement("p", null, "All 1X2 points are multiplied together to give a 1X2 total. And separately, Correct score bonus points are multiplied together."),
                    React.createElement("br", null),
                    React.createElement("p", null, "A further bonus of 3 points is awarded if the user correctly predicts the win/draw/win (1X2) outcome of all 3 selections. Or, a bonus of 9 points if the user correctly predicts all 3 correct scores!"),
                    React.createElement("br", null),
                    React.createElement("h3", null, "Goal Markets"),
                    React.createElement("p", null, "User will earn the decimal odds of each correct selection, as points. Points from each correct selection are multiplied together to give a Goal Markets total."),
                    React.createElement("p", null, "A further bonus of 3 points is awarded if the user correctly predicts a goal markets outcome in all 3 selections."),
                    React.createElement("br", null),
                    React.createElement("h3", null, "Anytime Goalscorers"),
                    React.createElement("p", null, "User will earn the decimal odds of each correct selection, as points. Points from each correct selection are multiplied together to give a Goalscorers total."),
                    React.createElement("p", null, "A further bonus of 3 points is awarded if all three of the user\u00B4s selections score 1 goal or more.")));
            case 3:
                return (React.createElement("div", { className: "how-to-play-content" },
                    React.createElement("p", null, "Please use the Leagues page to create your own private league and challenge your friends and foes. The page will display the \u2018create a league\u2019 tab by default. Enter a name for your league and click on create \u2013 Easy!"),
                    React.createElement("img", { src: "private-leagues1.png" }),
                    React.createElement("p", null, "Once the league has been created you will receive a unique code to pass on to friends and colleagues. They will need to sign up for membership and enter the unique code by switching the panel on the leagues page to \u2018join a league\u2019."),
                    React.createElement("img", { src: "private-leagues2.png" }),
                    React.createElement("p", null, "Just enter the code into the box and click CONFIRM THE CODE."),
                    React.createElement("p", null, "In both the overall rankings and private leagues you can check the performance history of your rivals by clicking their username. You will see their predictions and points in the most recent game round by default, but you can also use the dropdown box in the top right to view their previous scores.")));
            default:
                return (React.createElement("div", { className: "how-to-play-content" },
                    React.createElement("p", null,
                        React.createElement("i", null, "Terms & Conditions for Accumulator Club competition")),
                    React.createElement("h3", null, "General"),
                    React.createElement("p", null, "1. These terms and conditions cover The Accumulator Club competition that will run from 13/06/2018 to 08/07/2018"),
                    React.createElement("p", null, "2. Accumulator Club is a free to play competition with 13 game rounds. Each round there is a cash prize of 20 \u00A3 / \u20AC / $ to be won and the overall winner will win a Ps4 with Fifa 18 bundle."),
                    React.createElement("p", null, "3. The competition is open to anybody over the age of 18, residing in any country."),
                    React.createElement("p", null, "4. Cash prizes for the winner of each round can be awarded to anyone. But the overall prize, the Ps4 can only be awarded to a resident in Europe."),
                    React.createElement("p", null, "5. Accumulator Club admin will endeavor to contact winners within 48 hours of a round closing, or the competition closing. We will provide further instructions on how to claim."),
                    React.createElement("p", null, "6. If a winner does not respond within 30 days after we have made contact through their registered email address, the winnings will be forfeited."),
                    React.createElement("p", null, "7. These terms & conditions should be read and understood alongside our website terms & conditions."),
                    React.createElement("br", null),
                    React.createElement("h3", null, "The game"),
                    React.createElement("p", null, "1. Each game round has a deadline for entry and you will not score any points if you do not confirm an entry before the deadline."),
                    React.createElement("p", null, "2. You can edit your selections at any time up to the deadline for that round."),
                    React.createElement("p", null, "3. After the deadline has passed for a round, you will not be able to edit your selections."),
                    React.createElement("p", null, "4. In the event that one of your selections does not appear, you will not receive any points."),
                    React.createElement("p", null, "5. We use a third party data feed to display odds and the odds dictate the points that will be distributed for correct selections. Odds are subject to change from time to time and your points may differ from those displayed. Where possible, the odds and projected points will be finalized at the time of the deadline for the round in question."),
                    React.createElement("p", null, "6. Points from every round you enter will automatically be accumulated and place you on overall and private rankings."),
                    React.createElement("p", null, "7. The winner of each round is the user who scores the most points for that round."),
                    React.createElement("p", null, "8. The overall winner is the user who has accumulated the most points after the final round (Round 13), which will be after the quarter finals in the knockout phase."),
                    React.createElement("p", null, "9. In the unlikely case that two users have the same total points, ranking will be decided first by total correct score points, then goalscorer points if users are still equal."),
                    React.createElement("p", null, "10. Accumulator Club shall not be liable for technical, hardware, software or network conditions that may limit or prohibit your ability to enter or participate in the Competition."),
                    React.createElement("br", null),
                    React.createElement("p", null, "If you do not meet the eligibility requirements for entering the competition, or for claiming a prize, your entries will be deemed void and you will be ineligible for prizes. If you are in fact infringing on any of these terms and conditions, or those of the website, your account may be deactivated."),
                    React.createElement("br", null),
                    React.createElement("p", null, "By entering the competition you confirm that you have read and understood these terms and conditions and agree to their content and ruling.")));
        }
    };
    return HowToPlay;
}(React.Component));
exports.HowToPlay = HowToPlay;
var Terms = /** @class */ (function (_super) {
    __extends(Terms, _super);
    function Terms(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        _this.cookies = new react_cookie_1.Cookies();
        _this.state = {
            userDropdown: false,
            mobileMenu: false
        };
        return _this;
    }
    Terms.prototype.render = function () {
        var _this = this;
        return (React.createElement("section", { className: "wrapper" },
            React.createElement("div", { className: "header", role: "banner" },
                React.createElement("header", { className: "navbar navbar-default", style: { marginBottom: '0' } },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "navbar-header" },
                            React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" })),
                            React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                React.createElement("img", { src: Assets.logoMain, alt: "", className: "logo" })),
                            React.createElement("span", { className: "navbar-toggle user-profile-trigger" }, this.cookies.get('username'))),
                        React.createElement("nav", { className: (this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse', id: "navbar-collapse-left", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' } }, (this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)),
                        React.createElement("nav", { className: "collapse navbar-collapse", id: "user-profile" },
                            React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                                React.createElement("li", { className: "user-nav-option" },
                                    React.createElement("div", { className: "user" },
                                        React.createElement("div", { className: "user-info-wrap" },
                                            " ",
                                            React.createElement("span", { className: "user-name" }, this.cookies.get('username')),
                                            React.createElement("div", { className: "balance-info" },
                                                " Balance",
                                                React.createElement("span", { className: "text-primary" }, "5,000 \u20AC "),
                                                React.createElement("a", { href: "javascript:void(0);" },
                                                    React.createElement("i", { className: "icon-plus-circular" })))))),
                                (this.cookies.get('username')) ?
                                    React.createElement("li", { className: (this.state.userDropdown === true) ? 'dropdown open' : 'dropdown' },
                                        React.createElement("a", { href: "javascript:void(0);", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (this.state.userDropdown) ? 'true' : 'false' },
                                            React.createElement("i", { className: "icon-menu-dots", onClick: function () { return _this.setState({ userDropdown: !_this.state.userDropdown }); } })),
                                        React.createElement("ul", { className: "dropdown-menu" },
                                            React.createElement("li", null,
                                                React.createElement(react_router_dom_1.Link, { to: "/myprofile" },
                                                    React.createElement("i", { className: "icon-profile" }),
                                                    "MY PROFILE")),
                                            React.createElement("li", { onClick: function () { return Utils.logout(); } },
                                                React.createElement(react_router_dom_1.Link, { to: "/login" },
                                                    React.createElement("i", { className: "icon-logout" }),
                                                    "LOGOUT"))))
                                    :
                                        null))))),
            React.createElement("div", { className: "info-ribbon" },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "h4 text-center" }, "TERMS AND CONDITIONS"))),
            React.createElement("main", { className: "main" },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "panel panel-default" },
                        React.createElement("div", { className: "panel-body" },
                            React.createElement("div", { className: "panel-icon" },
                                React.createElement("i", { className: "icon-terms" })),
                            React.createElement("div", { className: "core-text" },
                                React.createElement("div", { className: "h3" }, "Introduction"),
                                React.createElement("a", { href: "https://www.accumulatorclub.com", target: "_blank" }, "www.accumulatorclub.com"),
                                " is a service operated by Fair Play Gaming Ltd and for the purpose of these terms of service will be described as \u201CThe Accumulator Club\u201D, \u201Cwebsite\u201D, \u201Cwe\u201D or \u201Cus\u201D. \"Game\" means a game played on the The Accumulator Club plaform, \u201CMatch Day\u201D means a calendar day (Eg. Saturday or Sunday) where fixtures associated with the game are played out in reality. \u201CYou\u201D and \u201CUser/s\u201D means you, visitors to the website and participants in The Accumulator Club games, also bound by these Terms of service. \u201CPlayer/s\u201D means the real athletes named and featured in the games.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "The Accumulator Club is a social gaming platform that offers free to play sports betting predictor games. Users can create a profile, make entries into the games, setup private leagues and invite friends and colleagues to participate, track their results and those of other users.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Please read these Terms of service carefully. They form a legal agreement between you and Fair Play Gaming Ltd. Along with your understanding and acceptance of the privacy policy, these terms of service govern your membership of the website and you agree to their content.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "By signing up to participate in The Accumulator Club games you are confirming that you have read, understood and accepted these terms of service and agree to be bound by them. You also confirm that you are over 18 years of age.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "We may modify or update these terms of service from time to time. If you are not happy with any modification, you must stop using the Website. If you keep using the Website, this will indicate your acceptance of any updates. We may notify key changes to you, but you should review these terms of service from time to time to ensure you are aware of any changes.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Conditions of Participation"),
                                "The Accumulator Club is open to both UK and non-UK residents, but you must be at least 18 years of age to use the website, participate in the games and claim prizes. If we have reason to believe you are under the age of 18, we will suspend your account immediately and request proof of age. Failure to provide such information within a reasonable period of time will result in account termination.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "All players must adhere to these Terms of service and follow the onscreen instructions on the Website. Users will be requested to enter their name, email address, a password and a username. A welcome email, including a link to verify your email address will be received after completing the sign up successfully. You will need to verify your email address before you can participate in any Games.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "The Games are free to play, but in the future The Accumulator Club may offer real money games. When such games are offered on the website, all users who wish to participate will be ID checked and required to accept an updated version of these terms and conditions before depositing funds for use on the website.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Any one person (user) is only permitted to sign up for one membership at The Accumulator Club. All accounts must be registered with a valid personal email address to which you have sole access. Any use of multiple accounts is deemed as a breach of these Terms of service. If we have reason to suspect a breach has been made, an email will be sent to issue a warning. Any further abuse of this condition may result in the termination of all connected accounts.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "The Accumulator Club reserves the right to close accounts if any user is found to be using proxy IPs (Internet Protocol addresses) in order to attempt to hide the use of multiple memberships.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Copyrighted material, rights of use and intellectual property rights"),
                                "Your use of any information or materials on The Accumulator Club is entirely at your own risk, for which we shall not be liable.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "This website and application contain material which is owned by or licensed to The Accumulator Club. This material includes, but is not limited to, trademarks, design, layout, appearance, programming code, databases and the concept or format of the games, how they are played and the point scoring systems associated. Any development of software or functionality that copies or mimics any part of the site and those aspects detailed above is strictly prohibited and any unauthorised reproduction or attempt to do so may give rise to a claim for damages and/or be a criminal offence.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "All imagery and trademarks that have been reproduced on this website which are not the property of, or licensed to, The Accumulator Club are acknowledged on the website.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "All third party trade names and trademarks are the property of their respective owners and we make no warranty or representation in relation to them.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Subject to these terms and conditions and your compliance with them, we grant you a non- exclusive, non-transferable, personal, limited license to access and use the Website and the content solely for your private, non-commercial, personal use only.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Gameplay"),
                                "The How to Play page provides a detailed explanation of how to navigate the site, access the games and enter your predictions and selections. A link to the How to Play page is available in the top menu and the footer of every page on the website. Players should read this page carefully before playing any game on The Accumulator Club. The How to Play page is to be used as the first point of reference if a player finds an issue with any aspect of the website or a game on the website.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "The Accumulator Club has purchased a data provision package from Goalserve, Inc. And utilises an odds feed API from multiple third parties (can change from time to time). The data received will dictate the points distributed, according to the points system detailed on the How to Play page. The How to Play page is to be used as the first point of reference if a player finds an issue with the distribution of points. The points distributed at the end of any given match day are subject to revisions by the odds or stats provider. In the event this occurs, the points on The Accumulator Club will be updated accordingly.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Many of our games will run for the entirety of a competition (Eg. Start to finish of a domestic sports season or international tournament). Users are able to begin playing these games at any stage during the competition and will automatically be positioned in the overall rankings as they accumulate points.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Each gaming round has a deadline for entries and it will not be possible to enter a gaming round after the deadline has passed.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "The Accumulator Club reserves the right to limit access to the site during periods of necessary updates to player profiles, points, rankings, games available etc.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Code of Conduct"),
                                "The Accumulator Club, in its sole discretion reserves the right to suspend and delete teams or entire leagues that contain team names or league names which are deemed to be inappropriate or offensive. Depending on the seriousness of the situation, a user's account may be permanently removed.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "In due course, The Accumulator Club will provide the facility to leave comments on the blog, or contribute to a forum/message board. To participate and contribute in these areas of the website you will be required to sign up for membership. These Terms and Conditions govern that membership and in accepting these Terms and Conditions you also agree to use any blog, forum or message board in accordance with the following rules;",
                                React.createElement("ul", null,
                                    React.createElement("li", null, "No Defamation, stalking, bullying, abuse, harassment, impersonation or use of threatening or intimidating behaviour towards other Accumulator Club members, or any other third party."),
                                    React.createElement("li", null, "Do not publish or upload any material that is unlawful, harassing, threatening, defamatory, obscene, offensive, abusive, hateful, inflammatory, profane, racially, sexually or religiously offensive or otherwise objectionable or unlawful."),
                                    React.createElement("li", null, "No spamming, soliciting services or advertising to other Accumulator Club members, or any other third party."),
                                    React.createElement("li", null, "Do not transmit material that contains viruses or any other malicious code designed to interrupt, delete, or deny the functionality of any software or hardware."),
                                    React.createElement("li", null, "Do not use automated software including robots, spiders and scrapers to extract Game content without written consent from The Accumulator Club."),
                                    React.createElement("li", null, "Do not submit or share material that may violate, plagiarise, or infringe \u2013 the copyright, trademark/s, trade secrets, privacy, publicity, personal or proprietary rights of The Accumulator Club, or any third party.")),
                                React.createElement("br", null),
                                "If you fail to abide by these Rules when contributing to and using The Accumulator Club website, your contribution may well be edited or removed without warning. If further indiscretions are made, an email will be sent issuing a warning that continuing to break the rules may result in the termination of your membership.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "The Accumulator Club reserves the right to delete any contribution, or take action against any member, at any time, for any reason.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "In-game player status and information"),
                                "The football players and other athletes that are named and used in the games are those provided by our data and odds providers. The official squad selections, player info and numbers are accurate to the best of our knowledge. The data providers have used best research practice and common perception to determine each player\u2019s position, which may not necessarily reflect the position in reality, or that of any other third party. At the discretion of The Accumulator Club, players and athletes may be added, modified or removed from the game.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Within the website and the user interface of the games, team and player information and statistics will be available to check in order to help make informed decisions on playing the game. This information is drawn from the data provided and is not researched or updated by The Accumulator Club \u2013 We cannot edit this information and we cannot accept any responsibility for the affect it has on your entries in the games. Although we know the information to be very accurate, it should be treated as a guideline and there is no guarantee of its accuracy at any given time.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Registration, Account Password and Security"),
                                "Many areas of the Website require registration for access. If you choose to provide information to The Accumulator Club, you hereby agree to provide accurate and complete information. By creating a user account, you accept responsibility for all activities that occur under your account including maintaining the confidentiality of your password and restricting access to your computer and mobile devices so that others may not access any protected areas. You agree to indemnify The Accumulator Club for any improper or illegal use of your account.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Limitation on Liability"),
                                "The information on this website and its associated news and blogs is subject to change at any time.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, or suitability of the information, tools or games found or offered on this website for any particular purpose. You acknowledge that such information, tools and games may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "The Accumulator Club assumes no liability for loss or damage resulting from any use of or reliance upon the games or the content found on this website. In no event will The Accumulator Club, or any of its affiliates be liable for any lost profits, lost savings, lost data, business interruption, or other consequential damages or claims arising from the use of The Accumulator Club website or applications.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "The Accumulator Club may occasionally provide links to other websites. These links are provided for your convenience and to provide further information deemed to be of interest. They do not signify that we endorse the linked website/s, nor do we have responsibility for the content on the linked website/s.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "The Accumulator Club does not offer gambling facilities at this time, although we may link to third party sites that do. Use of any third party sites is at your own risk and The Accumulator Club will not be liable for any lost profits, lost savings, lost data, business interruption, or other consequential damages or claims arising from the use of linked sites.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Prizes"),
                                "The Accumulator Club is free to play, but cash prizes will be awarded to users in certain games. Generally these prizes are for the overall rankings winner (most points) in each individual gaming round and also the winner in the overall rankings at the end of a competition (most overall points in that competition).",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "The terms and conditions outlined below cover the ruling around the rewarding and payment of cash prizes only.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "The winner of any gaming round or full competition where cash prizes are linked, will need to contact us by email from the address registered on their account, to the following address;",
                                React.createElement("a", { href: "mailto:admin@accumulatorclub.com" }, " admin@accumulatorclub.com "),
                                "in order to make a claim. Cash prizes will be sent by Paypal only and we will not ask for any personal account information at any time. Cash prizes will only be paid in Euros (\u20AC), Pound sterling (\u00A3), or US dollars ($).",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "We may also offer other forms of prize from time to time in the competitions we operate on the website. Any prize that is offered that is not cash will most likely carry additional terms and conditions, exclusions and limitations. These will be made available for review and a link to view them will be clearly indicated on the website and any advertisement.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Users should read the terms and conditions of any competition where we offer prizes carefully. Your entry and participation into any game where prizes can be won is taken as expressed agreement of the terms and conditions of that game. Therefore, in agreeing to these terms and conditions you assume responsibility to read, understand and accept any additional terms and conditions of games with prizes.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "These Terms and Conditions will be interpreted in accordance with English law and the users agree that all claims arising from their participation in the Game will be under the exclusive jurisdiction of the Courts of England and Wales.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "All questions, comments or enquiries should be emailed directly to us at;",
                                React.createElement("a", { href: "mailto:support@accumulatorclub.com" }, " support@accumulatorclub.com "),
                                "and we will try to respond within 48 hours.")))))));
    };
    return Terms;
}(React.Component));
exports.Terms = Terms;
var Privacy = /** @class */ (function (_super) {
    __extends(Privacy, _super);
    function Privacy(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        _this.cookies = new react_cookie_1.Cookies();
        _this.state = {
            userDropdown: false,
            mobileMenu: false
        };
        return _this;
    }
    Privacy.prototype.render = function () {
        var _this = this;
        return (React.createElement("section", { className: "wrapper" },
            React.createElement("div", { className: "header", role: "banner" },
                React.createElement("header", { className: "navbar navbar-default", style: { marginBottom: '0' } },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "navbar-header" },
                            React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" })),
                            React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                React.createElement("img", { src: Assets.logoMain, alt: "", className: "logo" })),
                            React.createElement("span", { className: "navbar-toggle user-profile-trigger" }, this.cookies.get('username'))),
                        React.createElement("nav", { className: (this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse', id: "navbar-collapse-left", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' } }, (this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)),
                        React.createElement("nav", { className: "collapse navbar-collapse", id: "user-profile" },
                            React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                                React.createElement("li", { className: "user-nav-option" },
                                    React.createElement("div", { className: "user" },
                                        React.createElement("div", { className: "user-info-wrap" },
                                            " ",
                                            React.createElement("span", { className: "user-name" }, this.cookies.get('username')),
                                            React.createElement("div", { className: "balance-info" },
                                                " Balance",
                                                React.createElement("span", { className: "text-primary" }, "5,000 \u20AC "),
                                                React.createElement("a", { href: "javascript:void(0);" },
                                                    React.createElement("i", { className: "icon-plus-circular" })))))),
                                (this.cookies.get('username')) ?
                                    React.createElement("li", { className: (this.state.userDropdown === true) ? 'dropdown open' : 'dropdown' },
                                        React.createElement("a", { href: "javascript:void(0);", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (this.state.userDropdown) ? 'true' : 'false' },
                                            React.createElement("i", { className: "icon-menu-dots", onClick: function () { return _this.setState({ userDropdown: !_this.state.userDropdown }); } })),
                                        React.createElement("ul", { className: "dropdown-menu" },
                                            React.createElement("li", null,
                                                React.createElement(react_router_dom_1.Link, { to: "/myprofile" },
                                                    React.createElement("i", { className: "icon-profile" }),
                                                    "MY PROFILE")),
                                            React.createElement("li", { onClick: function () { return Utils.logout(); } },
                                                React.createElement(react_router_dom_1.Link, { to: "/login" },
                                                    React.createElement("i", { className: "icon-logout" }),
                                                    "LOGOUT"))))
                                    :
                                        null))))),
            React.createElement("div", { className: "info-ribbon" },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "h4 text-center" }, "PRIVACY POLICY"))),
            React.createElement("main", { className: "main" },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "panel panel-default" },
                        React.createElement("div", { className: "panel-body" },
                            React.createElement("div", { className: "panel-icon" },
                                React.createElement("i", { className: "icon-privacy" })),
                            React.createElement("div", { className: "core-text" },
                                "This privacy policy (The \u201Cpolicy\u201D)is for The Accumulator Club website (The \u201Cwebsite\u201D) located at www.accumulatorclub.com. The policy describes the way in which The Accumulator Club collects, processes, stores, uses and protects the personal data and information you provide.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Please read the policy carefully. Along with our terms of service, it governs your use of the website. By accepting this Privacy Policy you agree that you understand and accept the use of your personal information as set out in the policy. If you do not agree with the terms of this Privacy Policy please do not use the Website or otherwise provide us with your personal information.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Who we are"),
                                "For the purposes hereof, \u201CThe policy\u201D means this privacy policy, \u201CThe Accumulator Club\u201D, \u201Cwebsite\u201D, \u201Cwebsite owners\u201D, \u201Cwe\u201D or \u201Cus\u201D mean Fair Play Gaming Ltd, a company incorporated in the United Kingdom (company number 10636954) with its registered office at Home Mead, Camel Street, Marston Magna, Somerset, BA22 8DB.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "We are dedicated to safeguarding user privacy and ensure that the necessary steps are taken to protect the privacy of users throughout their visiting and gaming experience. We control the ways your Personal Data is collected and the purposes for which your Personal Data is used by The Accumulator Club, under our responsibilities as a \u201Cdata controller\u201D. We take the necessary actions and have the appropriate measures in place to adhere to applicable European data protection legislation.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "\u201CYou\u201D or \u201CUser/s\u201D mean persons using the internet or specifically persons visiting and participating in activities on The Accumulator Club website.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Contact us"),
                                "If you have any concerns, or would like more detail about how we process your Personal Data, you can contact us using ",
                                React.createElement("a", { href: "mailto:support@accumulatorclub.com" }, "support@accumulatorclub.com"),
                                ".",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Information Collected"),
                                "The information and data about you which we may collect, use and process includes the following:",
                                React.createElement("ul", null,
                                    React.createElement("li", null, "Information that you provide to us by filling in forms on the Website or any other information you submit to us via the Website or email"),
                                    React.createElement("li", null, "Records of correspondence, whether via the Website, forms or emails"),
                                    React.createElement("li", null, "Your responses to surveys or customer research that we carry out"),
                                    React.createElement("li", null, "Data from your IP address when entering the website, such as location data")),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Protecting Your Personal Data"),
                                "The law states that we can only process your Personal Data when there is a genuine reason to do so and it must be one of the following:",
                                React.createElement("ul", null,
                                    React.createElement("li", null, "To fulfil any contract that we have with you"),
                                    React.createElement("li", null, "We have a legal obligation"),
                                    React.createElement("li", null, "Where you have consented to the processing"),
                                    React.createElement("li", null, "When it is in our legitimate interest"),
                                    React.createElement("li", null, "When it is in the public interest"),
                                    React.createElement("li", null, "When it is in your vital interests")),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Use of data and information"),
                                "Users contacting this website and/or its owners do so at their own discretion and provide any such personal details requested at their own risk. Your personal information is kept private and stored securely until a time it is no longer required or has no use.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "The information that we store relating to you will mainly be used for fulfilling our obligation to you as part of our service. This primarily relates to, although is not limited to:",
                                React.createElement("ul", null,
                                    React.createElement("li", null, "Assisting you with any questions or queries you have submitted")),
                                React.createElement("br", null),
                                "We also deem the following to be within our legitimate interest, or your vital interests:",
                                React.createElement("ul", null,
                                    React.createElement("li", null, "Contacting you regarding a breach of our Terms of service"),
                                    React.createElement("li", null, "Notifying you of important deadlines and information for the games you have participated in"),
                                    React.createElement("li", null, "To make you aware of other relevant games as we launch them")),
                                React.createElement("br", null),
                                "If we use legitimate interests or your vital interests as a reason to process your Personal Data (or send you emails) we will also provide you with a method to manage what type of communications you receive. However, compelling grounds for processing such information may over-ride your right to object.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "How long we keep your Personal Data"),
                                "Whenever your data is kept by The Accumulator Club we will ensure that it is appropriately protected and only used for acceptable purposes.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "We will keep your data for the period that you hold an account at The Accumulator Club.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "If you would like us to remove your account and delete your data, you will need to contact us at the email address provided under \u201CContact us\u201D",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Cookies policy"),
                                "We use cookies to improve the user experience while visiting the website. Where applicable this website uses a static message to inform visitors of the use of cookies on their computer/device the first time they visit the site. The message will contain a link to this page where visitors can learn more about our cookie policy. Continued use of the website or removal of the message is confirmed acceptance of this policy.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Cookies are small files saved to the user\u2019s computer hard drive that track, save and store information about the user's interactions and usage of a website. This allows the website, through its server to provide the users with a tailored experience when visiting the website and returning to the website in the future.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "This website uses tracking software to monitor site traffic and better understand how visitors are using it. This software is provided by Google Analytics which uses cookies to track visitor usage. The software will save a cookie to your computer\u2019s hard drive in order to track and monitor your engagement and usage of the website. However, the software will not store, save or collect personal information. You can read Google's privacy policy here for more information \u2013 ",
                                React.createElement("a", { href: "https://privacy.google.com", target: "_blank" }, "www.google.com/privacy"),
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Cookies are also very commonly used in online advertising as they can be used to build a profile of the sites you are visiting. Advertisers can then direct more targeted advertisements, of more perceived interest to you while you surf the internet. This website provides advertising space and therefore, cookies may be stored on your computer\u2019s hard drive by external vendors when this website uses referral programs, sponsored links or adverts. Such cookies are used for conversion and referral tracking and typically expire after 30 days, though some may take longer. However, no personal information is ever stored, saved or collected.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Although cookies are used across almost every site on the internet, some users do not like the idea of this information being stored on their computer. Through your browser settings, it is possible to delete existing cookies and block them from being used in the future. However, this will mean you could lose some functionality on The Accumulator Club and other websites.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "This website \u2013 ",
                                React.createElement("a", { href: "https://www.aboutcookies.org", target: "_blank", style: { color: '#000', fontWeight: 'bold' } }, "www.aboutcookies.org"),
                                " \u2013 will help you explore your options when it comes to removing and turning off cookies in your browser.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "External links"),
                                "You may find links to third party websites on this website. These websites should have their own privacy policies, which you should check - We do not accept any responsibility or liability for their policies.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "The Accumulator Club cannot guarantee or verify the contents of any external linked website. Users should therefore note they click on external links at their own risk and this website and its owners cannot be held liable for any damages or implications caused by visiting the external links mentioned.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Adverts and Sponsored Links"),
                                "This website may contain sponsored links and adverts. These are delivered through our advertising partners who have their own detailed privacy policies relating directly to the adverts they deliver.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Clicking on any such adverts will send you to the advertiser\u2019s website through a referral program which may use cookies and will track the number of referrals sent from this website. This may include the use of cookies that will be saved on your computer\u2019s hard drive. Users should therefore note they click on adverts and sponsored links at their own risk and this website and it's owners cannot be held liable for any damages or implications caused by visiting any adverts and sponsored links mentioned.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Social Media Platforms"),
                                "Communication, engagement and actions taken through external social media platforms that this website and it's owners participate on are compliant with the terms and conditions and privacy policies held with each social media platform respectively.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Users are advised to use social media platforms wisely and communicate / engage upon them with due care and caution in regard to their own privacy and personal details. This website nor it's owners will ever ask for personal or sensitive information through social media platforms and encourage users wishing to discuss sensitive details to contact them through primary communication channels such as telephone or email.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "This website may use social sharing buttons which help share web content directly from web pages to the social media platform in question. Users are advised before using such social sharing buttons that they do so at their own discretion and note that the social media platform may track and save your request to share a web page respectively through your social media platform account.",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Disclosing your information"),
                                "We may only disclose your personal information to third parties:",
                                React.createElement("ul", null,
                                    React.createElement("li", null, "If we sell any or all of our business and/or our assets to a third party"),
                                    React.createElement("li", null, "If we are legally required to disclose your information"),
                                    React.createElement("li", null, "To assist with fraud protection and anti-money laundering initiatives")),
                                React.createElement("br", null),
                                React.createElement("div", { className: "h3" }, "Contact Us"),
                                "By using www.accumulatorclub.com you consent to our privacy policy. If you have any questions or queries regarding this privacy policy, please do not hesitate to contact:",
                                React.createElement("br", null),
                                React.createElement("a", { href: "mailto:support@accumulatorclub.com" }, "support@accumulatorclub.com"))))))));
    };
    return Privacy;
}(React.Component));
exports.Privacy = Privacy;
react_cookie_1.withCookies(Contact, HowToPlay, Terms, Privacy);


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var socket_init_1 = __webpack_require__(6);
var Utils = __webpack_require__(9);
// import { Logic } from '../../../Logic/Type'
var Main_1 = __webpack_require__(13);
// import * as Bet from './Bet'
// import * as RouteClasses from '../../../Socket/route-classes'
var react_router_dom_1 = __webpack_require__(5);
var react_cookie_1 = __webpack_require__(4);
var Type_1 = __webpack_require__(11);
// import FacebookProvider, { Like } from 'react-facebook'
var Body = __webpack_require__(7);
var Assets = __webpack_require__(3);
var Standings_1 = __webpack_require__(42);
var moment = __webpack_require__(19);
var Loader_1 = __webpack_require__(10);
var react_helmet_1 = __webpack_require__(18);
var openedGWs = [27, 28, 29, 30, 31, 32, 33];
function setPosition(position) {
    switch (position) {
        case 'G':
            return 'Goalkeeper';
        case 'D':
            return 'Defender';
        case 'M':
            return 'Midfielder';
        default:
            return 'Attacker';
    }
}
exports.setPosition = setPosition;
var Lounge = /** @class */ (function (_super) {
    __extends(Lounge, _super);
    function Lounge(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        _this.props.history.push('/lounge');
        _this.cookies = new react_cookie_1.Cookies();
        _this.state = {
            userDropdown: false,
            listen: false,
            showConfirmButton: null,
            mobileMenu: false,
            showTable: [false, false, false, false, false, false, false, false],
            popupTeam: false,
            popupPlayer: false
        };
        Type_1.Logic.Type.New(Main_1.Main.Instance.Fantasy, {
            chosenResults: undefined,
            selectedResult: ['-:-', '-:-', '-:-', '-:-', '-:-', '-:-', '-:-', '-:-', '-:-', '-:-'],
            selectedAcc: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        });
        localStorage.clear();
        socket_init_1.default.Send('rounds', { playerId: +_this.cookies.get('playerId') });
        socket_init_1.default.Send('user-leagues', { playerId: +_this.cookies.get('playerId'), tab: +_this.cookies.get('competitionTab') });
        socket_init_1.default.Send('get-leaderboard', { leagueId: 1204 });
        socket_init_1.default.Send('upcoming-fixtures', { competition: 'premier-league' });
        return _this;
    }
    Lounge.prototype.componentWillReceiveProps = function () {
        if (this.state.listen === true) {
            var matches = socket_init_1.default.Get('matches');
            var results = socket_init_1.default.Get('results');
            if (matches.loading === 'loaded' && results.loading === 'loaded') {
                Utils.fillChosenResults(matches, results);
                this.setState({ listen: false });
            }
        }
    };
    Lounge.prototype.componentDidUpdate = function () {
        var rounds = socket_init_1.default.Get('rounds');
        if (rounds.loading === 'loaded') {
            var currentTime = moment().local();
            var closestRound = rounds.rounds[0];
            for (var _i = 0, _a = rounds.rounds; _i < _a.length; _i++) {
                var item = _a[_i];
                var utcDeadline = moment.utc(item.deadline, 'llll');
                var deadline = moment(utcDeadline).local();
                var difference = currentTime.valueOf() - deadline.valueOf();
                if (+difference < 0) {
                    closestRound = item;
                    break;
                }
            }
            var roundsTable = document.getElementById('rounds-table');
            var firstRound = document.getElementById('round-1');
            if (roundsTable && firstRound) {
                roundsTable.scrollTop = firstRound.offsetHeight * (closestRound.roundId - 2);
            }
        }
    };
    Lounge.prototype.render = function () {
        var _this = this;
        if (Main_1.Main.Instance.Fantasy.chosenResults !== undefined) {
            return React.createElement(react_router_dom_1.Redirect, { to: { pathname: '/confirmation', state: { showConfirmButton: false } } });
        }
        var rounds = socket_init_1.default.Get('rounds');
        var userLeagues = socket_init_1.default.Get('user-leagues');
        var upcomingFixtures = socket_init_1.default.Get('upcoming-fixtures');
        var standings = socket_init_1.default.Get('get-leaderboard');
        if (rounds.loading !== 'loaded' || userLeagues.loading !== 'loaded' || upcomingFixtures.loading !== 'loaded' || standings.loading !== 'loaded') {
            return React.createElement(Loader_1.default, null);
        }
        else {
            return (React.createElement("section", { className: "wrapper" },
                React.createElement(react_helmet_1.Helmet, null,
                    React.createElement("meta", { charSet: "utf-8" }),
                    React.createElement("title", null, "The Accumulator Club \u2013 Premier League predictions - Lounge"),
                    React.createElement("meta", { name: "description", content: "Play our awesome free to play predictor game at The Accumulator Club and you can win\n                  cash. Make your predictions on a number of different betting markets and earn points based on real\n                  sportsbook odds. Visit the lounge, make your Premier League predictions and follow the action." })),
                React.createElement("div", { className: "header", role: "banner" },
                    React.createElement("header", { className: "navbar navbar-default" },
                        React.createElement("div", { className: "container", style: { marginBottom: '0' } },
                            React.createElement("div", { className: "navbar-header" },
                                React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                    React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" })),
                                React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                    React.createElement("img", { src: "logo-main2.png", alt: "", className: "logo" })),
                                React.createElement("span", { className: "navbar-toggle user-profile-trigger" }, this.cookies.get('username'))),
                            React.createElement("nav", { className: (this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse', id: "navbar-collapse-left", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' } }, (this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)),
                            React.createElement("nav", { className: "collapse navbar-collapse", id: "user-profile" },
                                React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                                    React.createElement("li", { className: "user-nav-option" },
                                        React.createElement("div", { className: "user" },
                                            React.createElement("div", { className: "user-info-wrap" },
                                                " ",
                                                React.createElement("span", { className: "user-name" }, this.cookies.get('username')),
                                                React.createElement("div", { className: "balance-info" },
                                                    " Balance",
                                                    React.createElement("span", { className: "text-primary" }, "5,000 \u20AC "),
                                                    React.createElement("a", { href: "javascript:void(0);" },
                                                        React.createElement("i", { className: "icon-plus-circular" })))))),
                                    (this.cookies.get('username')) ?
                                        React.createElement("li", { className: (this.state.userDropdown === true) ? 'dropdown open' : 'dropdown' },
                                            React.createElement("a", { href: "javascript:void(0);", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (this.state.userDropdown) ? 'true' : 'false' },
                                                React.createElement("i", { className: "icon-menu-dots", onClick: function () { return _this.setState({ userDropdown: !_this.state.userDropdown }); } })),
                                            React.createElement("ul", { className: "dropdown-menu" },
                                                React.createElement("li", null,
                                                    React.createElement(react_router_dom_1.Link, { to: "/myprofile" },
                                                        React.createElement("i", { className: "icon-profile" }),
                                                        "MY PROFILE")),
                                                React.createElement("li", { onClick: function () { return Utils.logout(); } },
                                                    React.createElement(react_router_dom_1.Link, { to: "/login" },
                                                        React.createElement("i", { className: "icon-logout" }),
                                                        "LOGOUT"))))
                                        :
                                            null))))),
                React.createElement("main", { className: "main" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "section-left" },
                            React.createElement("ul", { className: "nav nav-tabs nav-justified nav-lg", role: "tablist" },
                                React.createElement("li", { role: "presentation", className: "active" },
                                    React.createElement("a", { "aria-controls": "join", role: "tab", "data-toggle": "tab" }, "PREMIER LEAGUE 2018/19"))),
                            React.createElement("div", { className: "compition-table" },
                                React.createElement("div", { className: "tab-content custom" },
                                    React.createElement("div", { role: "tabpanel", className: "tab-pane active", id: "euro-2016" },
                                        React.createElement("div", { className: "lounge-rounds" },
                                            React.createElement("div", null,
                                                React.createElement("span", null, "COMPETITION"),
                                                React.createElement("span", null, "DEADLINE"),
                                                React.createElement("span", null, "PRIZE"),
                                                React.createElement("span", null)),
                                            React.createElement("div", { className: "rounds-table", id: "rounds-table" }, this.setRounds()))))),
                            React.createElement("div", { className: "league-rank" },
                                React.createElement("span", { className: "section-heading" }, "STANDINGS"),
                                React.createElement("div", { className: "standings-groups" },
                                    React.createElement("table", null,
                                        React.createElement("thead", null,
                                            React.createElement("tr", null,
                                                React.createElement("th", null, "#"),
                                                React.createElement("th", { style: { width: '40%' } }, "Team"),
                                                React.createElement("th", null, "Games Played"),
                                                React.createElement("th", { className: "mobile-hide" }, "Goals For"),
                                                React.createElement("th", { className: "mobile-hide" }, "Goals Against"),
                                                React.createElement("th", { className: "mobile-hide" }, "Goal Difference"),
                                                React.createElement("th", { style: { borderRight: '0' } }, "Points"))),
                                        React.createElement("tbody", null, this.setStandings()))))),
                        React.createElement("div", { className: "section-right" },
                            React.createElement("div", { className: "league-rank" },
                                React.createElement("div", { className: "section-heading" }, "SOCIAL CHANNELS"),
                                React.createElement("div", { className: "section-content" },
                                    React.createElement("span", { className: "social-span", style: { marginTop: '10px' } },
                                        React.createElement("iframe", { src: "https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Faccumulatorclub%2F&width=88&layout=button_count&action=like&size=large&show_faces=false&share=false&height=21&appId", width: "150", height: "30", style: { border: 'none', overflow: 'hidden' }, scrolling: "no" })),
                                    React.createElement("span", { className: "social-span", style: { background: '#1b95e0', marginBottom: '10px' } },
                                        React.createElement("a", { href: "https://twitter.com/TheAccaClub?ref_src=twsrc%5Etfw", target: "_blank", "data-show-count": "false" }, "Follow @TheAccaClub"),
                                        React.createElement("script", { async: true, src: "https://platform.twitter.com/widgets.js" })))),
                            (this.cookies.get('playerId')) ?
                                React.createElement("div", { className: "league-rank" },
                                    React.createElement("div", { className: "section-heading" }, "MY LEAGUES"),
                                    React.createElement("div", { className: "section-content" },
                                        React.createElement("div", { className: "row" },
                                            React.createElement("ul", { className: "list-unstyled" },
                                                React.createElement("li", { style: { background: 'rgb(231, 231, 231)' } },
                                                    React.createElement("div", { className: "league" },
                                                        React.createElement("span", { className: "bold" }, "Private leagues"),
                                                        React.createElement("span", null, ''))),
                                                this.setLeagues())),
                                        React.createElement("div", { className: "row", style: { background: 'rgb(231, 231, 231)' } },
                                            React.createElement("ul", { className: "list-unstyled" },
                                                React.createElement("li", null,
                                                    React.createElement(react_router_dom_1.Link, { onClick: function () { socket_init_1.default.Send('leaderboards', { playerId: +_this.cookies.get('playerId'), tab: +_this.cookies.get('competitionTab') }), localStorage.setItem('overallRanking', 'true'); }, to: "/leaderboards" },
                                                        React.createElement("div", { className: "league" },
                                                            React.createElement("span", { className: "bold" }, "Overall ranking"),
                                                            React.createElement("span", null, '')),
                                                        React.createElement("div", { className: "league-ranking" },
                                                            React.createElement("span", { className: "badge badge-warning bagde-rank" }, userLeagues.userLeagues[0].playerPosition.toString()))))))))
                                : null),
                        React.createElement("div", null, this.upcomingFixturesSection(upcomingFixtures))),
                    (this.state.popupTeam) ? this.showPopupTeam() : null,
                    (this.state.popupPlayer) ? this.showPopupPlayer() : null)));
        }
    };
    Lounge.prototype.upcomingFixturesSection = function (upcomingFixtures) {
        return (React.createElement("div", { className: "section-right" },
            React.createElement("div", { className: "league-rank" },
                React.createElement("div", { className: "section-heading" }, "UPCOMING FIXTURES"),
                React.createElement("div", { className: "section-content" },
                    React.createElement("div", { className: "row" }, this.setUpcomingFixtures(upcomingFixtures.upcomingFixtures))))));
    };
    Lounge.prototype.setStandings = function () {
        var _this = this;
        var rows = [];
        var leaderboard = socket_init_1.default.Get('get-leaderboard').leaderboard;
        var _loop_1 = function (i) {
            rows.push(React.createElement("tr", { key: rows.length, style: { background: (i % 2 === 0) ? 'rgb(241, 241, 241)' : 'rgb(255, 255, 255)' } },
                React.createElement("td", { style: { fontWeight: 'bold' } }, leaderboard[i].position),
                React.createElement("td", { style: { color: 'rgb(41, 160, 0)', fontWeight: 'bold', cursor: 'pointer' }, onClick: function () { socket_init_1.default.Send('get-team-info', { teamId: +leaderboard[i].id }), _this.setState({ popupTeam: true }); } }, leaderboard[i].name),
                React.createElement("td", null, leaderboard[i].gamesPlayed),
                React.createElement("td", { className: "mobile-hide" }, leaderboard[i].goalsFor),
                React.createElement("td", { className: "mobile-hide" }, leaderboard[i].goalsAgainst),
                React.createElement("td", { className: "mobile-hide" }, leaderboard[i].goalsDifference),
                React.createElement("td", null, leaderboard[i].points)));
        };
        for (var i = 0; i < leaderboard.length; i++) {
            _loop_1(i);
        }
        return rows;
    };
    Lounge.prototype.setRounds = function () {
        var _this = this;
        var playerId = this.cookies.get('playerId');
        var currentTime = moment().local();
        var roundsReturn = [];
        var rounds = socket_init_1.default.Get('rounds').rounds;
        var _loop_2 = function (i) {
            var utcDeadline = moment.utc(rounds[i].deadline, 'llll');
            var deadline = moment(utcDeadline).local();
            roundsReturn.push(React.createElement("div", { key: roundsReturn.length, id: 'round-' + (i + 1) },
                React.createElement("span", null,
                    React.createElement("b", null, rounds[i].roundName)),
                React.createElement("span", null, deadline.format('llll')),
                React.createElement("span", null, rounds[i].prizes),
                React.createElement("span", { style: { textAlign: 'right' } }, (rounds[i].played) ?
                    (currentTime > deadline) ?
                        React.createElement(react_router_dom_1.Link, { to: { pathname: '/results', state: { playerId: +this_1.cookies.get('playerId'), resultsRound: rounds[i].roundId, showConfirmButton: false } }, className: "btn btn-primary", onClick: function () { localStorage.setItem('roundId', rounds[i].roundId.toString()), socket_init_1.default.Send('results', { playerId: +_this.cookies.get('playerId'), round: rounds[i].roundId }); } }, "VIEW")
                        :
                            React.createElement("a", { className: "btn btn-primary", onClick: function () {
                                    localStorage.setItem('roundId', rounds[i].roundId.toString()),
                                        socket_init_1.default.Send('results', { playerId: +_this.cookies.get('playerId'), round: rounds[i].roundId }),
                                        socket_init_1.default.Send('matches', { round: rounds[i].roundId }),
                                        _this.setState({ listen: true, showConfirmButton: false });
                                } }, "VIEW")
                    :
                        (currentTime <= deadline || (openedGWs.includes(+rounds[i].roundId) && +playerId === 61) || +playerId >= 232) ?
                            React.createElement(react_router_dom_1.Link, { to: { pathname: '/betstep1', state: { showConfirmButton: true } }, className: "btn btn-primary", onClick: function () { localStorage.setItem('roundId', rounds[i].roundId.toString()), socket_init_1.default.Send('matches', { round: rounds[i].roundId }); } }, "JOIN")
                            :
                                React.createElement("a", { className: "btn btn-primary", onClick: function () { return alert('Deadline for this round has passed.'); } }, "JOIN"))));
        };
        var this_1 = this;
        for (var i = 0; i < rounds.length; i++) {
            _loop_2(i);
        }
        return roundsReturn;
    };
    Lounge.prototype.setLeagues = function () {
        var _this = this;
        var leaguesReturn = [];
        var userLeagues = socket_init_1.default.Get('user-leagues').userLeagues;
        if (userLeagues.length < 2) {
            leaguesReturn.push(React.createElement("li", { key: leaguesReturn.length },
                React.createElement(react_router_dom_1.Link, { to: (!this.cookies.get('playerId')) ? '/login' : '/leagues' },
                    React.createElement("div", { className: "league" },
                        React.createElement("span", { className: "bold" }, "No private league created yet!")))));
        }
        var _loop_3 = function (i) {
            leaguesReturn.push(React.createElement("li", { key: leaguesReturn.length },
                React.createElement(react_router_dom_1.Link, { to: "/leaderboards", onClick: function () {
                        socket_init_1.default.Send('leaderboards', { playerId: +_this.cookies.get('playerId'), tab: +_this.cookies.get('competitionTab'), league: userLeagues[i].leagueId }),
                            localStorage.setItem('leaderboardLeagueName', userLeagues[i].leagueName),
                            localStorage.setItem('leagueId', userLeagues[i].leagueId),
                            localStorage.setItem('leagueCode', userLeagues[i].leagueCode),
                            localStorage.setItem('overallRanking', 'false');
                    } },
                    React.createElement("div", { className: "league" },
                        React.createElement("span", { className: "bold" }, userLeagues[i].leagueName),
                        React.createElement("span", null,
                            "By ",
                            userLeagues[i].leagueAdmin)),
                    React.createElement("div", { className: "league-ranking" },
                        React.createElement("span", { className: "badge badge-warning bagde-rank" }, userLeagues[i].playerPosition.toString())))));
        };
        for (var i = 1; i < userLeagues.length; i++) {
            _loop_3(i);
        }
        return leaguesReturn;
    };
    Lounge.prototype.showPopupTeam = function () {
        var _this = this;
        var team = socket_init_1.default.Get('get-team-info');
        if (team.loading !== 'loaded') {
            return React.createElement(Loader_1.default, null);
        }
        else {
            var screenPosition = document.scrollingElement.scrollTop + 100;
            var top = screenPosition.toString() + 'px';
            var selectedTeam = team.teamInfo;
            return (React.createElement("div", { className: "popup" },
                React.createElement("div", { id: "popup-below", className: "popup-inner", style: { top: top, maxHeight: '600px', overflow: 'scroll' } },
                    React.createElement("div", { className: "team-info", style: { marginBottom: '20px' } },
                        React.createElement("div", { style: { position: 'relative', marginBottom: '20px' } },
                            React.createElement("span", { style: { marginRight: '20px' } },
                                React.createElement("img", { src: 'data:image/png;base64,' + selectedTeam.logo, style: { width: '70px', height: '60px' } })),
                            React.createElement("span", { className: "team-info-name" }, selectedTeam.name.toUpperCase()),
                            React.createElement("span", { className: "team-info-close" },
                                React.createElement("img", { src: "cancel.svg", style: { width: '30px', height: '30px' }, onClick: function () { return _this.setState({ popupTeam: false }); } }))),
                        React.createElement("div", { className: "team-data", style: { textAlign: 'left' } },
                            React.createElement("span", null,
                                "Coach: ",
                                React.createElement("p", null, selectedTeam.coach)))),
                    React.createElement("div", { className: "team-players" },
                        React.createElement("p", { style: { fontSize: '16px' } },
                            React.createElement("b", null, "TEAM SQUAD")),
                        React.createElement("div", { className: "team-table" }, this.setSquad(selectedTeam))))));
        }
    };
    Lounge.prototype.setSquad = function (team) {
        var _this = this;
        var players = [];
        var teamShirt = Standings_1.getTeamShirt(team.name);
        var _loop_4 = function (i) {
            var injured = team.sidelined.find(function (elt) { return +elt.id === +team.squad[i].id; });
            if (i === 0 || (team.squad[i - 1] && team.squad[i - 1].position !== team.squad[i].position)) {
                players.push(React.createElement("p", { key: players.length, style: { fontSize: '15px', marginBottom: '0' } },
                    React.createElement("b", null, setPosition(team.squad[i].position) + 's')));
            }
            players.push(React.createElement("div", { key: players.length, className: "team-table-player" },
                React.createElement("div", { className: "team-table-player-shirt" },
                    React.createElement("img", { src: teamShirt.src }),
                    React.createElement("div", { className: (team.squad[i].number.toString().length === 1) ? 'text-on-image shirt-one-number' : 'text-on-image shirt-two-numbers', style: { color: teamShirt.color, textShadow: teamShirt.textShadow } }, team.squad[i].number)),
                React.createElement("div", { style: { width: '65%', marginLeft: '5%' } },
                    React.createElement("span", { onClick: function () {
                            _this.setState({ popupPlayer: true }),
                                socket_init_1.default.Send('get-player-info', { playerId: team.squad[i].id });
                        } },
                        React.createElement("a", { style: { color: (injured) ? '#F03300' : 'rgb(41, 160, 0)' } }, team.squad[i].name)),
                    React.createElement("span", null, 'Age: ' + team.squad[i].age),
                    React.createElement("span", null, 'Appearances: ' + team.squad[i].appearences))));
        };
        for (var i = 0; i < team.squad.length; i++) {
            _loop_4(i);
        }
        return players;
    };
    Lounge.prototype.showPopupPlayer = function () {
        var _this = this;
        var team = socket_init_1.default.Get('get-team-info');
        var chosenPlayer = socket_init_1.default.Get('get-player-info');
        if (team.loading === 'loaded' && chosenPlayer.loading === 'loaded') {
            var playerProfile_1 = chosenPlayer.playerInfo;
            var selectedTeam = team.teamInfo;
            var screenPosition = document.scrollingElement.scrollTop + 100;
            document.getElementById('popup-below').style.zIndex = '0';
            var top = screenPosition.toString() + 'px';
            var injured = selectedTeam.sidelined.find(function (elt) { return +elt.id === +playerProfile_1.playerId; });
            return (React.createElement("div", { className: "popup" },
                React.createElement("div", { className: "popup-inner", style: { top: top } },
                    React.createElement("div", { className: "team-players" },
                        React.createElement("div", { style: { marginBottom: '20px', position: 'relative' } },
                            React.createElement("span", { style: { marginRight: '20px' } },
                                React.createElement("img", { src: 'data:image/png;base64,' + playerProfile_1.image, className: "player-profile-picture" })),
                            React.createElement("span", { className: "team-info-name team-info-player-name" }, playerProfile_1.name.toUpperCase()),
                            React.createElement("span", { className: "team-info-close" },
                                React.createElement("img", { src: "cancel.svg", style: { width: '30px', height: '30px' }, onClick: function () { return _this.setState({ popupPlayer: false }); } }))),
                        React.createElement("h3", null, "Profile"),
                        React.createElement("table", { className: "team-table" },
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("th", null, "Team"),
                                    React.createElement("th", null, "Position"),
                                    React.createElement("th", { className: "player-stats-hide" }, "Age"),
                                    React.createElement("th", null, "Club"),
                                    React.createElement("th", { className: "player-stats-hide" }, "Height"),
                                    React.createElement("th", { className: "player-stats-hide" }, "Weight"))),
                            React.createElement("tbody", null,
                                React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement("img", { src: 'data:image/png;base64,' + selectedTeam.logo, className: "player-team-logo" })),
                                    React.createElement("td", null, playerProfile_1.position),
                                    React.createElement("td", { className: "player-stats-hide" }, playerProfile_1.age),
                                    React.createElement("td", null, playerProfile_1.club),
                                    React.createElement("td", { className: "player-stats-hide" }, playerProfile_1.height),
                                    React.createElement("td", { className: "player-stats-hide" }, playerProfile_1.weight)))),
                        (injured) ?
                            React.createElement("div", null,
                                React.createElement("span", { style: { marginTop: '20px', fontSize: '20px', color: '#F03300' } },
                                    React.createElement("b", null, "Injury stats")),
                                React.createElement("div", { className: "injury-stats" },
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Injury: "),
                                        React.createElement("i", null, injured.description)),
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Injured from: "),
                                        React.createElement("i", null, injured.startDate)),
                                    React.createElement("span", null,
                                        React.createElement("b", null, "Expected comeback: "),
                                        React.createElement("i", null, (injured.endDate !== '') ? injured.endDate : 'Unknown'))))
                            : null,
                        React.createElement("div", null,
                            (playerProfile_1.thisSeasonStats) ? this.setPlayerStats(playerProfile_1.thisSeasonStats) : null,
                            (playerProfile_1.lastSeasonStats) ? this.setPlayerStats(playerProfile_1.lastSeasonStats) : null)))));
        }
    };
    Lounge.prototype.checkInjury = function (player, sidelined) {
        for (var _i = 0, sidelined_1 = sidelined; _i < sidelined_1.length; _i++) {
            var item = sidelined_1[_i];
            if (item.name === player)
                return item;
        }
    };
    Lounge.prototype.setPlayerStats = function (stats) {
        return (React.createElement("div", { className: "previous-seasons" },
            React.createElement("span", null,
                React.createElement("b", null, stats.competition + ' ' + stats.season)),
            React.createElement("table", { className: "team-table" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Appearances"),
                        React.createElement("th", null, "Starts"),
                        React.createElement("th", null, "Minutes"),
                        React.createElement("th", { className: "player-stats-hide" }, "Substitutes In"),
                        React.createElement("th", { className: "player-stats-hide" }, "Substitutes Out"),
                        React.createElement("th", null, "Goals"))),
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, stats.appearances),
                        React.createElement("td", null, stats.starts),
                        React.createElement("td", null, stats.minutes),
                        React.createElement("td", { className: "player-stats-hide" }, stats.substitutesin),
                        React.createElement("td", { className: "player-stats-hide" }, stats.substitutesout),
                        React.createElement("td", null, stats.goals))))));
    };
    Lounge.prototype.setUpcomingFixtures = function (fixtures) {
        var fixturesReturn = [];
        if (fixtures) {
            for (var i = 0; i < fixtures.length; i++) {
                var utcTime = moment.utc(fixtures[i].time, 'LT');
                var time = moment(utcTime).local();
                if (i === 0 || fixtures[i].date !== fixtures[i - 1].date) {
                    fixturesReturn.push(React.createElement("div", { key: fixturesReturn.length, className: "wedg-date" }, fixtures[i].date));
                }
                fixturesReturn.push(React.createElement("div", { key: fixturesReturn.length, className: "match-desc" },
                    React.createElement("span", null, fixtures[i].homeTeam),
                    React.createElement("span", { className: "two" }, fixtures[i].awayTeam),
                    React.createElement("label", null, time.format('LT'))));
            }
        }
        return fixturesReturn;
    };
    return Lounge;
}(React.Component));
exports.default = react_cookie_1.withCookies(Lounge);


/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var socket_init_1 = __webpack_require__(6);
var Utils = __webpack_require__(9);
// import { Logic } from '../../../Logic/Type'
// import { Main } from '../../../Logic/Main'
var Assets = __webpack_require__(3);
var Body = __webpack_require__(7);
var react_router_dom_1 = __webpack_require__(5);
var react_cookie_1 = __webpack_require__(4);
var moment = __webpack_require__(19);
var Loader_1 = __webpack_require__(10);
var Leaderboards = /** @class */ (function (_super) {
    __extends(Leaderboards, _super);
    function Leaderboards(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        _this.props.history.push('/leaderboards');
        _this.cookies = new react_cookie_1.Cookies();
        _this.state = {
            userDropdown: false,
            leaderboardTypeClicked: 1,
            leaderboardRoundClicked: null,
            listen: false,
            chosenPlayer: null,
            latestRound: null,
            mobileMenu: false,
            roundsDropdown: false,
            chosenRound: 'OVERALL',
            popup: false,
            numOfPages: 1,
            selectedPage: 1
        };
        socket_init_1.default.Send('rounds', { playerId: +_this.cookies.get('playerId') });
        socket_init_1.default.Send('leaderboards', { playerId: +_this.cookies.get('playerId'), tab: 1, league: +localStorage.getItem('leagueId') });
        return _this;
    }
    Leaderboards.prototype.componentWillReceiveProps = function () {
        if (this.state.listen === true) {
            var rounds = socket_init_1.default.Get('rounds');
            if (rounds.loading === 'loaded') {
                this.setState({
                    listen: false
                });
                var currentTime = moment.utc();
                var competitionRounds = [];
                if (!this.state.leaderboardRoundClicked) {
                    for (var i = 0; i < rounds.rounds.length; i++) {
                        var utcDeadline = moment.utc(rounds.rounds[i].deadline);
                        if (rounds.rounds[i].played && currentTime.isAfter(utcDeadline))
                            competitionRounds.push(rounds.rounds[i]);
                    }
                    var latestRound = Math.max.apply(Math, competitionRounds.map(function (x) { return x.roundId; }));
                    this.setState({ latestRound: latestRound });
                    socket_init_1.default.Send('results', { playerId: this.state.chosenPlayer, round: latestRound });
                }
                else {
                    this.setState({ latestRound: this.state.leaderboardRoundClicked });
                    socket_init_1.default.Send('results', { playerId: this.state.chosenPlayer, round: this.state.leaderboardRoundClicked });
                }
            }
        }
        var leaderboards = socket_init_1.default.Get('leaderboards');
        if (leaderboards.loading === 'loaded') {
            var lb = leaderboards.leaderboards.leaderboard;
            if (lb) {
                var numOfPages = Math.ceil(lb.length / 10);
                this.setState({ numOfPages: numOfPages });
            }
        }
    };
    Leaderboards.prototype.render = function () {
        var _this = this;
        if (this.state.latestRound !== null) {
            return React.createElement(react_router_dom_1.Redirect, { to: { pathname: '/results', state: { playerId: this.state.chosenPlayer, resultsRound: this.state.latestRound } } });
        }
        var leaderboards = socket_init_1.default.Get('leaderboards');
        var rounds = socket_init_1.default.Get('rounds');
        if (leaderboards.loading !== 'loaded' || rounds.loading !== 'loaded') {
            return React.createElement(Loader_1.default, null);
        }
        else {
            return (React.createElement("div", null,
                React.createElement("section", { className: "wrapper" },
                    React.createElement("div", { className: "header", role: "banner" },
                        React.createElement("header", { className: "navbar navbar-default", style: { marginBottom: '0' } },
                            React.createElement("div", { className: "container" },
                                React.createElement("div", { className: "navbar-header" },
                                    React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                        React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                        React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                        React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                        React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" })),
                                    React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                        React.createElement("img", { src: Assets.logoMain, alt: "", className: "logo" })),
                                    React.createElement("span", { className: "navbar-toggle user-profile-trigger" }, this.cookies.get('username'))),
                                React.createElement("nav", { className: (this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse', id: "navbar-collapse-left", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' } }, (this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)),
                                React.createElement("nav", { className: "collapse navbar-collapse", id: "user-profile" },
                                    React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                                        React.createElement("li", { className: "user-nav-option" },
                                            React.createElement("div", { className: "user" },
                                                React.createElement("div", { className: "user-info-wrap" },
                                                    " ",
                                                    React.createElement("span", { className: "user-name" }, this.cookies.get('username')),
                                                    React.createElement("div", { className: "balance-info" },
                                                        " Balance",
                                                        React.createElement("span", { className: "text-primary" }, "5,000 \u20AC "),
                                                        React.createElement("a", { href: "javascript:void(0);" },
                                                            React.createElement("i", { className: "icon-plus-circular" })))))),
                                        (this.cookies.get('username')) ?
                                            React.createElement("li", { className: (this.state.userDropdown === true) ? 'dropdown open' : 'dropdown' },
                                                React.createElement("a", { href: "javascript:void(0);", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (this.state.userDropdown) ? 'true' : 'false' },
                                                    React.createElement("i", { className: "icon-menu-dots", onClick: function () { return _this.setState({ userDropdown: !_this.state.userDropdown }); } })),
                                                React.createElement("ul", { className: "dropdown-menu" },
                                                    React.createElement("li", null,
                                                        React.createElement(react_router_dom_1.Link, { to: "/myprofile" },
                                                            React.createElement("i", { className: "icon-profile" }),
                                                            "MY PROFILE")),
                                                    React.createElement("li", { onClick: function () { return Utils.logout(); } },
                                                        React.createElement(react_router_dom_1.Link, { to: "/login" },
                                                            React.createElement("i", { className: "icon-logout" }),
                                                            "LOGOUT"))))
                                            :
                                                null))))),
                    React.createElement("div", { className: "info-ribbon" },
                        React.createElement("div", { className: "container" },
                            React.createElement("div", { className: "h4 text-center" }, "RANKINGS"))),
                    React.createElement("main", { className: "main" },
                        React.createElement("div", { className: "container" },
                            React.createElement("div", { className: "panel panel-default" },
                                React.createElement("div", { className: "panel-body" },
                                    React.createElement("div", { className: "panel-icon" },
                                        React.createElement("i", { className: "icon-trophy" })),
                                    React.createElement("div", { className: "clearfix" }),
                                    React.createElement("div", { className: "text-center " },
                                        React.createElement("div", { className: "clearfix mT20" }),
                                        React.createElement("div", { className: "h3 font-size-30" }, (localStorage.getItem('leaderboardLeagueName'))
                                            ? localStorage.getItem('leaderboardLeagueName')
                                            : 'Overall Ranking'),
                                        (localStorage.getItem('leaderboardLeagueName')) ?
                                            React.createElement("div", { className: "leaderboards-invite" },
                                                React.createElement("span", { onClick: function () { return _this.setState({ popup: true }); } }, "INVITE"))
                                            : null),
                                    React.createElement("div", { className: "data-list-table limited-width" },
                                        React.createElement("div", { className: "page-header border-light outer-header mTzero h5" },
                                            React.createElement("div", { className: "row" },
                                                React.createElement("div", { className: "col-sm-4 right leaderboards-header-50" },
                                                    React.createElement("div", { className: "row" },
                                                        React.createElement("div", { className: "col-xs-4 leaderboard-round" },
                                                            React.createElement("label", { style: { fontWeight: 'normal' } }, "Round")),
                                                        React.createElement("div", { className: "col-xs-8" },
                                                            React.createElement("span", { onClick: function () { return _this.setState({ roundsDropdown: !_this.state.roundsDropdown }); }, className: (this.state.roundsDropdown) ? 'leaderboards-round-selection select2 select2-container select2-container--default select2-container--below select2-container--focus select2-container--open' : 'leaderboards-round-selection select2 select2-container select2-container--default select2-container--below select2-container--focus', dir: "ltr" },
                                                                React.createElement("span", { className: "selection" },
                                                                    React.createElement("span", { className: "select2-selection select2-selection--single", role: "combobox", "aria-haspopup": "true", "aria-expanded": (this.state.roundsDropdown) ? 'true' : 'false', "aria-labelledby": "select2--cy-container", "aria-owns": (this.state.roundsDropdown) ? 'select2--cy-results' : null },
                                                                        React.createElement("span", { className: "select2-selection__rendered", id: "select2--cy-container", title: "MD 1" }, this.state.chosenRound),
                                                                        React.createElement("span", { className: "select2-selection__arrow", role: "presentation" },
                                                                            React.createElement("b", { role: "presentation" })))),
                                                                React.createElement("span", { className: "dropdown-wrapper", "aria-hidden": "true" })),
                                                            (this.state.roundsDropdown) ?
                                                                React.createElement("span", { className: "select2-container select2-container--default select2-container--open" },
                                                                    React.createElement("span", { className: "select2-dropdown select2-dropdown--below leaderboards-rounds-dropdown results-round-selection", style: { display: 'inline-block' }, dir: "ltr" },
                                                                        React.createElement("span", { className: "select2-search select2-search--dropdown select2-search--hide" },
                                                                            React.createElement("input", { className: "select2-search__field", type: "search", role: "textbox" })),
                                                                        React.createElement("span", { className: "select2-results" },
                                                                            React.createElement("ul", { className: "select2-results__options", role: "tree", id: "select2--cy-results", "aria-expanded": "true", "aria-hidden": "false" }, this.getRoundsNames()))))
                                                                : null))))),
                                        React.createElement("span", { className: "user-info" },
                                            React.createElement("b", null, "User Info")),
                                        React.createElement("table", null,
                                            React.createElement("thead", null,
                                                React.createElement("tr", null,
                                                    React.createElement("th", null, "RANK"),
                                                    React.createElement("th", { className: "username" }, "USERNAME"),
                                                    React.createElement("th", { className: "leaderboard-stats-hide" }, "CORRECT SCORES"),
                                                    React.createElement("th", { className: "leaderboard-stats-hide" }, "GOAL MARKETS"),
                                                    React.createElement("th", { className: "leaderboard-stats-hide" }, "GOALSCORERS"),
                                                    React.createElement("th", null, "OVERALL PTS"))),
                                            React.createElement("tbody", null, (leaderboards.leaderboards.message) ?
                                                React.createElement("tr", null,
                                                    React.createElement("td", null, leaderboards.leaderboards.message))
                                                : (leaderboards.leaderboards.playerStats) ?
                                                    this.setPlayerStats()
                                                    : React.createElement("tr", { style: { background: '#E7E7E7' } },
                                                        React.createElement("td", null,
                                                            React.createElement("span", { className: "badge badge-warning bagde-rank" }, (leaderboards.leaderboards.leaderboard.length === 1) ? 1
                                                                : (leaderboards.leaderboards.leaderboard.length === 2) ? 2
                                                                    : (leaderboards.leaderboards.leaderboard.length + 1))),
                                                        React.createElement("td", null,
                                                            React.createElement("span", { className: "bold" }, this.cookies.get('username'))),
                                                        React.createElement("td", { className: "leaderboard-stats-hide" }, "-"),
                                                        React.createElement("td", { className: "leaderboard-stats-hide" }, "-"),
                                                        React.createElement("td", { className: "leaderboard-stats-hide" }, "-"),
                                                        React.createElement("td", null, "-")))),
                                        (leaderboards.leaderboards.message) ? null
                                            :
                                                React.createElement("table", { style: { marginBottom: '30px' } },
                                                    React.createElement("thead", null,
                                                        React.createElement("tr", null,
                                                            React.createElement("th", null, "RANK"),
                                                            React.createElement("th", { className: "username" }, "USERNAME"),
                                                            React.createElement("th", { className: "leaderboard-stats-hide" }, "CORRECT SCORES"),
                                                            React.createElement("th", { className: "leaderboard-stats-hide" }, "GOAL MARKETS"),
                                                            React.createElement("th", { className: "leaderboard-stats-hide" }, "GOALSCORERS"),
                                                            React.createElement("th", null, "OVERALL PTS"))),
                                                    React.createElement("tbody", null, this.setLeaderboard()))),
                                    React.createElement("div", { style: { float: 'right' } },
                                        React.createElement("img", { style: { cursor: 'pointer' }, onClick: function () { if (_this.state.selectedPage > 1)
                                                _this.setState({ selectedPage: _this.state.selectedPage - 1 }); }, src: "left-arrow.png" }),
                                        React.createElement("b", { style: { margin: '0 10px' } }, 'Page ' + this.state.selectedPage + ' / ' + this.state.numOfPages),
                                        React.createElement("img", { style: { cursor: 'pointer' }, onClick: function () { if (_this.state.selectedPage < _this.state.numOfPages)
                                                _this.setState({ selectedPage: _this.state.selectedPage + 1 }); }, src: "right-arrow.png" }))))),
                        (this.state.popup) ? this.showPopup() : null))));
        }
    };
    Leaderboards.prototype.getRoundsNames = function () {
        var _this = this;
        var rounds = socket_init_1.default.Get('rounds');
        var roundsNames = [];
        roundsNames.push(React.createElement("li", { key: roundsNames.length, className: "select2-results__option", role: "treeitem", "aria-selected": (this.state.chosenRound === 'OVERALL') ? 'true' : 'false', onClick: function () {
                _this.changeType(null, _this.state.leaderboardTypeClicked, +localStorage.getItem('leagueId')),
                    _this.setState({ chosenRound: 'OVERALL', roundsDropdown: false });
            } }, "OVERALL"));
        var currentTime = moment().local();
        var _loop_1 = function (i) {
            var utcDeadline = moment.utc(rounds.rounds[i].deadline);
            var deadline = moment(utcDeadline).local();
            if (currentTime > deadline) {
                roundsNames.push(React.createElement("li", { key: roundsNames.length, className: "select2-results__option", role: "treeitem", "aria-selected": (this_1.state.chosenRound === rounds.rounds[i].roundName) ? 'true' : 'false', onClick: function () {
                        _this.changeType(rounds.rounds[i].roundId, _this.state.leaderboardTypeClicked, +localStorage.getItem('leagueId')),
                            _this.setState({ chosenRound: rounds.rounds[i].roundName, roundsDropdown: false });
                    } }, rounds.rounds[i].roundName));
            }
        };
        var this_1 = this;
        for (var i = 0; i < rounds.rounds.length; i++) {
            _loop_1(i);
        }
        return roundsNames;
    };
    Leaderboards.prototype.changeType = function (leaderboardRoundClicked, leaderboardTypeClicked, league) {
        this.setState({
            leaderboardRoundClicked: leaderboardRoundClicked,
            leaderboardTypeClicked: leaderboardTypeClicked
        });
        if (localStorage.getItem('leaderboardLeagueName') === 'true') {
            if (leaderboardTypeClicked === 2) {
                socket_init_1.default.Send('leaderboards', {
                    playerId: +this.cookies.get('playerId'),
                    tab: +this.cookies.get('competitionTab'),
                    round: leaderboardRoundClicked,
                    nationality: (this.cookies.get('nationality'))
                });
            }
            else {
                socket_init_1.default.Send('leaderboards', {
                    playerId: +this.cookies.get('playerId'),
                    tab: +this.cookies.get('competitionTab'),
                    round: leaderboardRoundClicked
                });
            }
        }
        else {
            socket_init_1.default.Send('leaderboards', {
                playerId: +this.cookies.get('playerId'),
                tab: +this.cookies.get('competitionTab'),
                league: league,
                round: leaderboardRoundClicked
            });
        }
    };
    Leaderboards.prototype.getUserResults = function (player) {
        this.setState({ chosenPlayer: player });
        socket_init_1.default.Send('rounds', { playerId: player });
    };
    Leaderboards.prototype.setLeaderboard = function () {
        var _this = this;
        var leaderboardReturn = [];
        var leaderboards = socket_init_1.default.Get('leaderboards').leaderboards;
        if (leaderboards.leaderboard) {
            var forFrom = (this.state.selectedPage * 10) - 10;
            var forTo = (this.state.selectedPage * 10) - 1;
            if (this.state.selectedPage === this.state.numOfPages)
                forTo = leaderboards.leaderboard.length - 1;
            var _loop_2 = function (i) {
                leaderboardReturn.push(React.createElement("tr", { key: leaderboardReturn.length, style: (leaderboards.playerStats && leaderboards.leaderboard[i].player === leaderboards.playerStats.player) ? { background: '#E7E7E7' } : null },
                    React.createElement("td", null,
                        React.createElement("span", { className: "badge badge-warning bagde-rank" }, leaderboards.leaderboard[i].position)),
                    React.createElement("td", null,
                        React.createElement("a", { href: "javascript:void(0);", onClick: function () { _this.getUserResults(leaderboards.leaderboard[i].playerId), _this.setState({ listen: true }); } },
                            React.createElement("span", { className: "bold" }, leaderboards.leaderboard[i].player))),
                    React.createElement("td", { className: "leaderboard-stats-hide" }, leaderboards.leaderboard[i].correctScorePoints),
                    React.createElement("td", { className: "leaderboard-stats-hide" }, leaderboards.leaderboard[i].accumulatorPoints),
                    React.createElement("td", { className: "leaderboard-stats-hide" }, leaderboards.leaderboard[i].goalscorersPoints),
                    React.createElement("td", null, leaderboards.leaderboard[i].totalPoints)));
            };
            for (var i = forFrom; i <= forTo; i++) {
                _loop_2(i);
            }
        }
        return leaderboardReturn;
    };
    Leaderboards.prototype.setPlayerStats = function () {
        var playerStats = socket_init_1.default.Get('leaderboards').leaderboards.playerStats;
        return (React.createElement("tr", { style: { background: '#E7E7E7' } },
            React.createElement("td", null,
                React.createElement("span", { className: "badge badge-warning bagde-rank" }, playerStats.position)),
            React.createElement("td", null,
                React.createElement("span", { className: "bold" }, playerStats.player)),
            React.createElement("td", { className: "leaderboard-stats-hide" }, playerStats.correctScorePoints),
            React.createElement("td", { className: "leaderboard-stats-hide" }, playerStats.accumulatorPoints),
            React.createElement("td", { className: "leaderboard-stats-hide" }, playerStats.goalscorersPoints),
            React.createElement("td", null, playerStats.totalPoints)));
    };
    Leaderboards.prototype.showPopup = function () {
        var _this = this;
        var screenPosition = document.documentElement.scrollTop + 150;
        var top = screenPosition.toString() + 'px';
        return (React.createElement("div", { className: "popup" },
            React.createElement("div", { className: "popup-inner popup-forgot", style: { top: top } },
                React.createElement("div", { style: { textAlign: 'right', margiemailsnBottom: '10px' } },
                    React.createElement("img", { src: "cancel-black.png", onClick: function () { return _this.setState({ popup: false }); }, style: { cursor: 'pointer' } })),
                React.createElement("div", null,
                    React.createElement("p", { className: "congratulations-third" }, "Use the Code given below to share directly with your friends."),
                    React.createElement("div", { className: "congratulations-code" },
                        React.createElement("span", null, "Code"),
                        React.createElement("span", null, localStorage.getItem('leagueCode')))))));
    };
    return Leaderboards;
}(React.Component));
exports.Leaderboards = Leaderboards;
react_cookie_1.withCookies(Leaderboards);
react_router_dom_1.withRouter(Leaderboards);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
// import { Main } from '../../../Logic/Main'
var Body = __webpack_require__(7);
// import * as Lounge from './Lounge'
var socket_init_1 = __webpack_require__(6);
var Assets = __webpack_require__(3);
var Utils = __webpack_require__(9);
// import * as Utils from '../../../Logic/Utils'
// import * as Assets from '../../../assets/Assets'
var react_router_dom_1 = __webpack_require__(5);
var react_cookie_1 = __webpack_require__(4);
var Loader_1 = __webpack_require__(10);
var react_helmet_1 = __webpack_require__(18);
var Leagues = /** @class */ (function (_super) {
    __extends(Leagues, _super);
    function Leagues(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        _this.cookies = new react_cookie_1.Cookies();
        _this.state = {
            userDropdown: false,
            leaguesTab: 1,
            leagueName: '',
            leagueCode: '',
            mobileMenu: false,
            emails: ''
        };
        socket_init_1.default.Send('user-leagues', { playerId: +_this.cookies.get('playerId'), tab: +_this.cookies.get('competitionTab') });
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        return _this;
    }
    Leagues.prototype.handleInput = function (value, state) {
        this.state[state] = value;
        this.setState(this.state);
    };
    Leagues.prototype.handleSubmit = function (event) {
        event.preventDefault();
        if (this.state.emails === '') {
            alert('Please write at least one email address.');
        }
        else {
            socket_init_1.default.Send('send-league-code', { email: this.state.emails });
        }
    };
    Leagues.prototype.render = function () {
        var _this = this;
        var createLeagueReturn = socket_init_1.default.Get('create-league');
        var joinLeagueReturn = socket_init_1.default.Get('join-league');
        var userLeagues = socket_init_1.default.Get('user-leagues');
        if (userLeagues.loading !== 'loaded') {
            return React.createElement(Loader_1.default, null);
        }
        else {
            return (React.createElement("section", { className: "wrapper" },
                React.createElement(react_helmet_1.Helmet, null,
                    React.createElement("meta", { charSet: "utf-8" }),
                    React.createElement("title", null, "The Accumulator Club \u2013 Premier League predictions - Leagues"),
                    React.createElement("meta", { name: "description", content: "The Accumulator Club is the ultimate punting championship \u2013 Compete in private\n                            leagues against friends and colleagues in this free to play football game. Our unique social betting\n                            format awards points for correct predictions based on real sportsbook odds, who is the best punter?" })),
                React.createElement("div", { className: "header", role: "banner" },
                    React.createElement("header", { className: "navbar navbar-default", style: { marginBottom: '0' } },
                        React.createElement("div", { className: "container" },
                            React.createElement("div", { className: "navbar-header" },
                                React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                    React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" })),
                                React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                    React.createElement("img", { src: Assets.logoMain, alt: "", className: "logo" })),
                                React.createElement("span", { className: "navbar-toggle user-profile-trigger" }, this.cookies.get('username'))),
                            React.createElement("nav", { className: (this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse', id: "navbar-collapse-left", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' } }, (this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)),
                            React.createElement("nav", { className: "collapse navbar-collapse", id: "user-profile" },
                                React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                                    React.createElement("li", { className: "user-nav-option" },
                                        React.createElement("div", { className: "user" },
                                            React.createElement("div", { className: "user-info-wrap" },
                                                " ",
                                                React.createElement("span", { className: "user-name" }, this.cookies.get('username')),
                                                React.createElement("div", { className: "balance-info" },
                                                    " Balance",
                                                    React.createElement("span", { className: "text-primary" }, "5,000 \u20AC "),
                                                    React.createElement("a", { href: "javascript:void(0);" },
                                                        React.createElement("i", { className: "icon-plus-circular" })))))),
                                    (this.cookies.get('username')) ?
                                        React.createElement("li", { className: (this.state.userDropdown === true) ? 'dropdown open' : 'dropdown' },
                                            React.createElement("a", { href: "javascript:void(0);", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (this.state.userDropdown) ? 'true' : 'false' },
                                                React.createElement("i", { className: "icon-menu-dots", onClick: function () { return _this.setState({ userDropdown: !_this.state.userDropdown }); } })),
                                            React.createElement("ul", { className: "dropdown-menu" },
                                                React.createElement("li", null,
                                                    React.createElement(react_router_dom_1.Link, { to: "/myprofile" },
                                                        React.createElement("i", { className: "icon-profile" }),
                                                        "MY PROFILE")),
                                                React.createElement("li", { onClick: function () { return Utils.logout(); } },
                                                    React.createElement(react_router_dom_1.Link, { to: "/login" },
                                                        React.createElement("i", { className: "icon-logout" }),
                                                        "LOGOUT"))))
                                        :
                                            null))))),
                React.createElement("main", { className: "main" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "section-left" },
                            React.createElement("div", { className: "left-cont-main " },
                                React.createElement("div", { className: "section-content pad_zero" },
                                    React.createElement("ul", { className: "nav nav-tabs nav-justified nav-lg leagues-tabs", role: "tablist" },
                                        React.createElement("li", { role: "presentation", className: (this.state.leaguesTab === 1) ? 'active league-font' : 'league-font' },
                                            React.createElement("a", { href: "javascript:void(0);", onClick: function () { return _this.setState({ leaguesTab: 1 }); }, "aria-expanded": (this.state.leaguesTab === 1) ? 'true' : 'false', "aria-controls": "create", role: "tab", "data-toggle": "tab" }, "CREATE A  LEAGUE")),
                                        React.createElement("li", { role: "presentation", className: (this.state.leaguesTab === 2) ? 'active league-font' : 'league-font' },
                                            React.createElement("a", { href: "javascript:void(0);", onClick: function () { return _this.setState({ leaguesTab: 2 }); }, "aria-expanded": (this.state.leaguesTab === 2) ? 'true' : 'false', "aria-controls": "join", role: "tab", "data-toggle": "tab" }, "JOIN  A  LEAGUE"))),
                                    React.createElement("div", { className: "tab-content custom" }, (this.state.leaguesTab === 1) ?
                                        React.createElement("div", { role: "tabpanel", className: "tab-pane active", id: "create-a-league" },
                                            React.createElement("span", { className: "bold" }, "Accumulator Club"),
                                            " immerses you in the middle of the action! Push the excitement and competition to the max, test that Football brain and find your punting strategy to get ahead. You will automatically compete for global supremacy and top prizes, but you can also challenge friends and colleagues and see who comes out on top in your own private league.",
                                            React.createElement("div", { className: "clearfix mT20" }),
                                            React.createElement("span", null, "It\u2019s simple, just enter a suitable name for your league in the box below, click to CREATE and job done \u2013 You will see your unique league code on-screen and a copy will be sent to your email. Share it with friends and foes and enjoy this unique gaming experience \u2013 Good luck!"),
                                            React.createElement("div", { className: "clearfix mT20" }),
                                            React.createElement("div", { className: "form-400" },
                                                React.createElement("div", { className: "form-group" },
                                                    React.createElement("label", null, "League Name"),
                                                    React.createElement("input", { type: "text", id: "L_name", className: "form-control", placeholder: "", value: this.state.leagueName, onChange: function (event) { return _this.handleInput(event.target.value, 'leagueName'); } })),
                                                React.createElement("div", { className: "clearfix mT20" }),
                                                React.createElement("div", { className: "form-group" },
                                                    React.createElement("button", { className: "btn btn-lg btn-block btn-primary no-shadow", onClick: function () { return _this.createLeague(); } }, "CREATE"))))
                                        :
                                            React.createElement("div", { role: "tabpanel", className: "tab-pane active", id: "join-a-league" },
                                                React.createElement("span", null, "Has someone sent you a code to join a private league? ...What a legend! In addition to battling with friends and foes for top spot in your private league, you will automatically compete for global supremacy and top prizes as well."),
                                                React.createElement("div", { className: "clearfix mT20" }),
                                                React.createElement("span", null, "Please enter the code in the box below and click CONFIRM THE CODE. As long as the code is valid you will see a message to say you\u2019re in. Shortly afterwards you will be able to access the league table from this page (LEAGUES), or the LOUNGE page. Enjoy this unique gaming experience and good luck!"),
                                                React.createElement("div", { className: "clearfix mT20" }),
                                                React.createElement("div", { className: "form-400" },
                                                    React.createElement("div", { className: (joinLeagueReturn.joinLeague && joinLeagueReturn.joinLeague.error) ? 'form-group has-error' : 'form-group' },
                                                        React.createElement("label", null, "Code"),
                                                        React.createElement("input", { type: "text", id: "code", className: "form-control", placeholder: "", value: this.state.leagueCode, onChange: function (event) { return _this.handleInput(event.target.value, 'leagueCode'); } }),
                                                        React.createElement("span", { className: "error-block" },
                                                            React.createElement("span", null, "Incorrect Code")),
                                                        React.createElement("span", { className: "error-block-lg" }, "Ooops! There is no league associated with this code. Please check and try again.")),
                                                    React.createElement("div", { className: "clearfix mT20" }),
                                                    React.createElement("div", { className: "form-group" },
                                                        React.createElement("button", { className: "btn btn-lg btn-block btn-primary no-shadow", onClick: function () { return _this.joinLeague(); } }, "CONFIRM THE CODE")))))))),
                        React.createElement("div", { className: "section-right" },
                            React.createElement("div", { className: "league-rank" },
                                React.createElement("div", { className: "section-heading" }, "SOCIAL CHANNELS"),
                                React.createElement("div", { className: "section-content" },
                                    React.createElement("span", { className: "social-span", style: { marginTop: '10px' } },
                                        React.createElement("iframe", { src: "https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Faccumulatorclub%2F&width=88&layout=button_count&action=like&size=large&show_faces=false&share=false&height=21&appId", width: "150", height: "30", style: { border: 'none', overflow: 'hidden' }, scrolling: "no" })),
                                    React.createElement("span", { className: "social-span", style: { background: '#1b95e0', marginBottom: '10px' } },
                                        React.createElement("a", { href: "https://twitter.com/TheAccaClub?ref_src=twsrc%5Etfw", "data-show-count": "false" }, "Follow @TheAccaClub"),
                                        React.createElement("script", { async: true, src: "https://platform.twitter.com/widgets.js" })))),
                            (this.cookies.get('playerId')) ?
                                React.createElement("div", { className: "league-rank" },
                                    React.createElement("div", { className: "section-heading" }, "MY LEAGUES"),
                                    React.createElement("div", { className: "section-content" },
                                        React.createElement("div", { className: "row" },
                                            React.createElement("ul", { className: "list-unstyled" },
                                                React.createElement("li", { style: { background: 'rgb(231, 231, 231)' } },
                                                    React.createElement("div", { className: "league" },
                                                        React.createElement("span", { className: "bold" }, "Private leagues"),
                                                        React.createElement("span", null, ''))),
                                                this.setLeagues())),
                                        React.createElement("div", { className: "row", style: { background: 'rgb(231, 231, 231)' } },
                                            React.createElement("ul", { className: "list-unstyled" },
                                                React.createElement("li", null,
                                                    React.createElement(react_router_dom_1.Link, { onClick: function () { return socket_init_1.default.Send('leaderboards', { playerId: +_this.cookies.get('playerId'), tab: +_this.cookies.get('competitionTab') }); }, to: { pathname: '/leaderboards', state: { overallRanking: true } } },
                                                        React.createElement("div", { className: "league" },
                                                            React.createElement("span", { className: "bold" }, "Overall ranking"),
                                                            React.createElement("span", null, '')),
                                                        React.createElement("div", { className: "league-ranking" },
                                                            React.createElement("span", { className: "badge badge-warning bagde-rank" }, userLeagues.userLeagues[0].playerPosition.toString()))))))))
                                : null)),
                    (createLeagueReturn.createLeague && createLeagueReturn.createLeague.leagueCode) ?
                        this.showPopup(1)
                        : null,
                    (joinLeagueReturn.joinLeague && joinLeagueReturn.joinLeague.leagueName) ?
                        this.showPopup(2)
                        : null)));
        }
    };
    Leagues.prototype.createLeague = function () {
        socket_init_1.default.Send('create-league', { adminId: +this.cookies.get('playerId'), leagueName: this.state.leagueName, tab: +this.cookies.get('competitionTab') });
        this.setState({
            leagueName: ''
        });
    };
    Leagues.prototype.joinLeague = function () {
        socket_init_1.default.Send('join-league', { playerId: +this.cookies.get('playerId'), leagueKey: this.state.leagueCode });
        this.setState({
            leagueCode: ''
        });
    };
    Leagues.prototype.setLeagues = function () {
        var _this = this;
        var leaguesReturn = [];
        var userLeagues = socket_init_1.default.Get('user-leagues').userLeagues;
        if (userLeagues.length < 2) {
            leaguesReturn.push(React.createElement("li", { key: leaguesReturn.length },
                React.createElement(react_router_dom_1.Link, { to: (!this.cookies.get('playerId')) ? '/login' : '/leagues' },
                    React.createElement("div", { className: "league" },
                        React.createElement("span", { className: "bold" }, "No private league created yet!")))));
        }
        var _loop_1 = function (i) {
            leaguesReturn.push(React.createElement("li", { key: leaguesReturn.length },
                React.createElement(react_router_dom_1.Link, { to: "/leaderboards", onClick: function () {
                        socket_init_1.default.Send('leaderboards', { playerId: +_this.cookies.get('playerId'), tab: +_this.cookies.get('competitionTab'), league: userLeagues[i].leagueId });
                        localStorage.setItem('leaderboardLeagueName', userLeagues[i].leagueName);
                        localStorage.setItem('leagueId', userLeagues[i].leagueId);
                        localStorage.setItem('leagueCode', userLeagues[i].leagueCode);
                        localStorage.setItem('overallRanking', 'false');
                    } },
                    React.createElement("div", { className: "league" },
                        React.createElement("span", { className: "bold" }, userLeagues[i].leagueName),
                        React.createElement("span", null,
                            "By ",
                            userLeagues[i].leagueAdmin)),
                    React.createElement("div", { className: "league-ranking" },
                        React.createElement("span", { className: "badge badge-warning bagde-rank" }, userLeagues[i].playerPosition.toString())))));
        };
        for (var i = 1; i < userLeagues.length; i++) {
            _loop_1(i);
        }
        return leaguesReturn;
    };
    Leagues.prototype.showPopup = function (type) {
        var _this = this;
        var screenPosition = document.documentElement.scrollTop + 150;
        var top = screenPosition.toString() + 'px';
        var createLeague = socket_init_1.default.Get('create-league').createLeague;
        var joinLeague = socket_init_1.default.Get('join-league').joinLeague;
        return (React.createElement("div", { className: "popup" },
            React.createElement("div", { className: "popup-inner popup-forgot", style: { top: top } },
                React.createElement("div", { style: { textAlign: 'right', marginBottom: '10px' } },
                    React.createElement("img", { src: "cancel-black.png", onClick: function () {
                            socket_init_1.default.Send('user-leagues', { playerId: +_this.cookies.get('playerId'), tab: +_this.cookies.get('competitionTab') });
                            socket_init_1.default.Set('create-league', {});
                            socket_init_1.default.Set('join-league', {});
                            if (type === 1)
                                socket_init_1.default.Send('send-league-code', { username: _this.cookies.get('username'), leagueName: createLeague.leagueName, leagueCode: createLeague.leagueCode });
                        }, style: { cursor: 'pointer' } })),
                React.createElement("p", { className: "congratulations-first" }, "Congratulations!"),
                (type === 1) ?
                    React.createElement("p", { className: "congratulations-second" },
                        "Your league ",
                        React.createElement("span", { style: { color: 'rgb(41, 160, 0)' } }, createLeague.leagueName),
                        " has been created successfully.")
                    :
                        React.createElement("p", { className: "congratulations-second" },
                            "You have succesfully joined league ",
                            React.createElement("span", { style: { color: 'rgb(41, 160, 0)' } }, joinLeague.leagueName),
                            "."),
                (type === 1) ?
                    React.createElement("div", null,
                        React.createElement("p", { className: "congratulations-third" }, "Use the Code given below to share directly with your friends."),
                        React.createElement("div", { className: "congratulations-code" },
                            React.createElement("span", null, "Code"),
                            React.createElement("span", null, createLeague.leagueCode)))
                    : null)));
    };
    return Leagues;
}(React.Component));
exports.default = react_cookie_1.withCookies(Leagues);


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
// import Socket from '../../../Socket/socket-init'
// import { Logic } from '../../../Logic/Type'
// import { Main } from '../../../Logic/Main'
var react_router_dom_1 = __webpack_require__(5);
var react_cookie_1 = __webpack_require__(4);
var socket_init_1 = __webpack_require__(6);
var Assets = __webpack_require__(3);
var Body = __webpack_require__(7);
var Utils = __webpack_require__(9);
var Loader_1 = __webpack_require__(10);
var MyProfile = /** @class */ (function (_super) {
    __extends(MyProfile, _super);
    function MyProfile(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        _this.cookies = new react_cookie_1.Cookies();
        _this.state = {
            mobileMenu: false,
            userDropdown: false,
            username: '',
            password: '',
            passwordConfirmation: '',
            listen: true
        };
        socket_init_1.default.Send('flags', {});
        socket_init_1.default.Send('my-profile-select', { username: _this.cookies.get('username') });
        return _this;
    }
    MyProfile.prototype.handleInput = function (value, state) {
        this.state[state] = value;
        this.setState(this.state);
    };
    MyProfile.prototype.updateUser = function () {
        event.preventDefault();
        if (this.state.username === '') {
            alert('Write your Username.');
        }
        else if (this.state.password === '') {
            alert('Write your Password.');
        }
        else {
            var user = {
                username: this.state.username,
                password: this.state.password,
            };
            socket_init_1.default.Send('my-profile-update', { user: user, username: this.cookies.get('username') });
        }
    };
    MyProfile.prototype.componentWillReceiveProps = function () {
        if (this.state.listen) {
            if (socket_init_1.default.Get('my-profile-select').loading === 'loaded') {
                var user = socket_init_1.default.Get('my-profile-select').myProfileSelect;
                this.setState({
                    username: user.username
                });
                this.setState({ listen: false });
            }
        }
    };
    MyProfile.prototype.render = function () {
        var _this = this;
        var user = socket_init_1.default.Get('my-profile-select');
        if (user.loading !== 'loaded') {
            return React.createElement(Loader_1.default, null);
        }
        else {
            var userUpdate = socket_init_1.default.Get('my-profile-update');
            if (userUpdate.myProfileUpdate && userUpdate.myProfileUpdate.id) {
                socket_init_1.default.Set('my-profile-update', {});
                Utils.logout();
                return React.createElement(react_router_dom_1.Redirect, { to: "/login" });
            }
            return (React.createElement("div", null,
                React.createElement("section", { className: "wrapper" },
                    React.createElement("div", { className: "header", role: "banner" },
                        React.createElement("header", { className: "navbar navbar-default", style: { marginBottom: '0' } },
                            React.createElement("div", { className: "container" },
                                React.createElement("div", { className: "navbar-header" },
                                    React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                        React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                        React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                        React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                        React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" })),
                                    React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                        React.createElement("img", { src: Assets.logoMain, alt: "", className: "logo" })),
                                    React.createElement("span", { className: "navbar-toggle user-profile-trigger" }, this.cookies.get('username'))),
                                React.createElement("nav", { className: (this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse', id: "navbar-collapse-left", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' } }, (this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)),
                                React.createElement("nav", { className: "collapse navbar-collapse", id: "user-profile" },
                                    React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                                        React.createElement("li", { className: "user-nav-option" },
                                            React.createElement("div", { className: "user" },
                                                React.createElement("div", { className: "user-info-wrap" },
                                                    " ",
                                                    React.createElement("span", { className: "user-name" }, this.cookies.get('username')),
                                                    React.createElement("div", { className: "balance-info" },
                                                        " Balance",
                                                        React.createElement("span", { className: "text-primary" }, "5,000 \u20AC "),
                                                        React.createElement("a", { href: "javascript:void(0);" },
                                                            React.createElement("i", { className: "icon-plus-circular" })))))),
                                        (this.cookies.get('username')) ?
                                            React.createElement("li", { className: (this.state.userDropdown === true) ? 'dropdown open' : 'dropdown' },
                                                React.createElement("a", { href: "javascript:void(0);", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (this.state.userDropdown) ? 'true' : 'false' },
                                                    React.createElement("i", { className: "icon-menu-dots", onClick: function () { return _this.setState({ userDropdown: !_this.state.userDropdown }); } })),
                                                React.createElement("ul", { className: "dropdown-menu" },
                                                    React.createElement("li", null,
                                                        React.createElement(react_router_dom_1.Link, { to: "/myprofile" },
                                                            React.createElement("i", { className: "icon-profile" }),
                                                            "MY PROFILE")),
                                                    React.createElement("li", { onClick: function () { return Utils.logout(); } },
                                                        React.createElement(react_router_dom_1.Link, { to: "/login" },
                                                            React.createElement("i", { className: "icon-logout" }),
                                                            "LOGOUT"))))
                                            :
                                                null))))),
                    React.createElement("div", { className: "info-ribbon" },
                        React.createElement("div", { className: "container" },
                            React.createElement("div", { className: "h4 text-center" }, "MY PROFILE"))),
                    React.createElement("main", { className: "main" },
                        React.createElement("div", { className: "container" },
                            React.createElement("div", { className: "panel panel-default limited-width" },
                                React.createElement("div", { className: "panel-body" },
                                    React.createElement("div", { className: "profile-pic-wrapper" },
                                        React.createElement("div", { className: "profile-pic" },
                                            React.createElement("div", { className: "panel-profile-pic" },
                                                React.createElement("img", { src: "user-profile.png", alt: "", className: "img-circle" })))),
                                    React.createElement("div", { className: "profile-pic-wrapper-clone" }),
                                    React.createElement("div", { className: "clearfix" }),
                                    React.createElement("h4", { style: { marginBottom: '30px' } },
                                        React.createElement("i", null, "Edit your username or password below")),
                                    React.createElement("form", null,
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-sm-6" },
                                                React.createElement("div", { className: ((userUpdate.myProfileUpdate && userUpdate.myProfileUpdate.usernameError) || (userUpdate.myProfileUpdate && userUpdate.myProfileUpdate.bothError)) ? 'form-group has-error' : 'form-group' },
                                                    React.createElement("span", null, "Username"),
                                                    React.createElement("input", { type: "text", className: "form-control", placeholder: "", value: this.state.username, onChange: function (event) { return _this.handleInput(event.target.value, 'username'); } }),
                                                    React.createElement("span", { className: "error-block" },
                                                        React.createElement("span", null, "Username already exists"))))),
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-sm-6" },
                                                React.createElement("div", { className: "form-group" },
                                                    React.createElement("span", null, "Password"),
                                                    React.createElement("input", { type: "password", className: "form-control", placeholder: "", value: this.state.password, onChange: function (event) { return _this.handleInput(event.target.value, 'password'); } }))),
                                            React.createElement("div", { className: "col-sm-6" },
                                                React.createElement("div", { className: (this.state.password === this.state.passwordConfirmation) ? 'form-group' : 'form-group has-error' },
                                                    React.createElement("span", null, "Confirm Password"),
                                                    React.createElement("input", { type: "password", className: "form-control", placeholder: "", value: this.state.passwordConfirmation, onChange: function (event) { return _this.handleInput(event.target.value, 'passwordConfirmation'); } }),
                                                    React.createElement("span", { className: "error-block" },
                                                        React.createElement("span", null, "Passwords do not match"))))),
                                        React.createElement("div", { className: "row btn-wrapper mT20" },
                                            React.createElement("div", { className: "col-sm-6", style: { float: 'none', margin: '0 auto' } },
                                                React.createElement("a", { className: "btn-primary btn-lg no-shadow btn-block btn", onClick: function () { return _this.updateUser(); } }, "SAVE")))))))))));
        }
    };
    return MyProfile;
}(React.Component));
exports.MyProfile = MyProfile;
react_cookie_1.withCookies(MyProfile);
react_router_dom_1.withRouter(MyProfile);


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var socket_init_1 = __webpack_require__(6);
// import { Main } from '../../../Logic/Main'
// import { Logic } from '../../../Logic/Type'
var Utils = __webpack_require__(9);
var Assets = __webpack_require__(3);
var Body = __webpack_require__(7);
// import * as RouteClasses from '../../../Socket/route-classes'
var react_router_dom_1 = __webpack_require__(5);
var react_cookie_1 = __webpack_require__(4);
var moment = __webpack_require__(19);
var Loader_1 = __webpack_require__(10);
var Results = /** @class */ (function (_super) {
    __extends(Results, _super);
    function Results(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        _this.cookies = new react_cookie_1.Cookies();
        window.onload = function () {
            socket_init_1.default.Send('results', { playerId: _this.props.location.state.playerId, round: _this.props.location.state.resultsRound });
            socket_init_1.default.Send('rounds', { playerId: _this.props.location.state.playerId });
        };
        _this.state = {
            userDropdown: false,
            resultsRound: _this.props.location.state.resultsRound,
            mobileMenu: false,
            roundsDropdown: false,
            chosenRound: 'GAMEWEEK ' + _this.props.location.state.resultsRound.toString(),
            totalCorrectScore: 0,
            popup: false,
            pointsSystem: 0
        };
        return _this;
    }
    Results.prototype.render = function () {
        var _this = this;
        if ((socket_init_1.default.Get('results')).loading !== 'loaded' || socket_init_1.default.Get('rounds').loading !== 'loaded') {
            return React.createElement(Loader_1.default, null);
        }
        else {
            var results = socket_init_1.default.Get('results').results;
            return (React.createElement("section", { className: "wrapper" },
                React.createElement("div", { className: "header", role: "banner" },
                    React.createElement("header", { className: "navbar navbar-default", style: { marginBottom: '0' } },
                        React.createElement("div", { className: "container" },
                            React.createElement("div", { className: "navbar-header" },
                                React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                    React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" }),
                                    React.createElement("span", { style: (this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null, className: "icon-bar" })),
                                React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                    React.createElement("img", { src: Assets.logoMain, alt: "", className: "logo" })),
                                React.createElement("span", { className: "navbar-toggle user-profile-trigger" }, this.cookies.get('username'))),
                            React.createElement("nav", { className: (this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse', id: "navbar-collapse-left", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' } }, (this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)),
                            React.createElement("nav", { className: "collapse navbar-collapse", id: "user-profile" },
                                React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                                    React.createElement("li", { className: "user-nav-option" },
                                        React.createElement("div", { className: "user" },
                                            React.createElement("div", { className: "user-info-wrap" },
                                                " ",
                                                React.createElement("span", { className: "user-name" }, this.cookies.get('username')),
                                                React.createElement("div", { className: "balance-info" },
                                                    " Balance",
                                                    React.createElement("span", { className: "text-primary" }, "5,000 \u20AC "),
                                                    React.createElement("a", { href: "javascript:void(0);" },
                                                        React.createElement("i", { className: "icon-plus-circular" })))))),
                                    (this.cookies.get('username')) ?
                                        React.createElement("li", { className: (this.state.userDropdown === true) ? 'dropdown open' : 'dropdown' },
                                            React.createElement("a", { href: "javascript:void(0);", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": (this.state.userDropdown) ? 'true' : 'false' },
                                                React.createElement("i", { className: "icon-menu-dots", onClick: function () { return _this.setState({ userDropdown: !_this.state.userDropdown }); } })),
                                            React.createElement("ul", { className: "dropdown-menu" },
                                                React.createElement("li", null,
                                                    React.createElement(react_router_dom_1.Link, { to: "/myprofile" },
                                                        React.createElement("i", { className: "icon-profile" }),
                                                        "MY PROFILE")),
                                                React.createElement("li", { onClick: function () { return Utils.logout(); } },
                                                    React.createElement(react_router_dom_1.Link, { to: "/login" },
                                                        React.createElement("i", { className: "icon-logout" }),
                                                        "LOGOUT"))))
                                        :
                                            null))))),
                React.createElement("div", { className: "info-ribbon" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "h4 text-center" }, this.state.chosenRound))),
                React.createElement("main", { className: "main" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "page-header outer-header mTzero h5 results-header" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-sm-4 results-header-30" },
                                    "Name : ",
                                    React.createElement("b", null, results.username)),
                                React.createElement("div", { className: "col-sm-4 results-header-30" },
                                    "Score : ",
                                    React.createElement("b", null, (results.totalCorrectScores + results.totalCorrectScoresBonus + results.correctScoresBonus + results.totalAccumulator + results.accumulatorBonus + results.totalGoalscorers + results.goalscorersBonus).toFixed(2))),
                                React.createElement("div", { className: "col-sm-4 right results-header-40" },
                                    React.createElement("div", { className: "row" },
                                        React.createElement("div", { className: "col-xs-4 leaderboard-round" },
                                            React.createElement("label", { style: { fontWeight: 'normal' } }, "Round")),
                                        React.createElement("div", { className: "col-xs-8" },
                                            React.createElement("span", { onClick: function () { return _this.setState({ roundsDropdown: !_this.state.roundsDropdown }); }, className: (this.state.roundsDropdown) ? 'results-round-selection select2 select2-container select2-container--default select2-container--below select2-container--focus select2-container--open' : 'results-round-selection select2 select2-container select2-container--default select2-container--below select2-container--focus', dir: "ltr" },
                                                React.createElement("span", { className: "selection" },
                                                    React.createElement("span", { className: "select2-selection select2-selection--single", role: "combobox", "aria-haspopup": "true", "aria-expanded": (this.state.roundsDropdown) ? 'true' : 'false', "aria-labelledby": "select2--cy-container", "aria-owns": (this.state.roundsDropdown) ? 'select2--cy-results' : null },
                                                        React.createElement("span", { className: "select2-selection__rendered", id: "select2--cy-container", title: "MD 1" }, this.state.chosenRound),
                                                        React.createElement("span", { className: "select2-selection__arrow", role: "presentation" },
                                                            React.createElement("b", { role: "presentation" })))),
                                                React.createElement("span", { className: "dropdown-wrapper", "aria-hidden": "true" })),
                                            (this.state.roundsDropdown) ?
                                                React.createElement("span", { className: "select2-container select2-container--default select2-container--open" },
                                                    React.createElement("span", { className: "select2-dropdown select2-dropdown--below results-round-selection", style: { display: 'inline-block' }, dir: "ltr" },
                                                        React.createElement("span", { className: "select2-search select2-search--dropdown select2-search--hide" },
                                                            React.createElement("input", { className: "select2-search__field", type: "search", role: "textbox" })),
                                                        React.createElement("span", { className: "select2-results" },
                                                            React.createElement("ul", { className: "select2-results__options", role: "tree", id: "select2--cy-results", "aria-expanded": "true", "aria-hidden": "false" }, this.getRoundsNames()))))
                                                : null))))),
                        React.createElement("div", { className: "stage-view" },
                            React.createElement("div", { className: "stage-view-content" },
                                React.createElement("div", { className: "stage-view-header" },
                                    React.createElement("div", { className: "stage-view-row" },
                                        React.createElement("div", { className: "stage-view-cell stage-view-heading" },
                                            React.createElement("div", { className: "pro" },
                                                React.createElement("div", { className: "relative-wrap" }, "Correct Score"))),
                                        React.createElement("div", { className: "stage-view-cell" }, "Predictions"),
                                        React.createElement("div", { className: "stage-view-cell" }, "Outcome"),
                                        React.createElement("div", { className: "stage-view-cell" }, "1X2 points"),
                                        React.createElement("div", { className: "stage-view-cell" }, "Bonus"))),
                                React.createElement("div", { className: "stage-view-body" }, this.setCorrectScores()),
                                React.createElement("div", { className: "check-points-system", onClick: function () { return _this.setState({ popup: true, pointsSystem: 1 }); } },
                                    React.createElement("img", { src: "info-black.png" }),
                                    React.createElement("i", null, "Check points system"))),
                            React.createElement("div", { className: "stage-view-content" },
                                React.createElement("div", { className: "stage-view-header" },
                                    React.createElement("div", { className: "stage-view-row" },
                                        React.createElement("div", { className: "stage-view-cell stage-view-heading" },
                                            React.createElement("div", { className: "pro" },
                                                React.createElement("div", { className: "relative-wrap" }, "Goal Markets"))),
                                        React.createElement("div", { className: "stage-view-cell" }, "Outcome"),
                                        React.createElement("div", { className: "stage-view-cell" }, "Points"))),
                                React.createElement("div", { className: "stage-view-body" },
                                    this.setAccumulator('Both teams to score'),
                                    this.setAccumulator('Over 2.5 goals'),
                                    this.setAccumulator('Under 2.5 goals'),
                                    this.setAccumulator('Draw'),
                                    React.createElement("div", { className: "stage-view-row acc-odds-padding", style: { background: '#E7E7E7' } },
                                        React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
                                        React.createElement("div", { className: "stage-view-cell acc-odds-padding", "data-span": "Predictions", style: { background: '#FFF' } }, "Accumulator points"),
                                        React.createElement("div", { className: "stage-view-cell accumulated-odds acc-odds-padding", "data-span": "Points" }, results.totalAccumulator.toFixed(2))),
                                    React.createElement("div", { className: "stage-view-row acc-odds-padding", style: { background: '#E7E7E7' } },
                                        React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
                                        React.createElement("div", { className: "stage-view-cell acc-odds-padding", "data-span": "Predictions", style: { background: '#FFF' } }, "Triple bonus"),
                                        React.createElement("div", { className: "stage-view-cell accumulated-odds acc-odds-padding", "data-span": "Points" }, results.accumulatorBonus)),
                                    React.createElement("div", { className: "stage-view-row acc-odds-padding", style: { background: '#E7E7E7' } },
                                        React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
                                        React.createElement("div", { className: "stage-view-cell accumulated-odds-total acc-odds-padding", "data-span": "" }, "Goal markets total"),
                                        React.createElement("div", { className: "stage-view-cell accumulated-odds-total acc-odds-padding", "data-span": "" }, (results.totalAccumulator + results.accumulatorBonus).toFixed(2)))),
                                React.createElement("div", { className: "check-points-system", onClick: function () { return _this.setState({ popup: true, pointsSystem: 2 }); } },
                                    React.createElement("img", { src: "info-black.png" }),
                                    React.createElement("i", null, "Check points system"))),
                            React.createElement("div", { className: "stage-view-content" },
                                React.createElement("div", { className: "stage-view-header" },
                                    React.createElement("div", { className: "stage-view-row" },
                                        React.createElement("div", { className: "stage-view-cell stage-view-heading" },
                                            React.createElement("div", { className: "pro" },
                                                React.createElement("div", { className: "relative-wrap" }, "Goalscorers"))),
                                        React.createElement("div", { className: "stage-view-cell" }, "Outcome"),
                                        React.createElement("div", { className: "stage-view-cell" }, "Points"))),
                                React.createElement("div", { className: "stage-view-body" }, this.setGoalscorers()),
                                React.createElement("div", { className: "check-points-system", onClick: function () { return _this.setState({ popup: true, pointsSystem: 3 }); } },
                                    React.createElement("img", { src: "info-black.png" }),
                                    React.createElement("i", null, "Check points system"))),
                            React.createElement("div", { className: "stage-view-content", style: { marginTop: '50px' } },
                                React.createElement("div", { className: "stage-view-body" },
                                    React.createElement("div", { className: "stage-view-row" },
                                        React.createElement("div", { className: "stage-view-cell total-points" }, "Total"),
                                        React.createElement("div", { className: "stage-view-cell total-points" }, (results.totalCorrectScores + results.totalCorrectScoresBonus + results.correctScoresBonus + results.totalAccumulator + results.accumulatorBonus + results.totalGoalscorers + results.goalscorersBonus).toFixed(2))))))),
                    (this.state.popup) ? this.showPopup() : null)));
        }
    };
    Results.prototype.showPopup = function () {
        var _this = this;
        var screenPosition = document.documentElement.scrollTop + 200;
        var top = screenPosition.toString() + 'px';
        return (React.createElement("div", { className: "popup" },
            React.createElement("div", { className: "popup-inner", style: { top: top } },
                React.createElement("div", { className: "check-points-system-popup" },
                    React.createElement("span", { className: "team-players-name" },
                        React.createElement("b", null, "POINTS SYSTEM")),
                    React.createElement("span", { className: "team-info-close" },
                        React.createElement("img", { src: "cancel.svg", onClick: function () { return _this.setState({ popup: false }); } }))),
                (this.state.pointsSystem === 1) ?
                    React.createElement("div", { className: "check-points-system-third" },
                        React.createElement("h3", null, "Correct scores"),
                        React.createElement("p", null, "There are two parts to the points calculation in the Correct Score predictions..."),
                        React.createElement("p", null, "Part 1 - Correct win/draw/win (1X2) outcome = Earn the 1X2 odds for that selection, as points."),
                        React.createElement("p", null, "Part 2 - Correct score at full time (90mins) = Additional bonus points according to the table below;"),
                        React.createElement("p", null, "Correct score odds 1 \u2192 9.99 | 2 points"),
                        React.createElement("p", null, "Correct score odds 10 \u2192 24.99 | 3 points"),
                        React.createElement("p", null, "Correct score odds 25+ | 5 points"),
                        React.createElement("br", null),
                        React.createElement("p", null, "1X2 points are multiplied together to get the 1X2 Accumulator points."),
                        React.createElement("p", null, "Then, Correct Score bonus points are multiplied and the two totals are added together."),
                        React.createElement("p", null, "A further bonus of 3 points is awarded if the user correctly predicts the win/draw/win (1X2) outcome of all 3 selections. Or, a bonus of 9 points if the user correctly predicts all 3 correct scores!"))
                    : (this.state.pointsSystem === 2) ?
                        React.createElement("div", { className: "check-points-system-third" },
                            React.createElement("h3", null, "Goal markets"),
                            React.createElement("p", null, "User will earn the decimal odds of each correct selection, as points. Points from each correct selection are multiplied together to give a Goal Markets total."),
                            React.createElement("p", null, "A further bonus of 3 points is awarded if the user correctly predicts a goal markets outcome in all 3 selections."))
                        :
                            React.createElement("div", { className: "check-points-system-third" },
                                React.createElement("h3", null, "Goalscorers"),
                                React.createElement("p", null, "User will earn the decimal odds of each correct selection, as points. Points from each correct selection are multiplied together to give a Goalscorers total."),
                                React.createElement("p", null, "A further bonus of 3 points is awarded if all three of the user\u00B4s selections score 1 goal or more.")))));
    };
    Results.prototype.getRoundsNames = function () {
        var _this = this;
        var currentTime = moment().local();
        var rounds = Object.assign(socket_init_1.default.Get('rounds')).rounds;
        var roundsNames = [];
        var _loop_1 = function (i) {
            var utcDeadline = moment.utc(rounds[i].deadline);
            var deadline = moment(utcDeadline).local();
            if (rounds[i].played && currentTime > deadline) {
                roundsNames.push(React.createElement("li", { key: roundsNames.length, className: "select2-results__option", role: "treeitem", "aria-selected": (this_1.state.chosenRound === rounds[i].roundName) ? 'true' : 'false', onClick: function () {
                        _this.changeType(rounds[i].roundId, rounds[i].played),
                            _this.setState({ chosenRound: rounds[i].roundName, roundsDropdown: false });
                    } }, rounds[i].roundName));
            }
        };
        var this_1 = this;
        for (var i = 0; i < rounds.length; i++) {
            _loop_1(i);
        }
        return roundsNames;
    };
    Results.prototype.changeType = function (round, played) {
        this.setState({ resultsRound: round });
        var results = socket_init_1.default.Get('results').results;
        if (played) {
            socket_init_1.default.Send('results', { playerId: results.playerId, round: round });
        }
    };
    Results.prototype.setCorrectScores = function () {
        var scoresReturn = [];
        var scores = socket_init_1.default.Get('results').results;
        for (var _i = 0, _a = scores.correctScores; _i < _a.length; _i++) {
            var score = _a[_i];
            scoresReturn.push(React.createElement("div", { key: scoresReturn.length, className: "stage-view-row" },
                React.createElement("div", { className: "stage-view-cell" },
                    score.homeTeam,
                    " ",
                    React.createElement("small", { className: "text-gray vs" }, "vs"),
                    " ",
                    score.awayTeam),
                React.createElement("div", { className: "stage-view-cell", "data-span": "Predictions" }, score.correctScore.name[0] + '-' + score.correctScore.name[2]),
                React.createElement("div", { className: "stage-view-cell", "data-span": "Outcome" }, (score.result) ? ('(' + score.result[0] + '-' + score.result[2] + ')') : '-'),
                React.createElement("div", { className: "stage-view-cell", "data-span": "1X2 points" }, (typeof +score.result === 'number') ? score.points : '-'),
                React.createElement("div", { className: "stage-view-cell", "data-span": "Bonus" }, (typeof +score.result === 'number') ? score.bonus : '-')));
        }
        scoresReturn.push(React.createElement("div", { key: scoresReturn.length, className: "stage-view-row acc-odds-padding", style: { background: '#E7E7E7' } },
            React.createElement("div", { className: "stage-view-cell acc-odds-padding mobile-hide", style: { borderBottom: '1px solid #E7E7E7' } }),
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { background: '#FFF' } }, "Accumulator points"),
            React.createElement("div", { className: "stage-view-cell accumulated-odds acc-odds-padding mobile-color-green", "data-span": "1X2 points" }, scores.totalCorrectScores.toFixed(2)),
            React.createElement("div", { className: "stage-view-cell accumulated-odds acc-odds-padding mobile-color-green", "data-span": "Bonus" }, scores.totalCorrectScoresBonus)));
        scoresReturn.push(React.createElement("div", { key: scoresReturn.length, className: "stage-view-row acc-odds-padding", style: { background: '#E7E7E7' } },
            React.createElement("div", { className: "stage-view-cell acc-odds-padding mobile-hide", style: { borderBottom: '1px solid #E7E7E7' } }),
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { background: '#FFF' } }, "Triple bonus"),
            React.createElement("div", { className: "stage-view-cell accumulated-odds acc-odds-padding mobile-hide", "data-span": "1X2" }),
            React.createElement("div", { className: "stage-view-cell accumulated-odds acc-odds-padding", "data-span": "Bonus" }, scores.correctScoresBonus)));
        scoresReturn.push(React.createElement("div", { key: scoresReturn.length, className: "stage-view-row acc-odds-padding", style: { background: '#E7E7E7' } },
            React.createElement("div", { className: "stage-view-cell acc-odds-padding mobile-hide", style: { borderBottom: '1px solid #E7E7E7' } }),
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
            React.createElement("div", { className: "stage-view-cell accumulated-odds-total acc-odds-padding" }, "Correct score total"),
            React.createElement("div", { className: "stage-view-cell accumulated-odds-total acc-odds-padding mobile-hide", "data-span": "1X2" }),
            React.createElement("div", { className: "stage-view-cell accumulated-odds-total acc-odds-padding", "data-span": "" }, (scores.totalCorrectScores + scores.totalCorrectScoresBonus + scores.correctScoresBonus).toFixed(2))));
        return scoresReturn;
    };
    Results.prototype.setAccumulator = function (type) {
        var betType = '';
        if (type === 'Both teams to score')
            betType = 'BTTS';
        else if (type === 'Over 2.5 goals')
            betType = 'Over';
        else if (type === 'Under 2.5 goals')
            betType = 'Under';
        else
            betType = 'Draw';
        var accReturn = [];
        var types = socket_init_1.default.Get('results').results.accumulator.filter(function (elt) { return elt.type === betType; });
        if (types.length > 0) {
            accReturn.push(React.createElement("div", { key: accReturn.length, className: "stage-view-row stage-view-row-alt" },
                React.createElement("div", { className: "stage-view-cell" }),
                React.createElement("div", { className: "stage-view-cell-alt stage-view-cell" },
                    React.createElement("span", { "data-span": type }, type)),
                React.createElement("div", { className: "stage-view-cell" })));
            for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
                var res = types_1[_i];
                accReturn.push(React.createElement("div", { key: accReturn.length, className: "stage-view-row" },
                    React.createElement("div", { className: "stage-view-cell" },
                        " ",
                        res.homeTeam + ' / ' + res.awayTeam,
                        " "),
                    React.createElement("div", { className: "stage-view-cell", "data-span": "Outcome" }, (res.result) ? ('(' + res.result[0] + '-' + res.result[2] + ')') : '-'),
                    React.createElement("div", { className: "stage-view-cell", "data-span": "Points" }, (typeof +res.points === 'number') ? res.points : '-')));
            }
        }
        return accReturn;
    };
    Results.prototype.setGoalscorers = function () {
        var goalsReturn = [];
        var scorers = socket_init_1.default.Get('results').results;
        for (var _i = 0, _a = scorers.goalscorers; _i < _a.length; _i++) {
            var score = _a[_i];
            goalsReturn.push(React.createElement("div", { key: goalsReturn.length, className: "stage-view-row" },
                React.createElement("div", { className: "stage-view-cell" },
                    score.correctScore.name + ' (',
                    React.createElement("span", { style: (score.team !== 1) ? { color: '#AAA' } : {} }, score.homeTeam),
                    " ",
                    React.createElement("small", { className: "text-gray vs" }, " vs "),
                    " ",
                    React.createElement("span", { style: (score.team !== 2) ? { color: '#AAA' } : {} }, score.awayTeam),
                    ")"),
                React.createElement("div", { className: "stage-view-cell", "data-span": "Outcome" }, (typeof +score.result === 'number') ? score.result : '-'),
                React.createElement("div", { className: "stage-view-cell", "data-span": "Points" }, (typeof +score.points === 'number') ? score.points : '-')));
        }
        goalsReturn.push(React.createElement("div", { key: goalsReturn.length, className: "stage-view-row acc-odds-padding", style: { background: '#E7E7E7' } },
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", "data-span": "Predictions", style: { background: '#FFF' } }, "Accumulator points"),
            React.createElement("div", { className: "stage-view-cell accumulated-odds acc-odds-padding", "data-span": "Points" }, scorers.totalGoalscorers.toFixed(2))));
        goalsReturn.push(React.createElement("div", { key: goalsReturn.length, className: "stage-view-row acc-odds-padding", style: { background: '#E7E7E7' } },
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", "data-span": "Predictions", style: { background: '#FFF' } }, "Triple bonus"),
            React.createElement("div", { className: "stage-view-cell accumulated-odds acc-odds-padding", "data-span": "Points" }, scorers.goalscorersBonus)));
        goalsReturn.push(React.createElement("div", { key: goalsReturn.length, className: "stage-view-row acc-odds-padding", style: { background: '#E7E7E7' } },
            React.createElement("div", { className: "stage-view-cell acc-odds-padding", style: { borderBottom: '1px solid #E7E7E7' } }),
            React.createElement("div", { className: "stage-view-cell accumulated-odds-total acc-odds-padding", "data-span": "" }, "Goalscorers total"),
            React.createElement("div", { className: "stage-view-cell accumulated-odds-total acc-odds-padding", "data-span": "" }, (scorers.totalGoalscorers + scorers.goalscorersBonus).toFixed(2))));
        return goalsReturn;
    };
    return Results;
}(React.Component));
exports.default = react_cookie_1.withCookies(Results);


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
// import * as ReactDom from 'react-dom'
var socket_init_1 = __webpack_require__(6);
var Assets = __webpack_require__(3);
var Body = __webpack_require__(7);
var react_router_dom_1 = __webpack_require__(5);
var react_cookie_1 = __webpack_require__(4);
var Loader_1 = __webpack_require__(10);
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        var url = _this.props.location.search;
        var hash = _this.getParameterByName('hash', url);
        var forgotPassword = _this.getParameterByName('forgotpassword', url);
        socket_init_1.default.Send('user-confirmation', { hash: hash });
        socket_init_1.default.Send('change-password', { hash: forgotPassword });
        _this.cookies = new react_cookie_1.Cookies();
        var savedUsername = _this.cookies.get('savedUsername');
        var savedPassword = _this.cookies.get('savedPassword');
        _this.state = {
            username: (savedUsername) ? savedUsername : '',
            password: (savedPassword) ? savedPassword : '',
            newPassword: '',
            newPasswordConfirmation: '',
            mobileMenu: false,
            checkbox: false,
            forgotPassword: false,
            userInput: ''
        };
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleSubmitForgot = _this.handleSubmitForgot.bind(_this);
        _this.handleSubmitNewPassword = _this.handleSubmitNewPassword.bind(_this);
        return _this;
    }
    Login.prototype.handleInput = function (value, state) {
        this.state[state] = value;
        this.setState(this.state);
    };
    Login.prototype.handleSubmit = function (event) {
        event.preventDefault();
        if (this.state.username === '') {
            alert('Write your email.');
        }
        else if (this.state.password === '') {
            alert('Write your password.');
        }
        else {
            socket_init_1.default.Send('login', {
                username: this.state.username.toLowerCase(),
                password: this.state.password
            });
        }
    };
    Login.prototype.handleSubmitForgot = function (event) {
        event.preventDefault();
        if (this.state.userInput === '') {
            alert('Write your email.');
        }
        else {
            socket_init_1.default.Send('forgot-password', { userInput: this.state.userInput });
        }
    };
    Login.prototype.handleSubmitNewPassword = function (event) {
        event.preventDefault();
        var userId = socket_init_1.default.Get('change-password').changePassword;
        if (this.state.newPassword === '') {
            alert('Write your password.');
        }
        else {
            socket_init_1.default.Send('change-password', { userId: userId, password: this.state.newPassword });
            socket_init_1.default.Set('forgot-password', {});
            socket_init_1.default.Set('change-password', {});
            return (React.createElement(react_router_dom_1.Redirect, { to: "/login" }));
        }
    };
    Login.prototype.getParameterByName = function (name, url) {
        if (!url)
            url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        var results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };
    Login.prototype.render = function () {
        var _this = this;
        var login = socket_init_1.default.Get('login');
        if (login.login && login.login.id) {
            this.cookies.set('playerId', login.login.id /*, {secure: true}*/);
            this.cookies.set('username', login.login.username /*, {secure: true}*/);
            this.cookies.set('nationality', login.login.nationality /*, {secure: true}*/);
            this.cookies.set('competitionTab', 1 /*, {secure: true}*/);
            var currentDate = new Date();
            var year = currentDate.getFullYear();
            var month = currentDate.getMonth();
            var day = currentDate.getDate();
            var date = new Date(year, month + 1, day);
            if (this.state.checkbox) {
                this.cookies.set('savedUsername', this.state.username, { expires: date });
                this.cookies.set('savedPassword', this.state.password, { expires: date });
            }
            return React.createElement(react_router_dom_1.Redirect, { to: "/lounge" });
        }
        var userConfirmation = socket_init_1.default.Get('user-confirmation');
        var changePassword = socket_init_1.default.Get('change-password');
        if (userConfirmation.loading !== 'loaded' || changePassword.loading !== 'loaded') {
            return React.createElement(Loader_1.default, null);
        }
        else {
            var pathname = this.props.location.pathname;
            var hash = '/login' + this.props.location.search;
            return (React.createElement("section", { className: "wrapper" },
                React.createElement("div", { className: "navigation-main-wrapper" },
                    React.createElement("div", { className: "navigation-main navbar navbar-default", style: { marginBottom: '0' } },
                        React.createElement("div", { className: "container" },
                            React.createElement("div", { className: "row" },
                                React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                    React.createElement("img", { src: "logo-main2.png", alt: "", className: "logo logo-acc" })),
                                React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                    React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                    React.createElement("span", { className: "icon-bar" }),
                                    React.createElement("span", { className: "icon-bar" }),
                                    React.createElement("span", { className: "icon-bar" })),
                                React.createElement("div", { className: "clearfix" }),
                                React.createElement("nav", { className: (this.state.mobileMenu) ? 'collapse navbar-collapse navbar-mid-bar collapse in' : 'collapse navbar-collapse navbar-mid-bar', id: "navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: '220px' } : { height: '1px' } },
                                    Body.getMenu('pull-left', Assets.menuLeft),
                                    (this.state.mobileMenu) ? Body.getMenu('pull-left', Assets.menuRight) : Body.getMenu('pull-right', Assets.menuRight)))))),
                React.createElement("main", { className: "main" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "panel panel-default two-column equal-height-wrapper" },
                            React.createElement("div", { className: "panel-left equal-height-col", style: { padding: '50px 50px 0 50px' } }, (changePassword.changePassword && !changePassword.changePassword.error && !changePassword.changePassword.id) ?
                                React.createElement("div", { className: "form" },
                                    React.createElement("div", { className: "h3" }, "Password change"),
                                    React.createElement("div", { className: "clearfix" }),
                                    React.createElement("form", { onSubmit: this.handleSubmitNewPassword },
                                        React.createElement("div", { className: "form-group" },
                                            React.createElement("span", null, "New password"),
                                            React.createElement("input", { type: "password", className: "form-control", placeholder: "", value: this.state.newPassword, onChange: function (event) { return _this.handleInput(event.target.value, 'newPassword'); } })),
                                        React.createElement("div", { className: (this.state.newPassword !== this.state.newPasswordConfirmation)
                                                ? 'form-group has-error'
                                                : 'form-group', style: { marginBottom: '30px' } },
                                            React.createElement("label", null, "Confirm new password"),
                                            React.createElement("input", { type: "password", className: "form-control", placeholder: "", value: this.state.newPasswordConfirmation, onChange: function (event) { return _this.handleInput(event.target.value, 'newPasswordConfirmation'); } }),
                                            React.createElement("span", { className: "error-block" },
                                                React.createElement("span", null, "Passwords do not match"))),
                                        React.createElement("div", { className: "form-group" },
                                            React.createElement("button", { className: "btn btn-lg btn-block btn-primary no-shadow" }, "CHANGE PASSWORD"))))
                                :
                                    React.createElement("div", { className: "form" },
                                        React.createElement("div", { className: "h3" }, "Login"),
                                        React.createElement("div", { className: "clearfix" }),
                                        React.createElement("form", { onSubmit: this.handleSubmit },
                                            React.createElement("div", { className: (login.login && login.login.error === 'User with this username or email does not exist.')
                                                    ? 'form-group has-error'
                                                    : 'form-group' },
                                                React.createElement("span", null, "Email"),
                                                React.createElement("input", { type: "text", className: "form-control", placeholder: "", value: this.state.username.toLowerCase(), onChange: function (event) { return _this.handleInput(event.target.value, 'username'); } }),
                                                React.createElement("span", { className: "error-block" },
                                                    React.createElement("span", null, "Incorrect email"))),
                                            React.createElement("div", { className: (login.login && login.login.error === 'Password is incorrect.')
                                                    ? 'form-group has-error'
                                                    : 'form-group' },
                                                React.createElement("label", null, "Password"),
                                                React.createElement("input", { type: "password", className: "form-control", placeholder: "", value: this.state.password, onChange: function (event) { return _this.handleInput(event.target.value, 'password'); } }),
                                                React.createElement("span", { className: "error-block" },
                                                    React.createElement("span", null, "Incorrect password"))),
                                            React.createElement("div", { className: "form-group display-block" },
                                                React.createElement("div", { className: "pull-left" },
                                                    React.createElement("span", { className: "checkbox-wrapper" },
                                                        React.createElement("input", { type: "checkbox", name: "remember_me", checked: this.state.checkbox, onClick: function () { return _this.setState({ checkbox: !_this.state.checkbox }); } }),
                                                        React.createElement("span", { className: "checkbox-span" }),
                                                        "Remember me")),
                                                React.createElement("div", { className: "pull-right float-left" },
                                                    React.createElement("a", { className: "btn-link forgot-link", onClick: function () { return _this.setState({ forgotPassword: true }); } }, "Forgot Password?"))),
                                            React.createElement("div", { className: "form-group" },
                                                React.createElement("button", { className: "btn btn-lg btn-block btn-primary no-shadow" }, "LOGIN"))))),
                            React.createElement("div", { className: "panel-right display-table equal-height-col", style: { padding: '60px' } },
                                React.createElement("div", { className: "h3" },
                                    "New to",
                                    React.createElement("br", null),
                                    " The Accumulator Club? Still Need to Create an Account?"),
                                React.createElement("p", null, "Become a valued member of The Accumulator Club for free. It\u2019s a masterpiece of social football gaming, so pull your socks up and get involved!"),
                                React.createElement("div", { className: "table-row" },
                                    React.createElement("div", { className: "vertical-bot text-center" },
                                        React.createElement("div", { className: "h3 margin-zero" },
                                            React.createElement(react_router_dom_1.Link, { to: "/signup", className: "btn-link" }, "SIGN UP HERE"))))))),
                    (this.state.forgotPassword) ? this.showPopupForgot() : null,
                    (login.login && login.login.error === 'Not confirmed yet.') ? this.showPopupConfirm() : null,
                    (pathname !== hash) ? this.showPopup() : null)));
        }
    };
    Login.prototype.showPopupForgot = function () {
        var _this = this;
        var forgotPassword = socket_init_1.default.Get('forgot-password');
        var screenPosition = document.documentElement.scrollTop + 150;
        var top = screenPosition.toString() + 'px';
        return (React.createElement("div", { className: "popup" },
            React.createElement("div", { className: "popup-inner popup-forgot", style: { top: top } },
                React.createElement("div", { style: { textAlign: 'right' } },
                    React.createElement("img", { src: "cancel-black.png", style: { cursor: 'pointer' }, onClick: function () { socket_init_1.default.Set('forgot-password', {}), _this.setState({ forgotPassword: false, userInput: '' }); } })),
                (forgotPassword.forgotPassword && forgotPassword.forgotPassword.success) ?
                    React.createElement("h4", null, "Please check your email. We have sent you instructions for setting new password.")
                    :
                        React.createElement("div", null,
                            React.createElement("h4", null, "Please enter your email. We will send you instructions for setting a new one."),
                            React.createElement("form", { onSubmit: this.handleSubmitForgot },
                                React.createElement("div", { className: (forgotPassword.forgotPassword && forgotPassword.forgotPassword.error) ? 'form-group has-error' : 'form-group' },
                                    React.createElement("span", null, "Email"),
                                    React.createElement("input", { type: "text", className: "form-control", placeholder: "", value: this.state.userInput, onChange: function (event) { return _this.handleInput(event.target.value, 'userInput'); } }),
                                    React.createElement("span", { className: "error-block" },
                                        React.createElement("span", null, "Please enter valid email"))),
                                React.createElement("div", { className: "form-group" },
                                    React.createElement("button", { className: "btn btn-lg btn-block btn-primary no-shadow" }, "SEND")))))));
    };
    Login.prototype.showPopup = function () {
        var userConfirmation = socket_init_1.default.Get('user-confirmation');
        var screenPosition = document.documentElement.scrollTop + 150;
        var top = screenPosition.toString() + 'px';
        if (!userConfirmation.userConfirmation.error) {
            return (React.createElement("div", { className: "popup" },
                React.createElement("div", { className: "popup-inner popup-forgot", style: { top: top } },
                    React.createElement("div", { className: "fist-bump" },
                        React.createElement("img", { src: "fist-bump.svg" })),
                    React.createElement("p", { className: "congratulations-second" }, "Verified!"),
                    React.createElement("p", { className: "congratulations-third" }, "Thank you for confirming your email address is present and correct - You can now login and get involved!"),
                    React.createElement(react_router_dom_1.Link, { to: "/login", className: "btn btn-lg btn-block btn-primary no-shadow" }, "LOGIN"))));
        }
        else {
            return React.createElement(react_router_dom_1.Redirect, { to: "/login" });
        }
    };
    Login.prototype.showPopupConfirm = function () {
        var screenPosition = document.documentElement.scrollTop + 150;
        var top = screenPosition.toString() + 'px';
        return (React.createElement("div", { className: "popup" },
            React.createElement("div", { className: "popup-inner popup-forgot", style: { top: top } },
                React.createElement("div", { style: { textAlign: 'right', marginBottom: '10px' } },
                    React.createElement("img", { onClick: function () { return socket_init_1.default.Set('login', {}); }, style: { cursor: 'pointer' }, src: "cancel-black.png" })),
                React.createElement("p", { className: "congratulations-third" }, "Not quite,"),
                React.createElement("p", { className: "congratulations-third" }, "We need you to verify your email address before we can get you in the game!"),
                React.createElement("p", { className: "congratulations-third" }, "We sent an email with a verification link to the address you indicated. Please check your inbox, and your spam folder in case it was filtered there.\""))));
    };
    return Login;
}(React.Component));
exports.default = react_cookie_1.withCookies(Login);


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
// import * as ReactDom from 'react-dom'
// import { Main } from '../../../Logic/Main'
// import { Logic } from '../../../Logic/Type'
var socket_init_1 = __webpack_require__(6);
var Assets = __webpack_require__(3);
var Body = __webpack_require__(7);
var react_router_dom_1 = __webpack_require__(5);
var SignUp = /** @class */ (function (_super) {
    __extends(SignUp, _super);
    function SignUp(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        window.onload = function () {
            socket_init_1.default.Send('flags', {});
        };
        _this.state = _this.getInitialState();
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        socket_init_1.default.Send('flags', {});
        return _this;
    }
    SignUp.prototype.getInitialState = function () {
        return {
            email: '',
            username: '',
            password: '',
            passwordConfirmation: '',
            mobileMenu: false,
            checkbox: false,
            subscription: false
        };
    };
    SignUp.prototype.handleInput = function (value, state) {
        this.state[state] = value;
        this.setState(this.state);
    };
    SignUp.prototype.handleSubmit = function (event) {
        event.preventDefault();
        if (this.state.email === '') {
            alert('Write your Email.');
        }
        else if (this.state.username === '') {
            alert('Write your Username.');
        }
        else if (this.state.password === '') {
            alert('Write your Password.');
        }
        else if (!this.state.checkbox) {
            alert('You have to agree to the Accumulator Club Terms of Service.');
        }
        else {
            if (this.state.password === this.state.passwordConfirmation) {
                var user = {
                    firstName: '',
                    lastName: '',
                    email: this.state.email,
                    username: this.state.username,
                    password: this.state.password,
                    nationality: '',
                    subscription: this.state.subscription
                };
                socket_init_1.default.Send('registration', user);
            }
        }
    };
    SignUp.prototype.componentWillUnmount = function () {
        socket_init_1.default.Set('registration', {});
    };
    SignUp.prototype.render = function () {
        var _this = this;
        var registration = socket_init_1.default.Get('registration');
        return (React.createElement("section", { className: "wrapper" },
            React.createElement("div", { className: "navigation-main-wrapper" },
                React.createElement("div", { className: "navigation-main navbar navbar-default", style: { marginBottom: '0' } },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "row" },
                            React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                React.createElement("img", { src: "logo-main2.png", alt: "", className: "logo logo-acc" })),
                            React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                React.createElement("span", { className: "icon-bar" }),
                                React.createElement("span", { className: "icon-bar" }),
                                React.createElement("span", { className: "icon-bar" })),
                            React.createElement("div", { className: "clearfix" }),
                            React.createElement("nav", { className: (this.state.mobileMenu) ? 'collapse navbar-collapse navbar-mid-bar collapse in' : 'collapse navbar-collapse navbar-mid-bar', id: "navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: '220px' } : { height: '1px' } },
                                Body.getMenu('pull-left', Assets.menuLeft),
                                (this.state.mobileMenu) ? Body.getMenu('pull-left', Assets.menuRight) : Body.getMenu('pull-right', Assets.menuRight)))))),
            React.createElement("main", { className: "main" },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "panel panel-default two-column equal-height-wrapper" },
                        React.createElement("div", { className: "panel-left equal-height-col" },
                            React.createElement("div", { className: "form form-signup" },
                                React.createElement("div", { className: "h3" },
                                    "Sign Up",
                                    React.createElement("span", { className: "text-right text-small" }, "\u2033All fields are mandatory\u2033")),
                                React.createElement("div", { className: "clearfix" }),
                                React.createElement("form", { onSubmit: this.handleSubmit },
                                    React.createElement("div", { className: "row" },
                                        React.createElement("div", { className: "col-sm-6" },
                                            React.createElement("div", { className: (registration.registration && (registration.registration.message === 'Email already exists.' || registration.registration.message === 'Both already exist.')) ? 'form-group has-error' : 'form-group' },
                                                React.createElement("span", null, "Email"),
                                                React.createElement("input", { type: "email", className: "form-control", placeholder: "", value: this.state.email, onChange: function (event) { return _this.handleInput(event.target.value, 'email'); } }),
                                                React.createElement("span", { className: "error-block" },
                                                    React.createElement("span", null, "Email already exists")))),
                                        React.createElement("div", { className: "col-sm-6" },
                                            React.createElement("div", { className: (registration.registration && (registration.registration.message === 'Username already exists.' || registration.registration.message === 'Both already exist.')) ? 'form-group has-error' : 'form-group' },
                                                React.createElement("span", null, "Username"),
                                                React.createElement("input", { type: "text", className: "form-control", placeholder: "", value: this.state.username, onChange: function (event) { return _this.handleInput(event.target.value, 'username'); } }),
                                                React.createElement("span", { className: "error-block" },
                                                    React.createElement("span", null, "Username already exists"))))),
                                    React.createElement("div", { className: "row" },
                                        React.createElement("div", { className: "col-sm-6" },
                                            React.createElement("div", { className: "form-group" },
                                                React.createElement("span", null, "Password"),
                                                React.createElement("input", { type: "password", className: "form-control", placeholder: "", value: this.state.password, onChange: function (event) { return _this.handleInput(event.target.value, 'password'); } }))),
                                        React.createElement("div", { className: "col-sm-6" },
                                            React.createElement("div", { className: (this.state.password === this.state.passwordConfirmation) ? 'form-group' : 'form-group has-error' },
                                                React.createElement("span", null, "Confirm Password"),
                                                React.createElement("input", { type: "password", className: "form-control", placeholder: "", value: this.state.passwordConfirmation, onChange: function (event) { return _this.handleInput(event.target.value, 'passwordConfirmation'); } }),
                                                React.createElement("span", { className: "error-block" },
                                                    React.createElement("span", null, "Passwords do not match"))))),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("label", { className: "checkbox-wrapper" },
                                            React.createElement("input", { type: "checkbox", checked: this.state.checkbox, onClick: function () { return _this.setState({ checkbox: !_this.state.checkbox }); } }),
                                            React.createElement("span", { className: "checkbox-span" }),
                                            "I Agree to the Accumulator Club",
                                            React.createElement(react_router_dom_1.Link, { to: "/termsandconditions", className: "btn-link" }, " Terms of Service "),
                                            "and",
                                            React.createElement(react_router_dom_1.Link, { to: "/privacypolicy", className: "btn-link" }, " Privacy Policy. "),
                                            "I also confirm that I am at least 18 years of age."),
                                        React.createElement("span", { className: "error-block" },
                                            React.createElement("span", null, "Error message"))),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("label", { className: "checkbox-wrapper" },
                                            React.createElement("input", { type: "checkbox", checked: this.state.subscription, onClick: function () { return _this.setState({ subscription: !_this.state.subscription }); } }),
                                            React.createElement("span", { className: "checkbox-span" }),
                                            "I would like to receive game updates, reminders and tips from The Accumulator Club (once a week).")),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("button", { className: "btn btn-lg btn-block btn-primary no-shadow" }, "SIGNUP"))))),
                        React.createElement("div", { className: "panel-right display-table equal-height-col" },
                            React.createElement("div", { className: "h3" }, "Get involved! Sign up here..."),
                            React.createElement("p", null,
                                "Create your account and become a valued member of The Accumulator Club by completing the fields to the left. You will receive an email to validate your account and then you can enjoy this gaming revolution!",
                                React.createElement("br", null),
                                React.createElement("br", null),
                                "Thank you for joining The Accumulator Club."),
                            React.createElement("div", { className: "table-row" },
                                React.createElement("div", { className: "vertical-bot" },
                                    "Already a member? ",
                                    React.createElement(react_router_dom_1.Link, { to: "/login", className: "btn-link" }, "Login here")))))),
                (registration.registration && registration.registration.message === 'Registration successful.') ? this.showPopup() : null)));
    };
    SignUp.prototype.showPopup = function () {
        var _this = this;
        var screenPosition = document.documentElement.scrollTop + 150;
        var top = screenPosition.toString() + 'px';
        return (React.createElement("div", { className: "popup" },
            React.createElement("div", { className: "popup-inner popup-forgot", style: { top: top } },
                React.createElement("div", { style: { textAlign: 'right', marginBottom: '10px' } },
                    React.createElement("img", { onClick: function () { socket_init_1.default.Set('registration', {}), _this.setState(_this.getInitialState()); }, style: { cursor: 'pointer' }, src: "cancel-black.png" })),
                React.createElement("div", { className: "fist-bump" },
                    React.createElement("img", { src: "fist-bump.svg" })),
                React.createElement("p", { className: "congratulations-first" }, "Well played!"),
                React.createElement("p", { className: "congratulations-second" }, "Your sign up has been received..."),
                React.createElement("p", { className: "congratulations-third" }, "Please check your email inbox (and perhaps your spam) - We have sent you an email with a link to verify your email address."))));
    };
    return SignUp;
}(React.Component));
exports.default = SignUp;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Assets = __webpack_require__(3);
var Body = __webpack_require__(7);
var react_router_dom_1 = __webpack_require__(5);
var react_cookie_1 = __webpack_require__(4);
var socket_init_1 = __webpack_require__(6);
var Loader_1 = __webpack_require__(10);
var Unsubscribe = /** @class */ (function (_super) {
    __extends(Unsubscribe, _super);
    function Unsubscribe(props) {
        var _this = _super.call(this, props) || this;
        window.scroll(0, 0);
        _this.state = {
            mobileMenu: false,
            popup: true
        };
        return _this;
    }
    Unsubscribe.prototype.getParameterByName = function (name, url) {
        if (!url)
            url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        var results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };
    Unsubscribe.prototype.showPopup = function (hash) {
        var _this = this;
        var screenPosition = document.documentElement.scrollTop + 150;
        var top = screenPosition.toString() + 'px';
        return (React.createElement("div", { className: "popup" },
            React.createElement("div", { className: "popup-inner popup-unsubscribe", style: { top: top } },
                React.createElement("h3", { className: "h3", style: { textAlign: 'center', marginBottom: '30px' } }, "You will no longer receive game updates, reminders and tips from The Accumulator Club - Are you sure you want to unsubscribe?"),
                React.createElement("div", { className: "form-group", style: { display: 'inline-block', verticalAlign: 'top', width: '30%', marginLeft: '15%', marginRight: '5%' } },
                    React.createElement("button", { className: "btn btn-lg btn-block btn-primary no-shadow", onClick: function () {
                            socket_init_1.default.Send('unsubscribe', { hash: hash });
                            _this.setState({ popup: false });
                        } }, "YES")),
                React.createElement("div", { className: "form-group", style: { display: 'inline-block', verticalAlign: 'top', width: '30%', marginLeft: '5%', marginRight: '15%' } },
                    React.createElement("button", { className: "btn btn-lg btn-block btn-primary no-shadow" },
                        React.createElement(react_router_dom_1.Link, { to: "/lounge", style: { display: 'block', width: '100%', height: '100%', color: '#FFF', textDecoration: 'none' } }, "NO"))))));
    };
    Unsubscribe.prototype.render = function () {
        var _this = this;
        var hash = this.getParameterByName('hash', window.location.search);
        var unsubscribe = socket_init_1.default.Get('unsubscribe');
        if (!this.state.popup && unsubscribe.loading !== 'loaded') {
            return React.createElement(Loader_1.default, null);
        }
        else {
            return (React.createElement("section", { className: "wrapper" },
                React.createElement("div", { className: "navigation-main-wrapper" },
                    React.createElement("div", { className: "navigation-main navbar navbar-default", style: { marginBottom: '0' } },
                        React.createElement("div", { className: "container" },
                            React.createElement("div", { className: "row" },
                                React.createElement(react_router_dom_1.Link, { className: "navbar-brand", to: "/" },
                                    React.createElement("img", { src: "logo-main2.png", alt: "", className: "logo logo-acc" })),
                                React.createElement("button", { onClick: function () { return _this.setState({ mobileMenu: !_this.state.mobileMenu }); }, type: "button", className: (this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed', "data-toggle": "collapse", "data-target": "#navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false' },
                                    React.createElement("span", { className: "sr-only" }, "Toggle navigation"),
                                    React.createElement("span", { className: "icon-bar" }),
                                    React.createElement("span", { className: "icon-bar" }),
                                    React.createElement("span", { className: "icon-bar" })),
                                React.createElement("div", { className: "clearfix" }),
                                React.createElement("nav", { className: (this.state.mobileMenu) ? 'collapse navbar-collapse navbar-mid-bar collapse in' : 'collapse navbar-collapse navbar-mid-bar', id: "navbar-collapse-mid", "aria-expanded": (this.state.mobileMenu) ? 'true' : 'false', style: (this.state.mobileMenu) ? { height: '220px' } : { height: '1px' } },
                                    Body.getMenu('pull-left', Assets.menuLeft),
                                    (this.state.mobileMenu) ? Body.getMenu('pull-left', Assets.menuRight) : Body.getMenu('pull-right', Assets.menuRight)))))),
                React.createElement("main", { className: "main" },
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "panel panel-default two-column equal-height-wrapper" },
                            React.createElement("div", { className: "panel-left equal-height-col", style: { padding: '50px' } },
                                React.createElement("span", { style: { color: 'rgb(41, 160, 0)', fontSize: '20px' } }, (unsubscribe.unsubscribe && unsubscribe.unsubscribe.message) ?
                                    'You have been unsubscribed from our mailing list.'
                                    : (unsubscribe.unsubscribe && unsubscribe.unsubscribe.error) ?
                                        'Your link for cancelling subscription is not valid.'
                                        :
                                            '')))),
                    (hash && this.state.popup) ? this.showPopup(hash) : null)));
        }
    };
    return Unsubscribe;
}(React.Component));
exports.default = react_cookie_1.withCookies(Unsubscribe);


/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.86aa14dc.js